// GENERATED BY https://github.com/5app/translations

export default {
	'loading': 'Loading…',
	'loading_too_slow': 'Slower than usual, try reloading the page. Contact support if the issue persists.',
	'loading_video': 'Loading video…',
	'navbar_home': 'Home',
	'navbar_browse': 'Browse',
	'navbar_profile': 'Profile',
	'navbar_trending': 'Trending',
	'navbar_search': 'Search',
	'navbar_user_settings': 'User settings',
	'navbar_inbox': 'Your inbox',
	'navbar_contact': 'Contact us',
	'navbar_admin': 'Admin dashboard',
	'navbar_my_teams': 'My teams',
	'navbar_my_team_member': 'My team member',
	'navbar_users': 'Users',
	'navbar_nudges': 'Nudges',
	'navbar_asset_library': 'Asset library',
	'navbar_tools': 'Tools',
	'navbar_email_template_editor': 'Email template editor',
	'navbar_content_status_editor': 'Content status editor',
	'navbar_admin_roles_editor': 'Admin roles editor',
	'navbar_logs': 'Logs',
	'navbar_platform_announcements': 'Platform announcements',
	'navbar_access_keys_editor': 'Access keys editor',
	'navbar_skills': 'Skills',
	'navbar_skills_analytics': 'Skills analytics',
	'navbar_my_skills': 'My skills',
	'menu_advanced_settings': 'Advanced settings',
	'menu_general_settings': 'General settings',
	'menu_event_settings': 'Event settings',
	'menu_session_details': 'Session details',
	'main_navigation': 'Main',
	'secondary_navigation': 'More links',
	'settings_nav_general': 'General',
	'settings_nav_email': 'Email',
	'settings_nav_login': 'Login',
	'settings_nav_user_import': 'User import',
	'settings_nav_permissions': 'Permissions',
	'settings_nav_links_and_forms': 'Links & forms',
	'settings_nav_feature_flags': 'Feature flags',
	'settings_nav_admin_roles': 'Admin roles',
	'settings_nav_developer': 'Developer',
	'settings_nav_homepage': 'Homepage',
	'settings_homepage_display_type_for_topics': 'Display type for topics on homepage',
	'settings_homepage_upcoming_timeline_days': 'Upcoming timeline in days',
	'settings_homepage_customise_sections': 'Customise sections on homepage',
	'settings_homepage_included_sections': 'Included on homepage',
	'settings_homepage_excluded_sections': 'Not included on homepage',
	'settings_homepage_remove_section': 'Remove from homepage',
	'settings_homepage_add_section': 'Add to homepage',
	'settings_homepage_reset_sections_modal_title': 'Reset homepage sections',
	'settings_homepage_reset_sections_modal_message': 'Disabling customisation will reset the section order and selection to the default.',
	'settings_homepage_reset_sections_confirm_button': 'Reset',
	'to_do_title': 'To do',
	'upcoming_title': 'Upcoming',
	'saved_for_later_title': 'Saved for later',
	'badges_title': 'Badges',
	'history_title': 'History',
	'my_learning_saved_playlists': 'Your saved playlists',
	'my_learning_saved_playlists_empty': 'You have not saved any playlists yet.',
	'my_learning_completed_playlists_empty': 'You have not completed any playlists yet.',
	'my_learning_saved_assets_title': 'Your saved assets',
	'my_learning_saved_assets_empty': 'You have not saved any assets yet.',
	'my_learning_completed_assets_empty': 'You have not completed any assets yet.',
	'my_learning_opened_assets_empty': 'You have not started any assets yet.',
	'my_learning_recommendations_title': 'Recommendations',
	'my_learning_browse_cta_title': 'Looking for more exciting content?',
	'my_learning_browse_cta_content': 'Visit the Browse page to explore all available playlists',
	'my_learning_empty_title': 'Looks like you have not started any playlists yet.',
	'my_learning_empty_content': 'Playlists that you have made some progress in will appear here.',
	'my_learning_view_all': 'View all',
	'trending_title': 'Trending',
	'trending_most_opened': 'Most opened',
	'trending_highest_rated': 'Highest rated',
	'recently_added_title': 'Recently added',
	'recently_viewed_title': 'Recently viewed',
	'you_might_like_title': 'You might like',
	'featured_content_title': 'Featured for you',
	'featured_on_homepage': 'Featured on homepage',
	'saved_for_later_confirmation': 'Successfully saved asset',
	'saved_for_later_delete_confirmation': 'Successfully removed asset from saved',
	'complete_profile_title': 'Please complete your profile',
	'complete_profile_message': 'Before you get started, please fill in your profile to get the most out of your Digital Hub.',
	'add_to_homescreen_banner_title': 'Add {{pageTitle}} to your homescreen',
	'add_to_homescreen_ios_instructions': 'Install {{pageTitle}} on your {{device}}: Tap <0>the \'Share\' icon</0> and then \'Add to Home Screen\'',
	'search_results_title': 'Search results',
	'search_results_title_with_term': 'Results for "{{searchInput}}"',
	'search_results_view_all': 'View all results for "{{searchInput}}"',
	'search_results_empty': 'No results.',
	'search_results_need_help_question': 'Can’t find what you’re looking for?',
	'search_results_try_tags': 'Try searching by tag:',
	'no_search_suggestions_found': 'No search suggestions available.',
	'no_suggestions_found': 'No suggestions available',
	'search_navigation_available_suggestions': '{{count}} suggestion available. Use up and down arrow keys to navigate. Press Enter key to select.',
	'search_navigation_available_suggestions_plural': '{{count}} suggestions available. Use up and down arrow keys to navigate. Press Enter key to select.',
	'search_top_result_summary': 'Top result summary',
	'search_results_within_info': 'Navigate to point within the document (or video) which contains the search term',
	'profile_name_empty_cta': 'Welcome to your profile!',
	'hours_of_learning': 'Hours of content',
	'playlist_progress': '{{completedAssets}} of {{count}} asset completed',
	'playlist_progress_plural': '{{completedAssets}} of {{count}} assets completed',
	'playlist_item_count': '{{count}} item',
	'playlist_item_count_plural': '{{count}} items',
	'playlist_duration': 'duration',
	'playlist_percentage_done': 'done',
	'learning_progress_you_have_completed': 'You have completed',
	'learning_progress_headline': 'Learning progress',
	'share_title': 'Share \'{{name}}\'',
	'share_recipients': 'Share with',
	'share_recipients_instructions': 'Search for other users by their name or email address.',
	'share_no_users_found': 'Couldn’t find matching users',
	'share_empty': 'One or more of these teams have no members to share with.',
	'share_missing_recipients': 'Please enter at least one valid recipient',
	'shared_with_you': 'Shared with you',
	'shared_by': 'Shared by {{name}}',
	'shared_by_multiple': 'Shared by {{name}} and one other user',
	'shared_by_multiple_plural': 'Shared by {{name}} and {{count}} other users',
	'share_hint_admin_audience': 'This content is only visible for admins and can only be shared with these.',
	'share_hint_select_teams': 'Select one or more teams to enable sharing.',
	'ai_summary_generating': 'Generating summary…',
	'ai_summary_generated_info': 'Summary generated by AI',
	'ai_summary_error': 'Summary could not be generated',
	'ai_summary_available': 'AI summary available.',
	'state_shared': 'Shared',
	'state_active': 'Active',
	'state_mixed': 'Mixed',
	'state_all': 'All',
	'state_everyone': 'Everyone',
	'state_everyone_with_access': 'Everyone with access',
	'state_everyone_in_audience': 'Everyone in audience',
	'state_people_with_changed_status': 'Only people whose status has changed',
	'state_selected_teams': 'Selected teams',
	'state_selected_teams_hellip': 'Selected teams…',
	'state_teams_or_everyone': 'Teams or everyone',
	'state_individual_users': 'Individual user(s)',
	'state_individual_members': 'Individual members',
	'state_current_team_members': 'Current team members',
	'state_team_members': 'Team members',
	'state_do_not_share': 'Do not share',
	'state_only_admins': 'Only admins',
	'state_not_invited': 'Not Invited',
	'state_invited': 'Invited',
	'state_enabled': 'Enabled',
	'state_disabled': 'Disabled',
	'state_disabled_with_brackets': '(disabled)',
	'state_required_no_file_preview': 'Required (no file preview)',
	'state_added_today': 'Added today',
	'state_just_added': 'Just added',
	'state_deleted': 'Deleted',
	'state_no_changes_since_your_last_edit': 'No changes since your last edit',
	'state_no_changes_since_last_save': 'No changes since the last save',
	'state_unsaved_changes': 'There are unsaved changes',
	'state_number_of_unsaved_changes': '1 unsaved change',
	'state_number_of_unsaved_changes_plural': '{{count}} unsaved changes',
	'state_opened': 'Opened',
	'state_completed': 'Completed',
	'state_open_content': 'Open content',
	'state_complete_content': 'Complete content',
	'state_fixed': 'Fixed',
	'state_relative': 'Relative',
	'state_relative_to_target_date': 'Relative to target date',
	'state_greyed_out_brackets': '(Greyed out)',
	'state_complete': 'Complete',
	'state_incomplete': 'Incomplete',
	'state_incomplete_brackets': '(Incomplete)',
	'state_distributed': 'Distributed',
	'state_any': 'Any',
	'state_none_utc': 'None (UTC)',
	'state_achieved': 'Achieved',
	'state_unachieved': 'Unachieved',
	'state_achieved_all': 'All achieved',
	'state_achieved_on_time': 'Achieved (on time)',
	'state_achieved_late': 'Achieved (late)',
	'state_unachieved_all': 'All unachieved',
	'state_unachieved_within_time': 'Unachieved (within time)',
	'state_unachieved_late': 'Unachieved (late)',
	'state_approaching_renewal': 'Approaching renewal',
	'state_overdue': 'Overdue',
	'state_due_on_date': 'Due {{date}}',
	'state_due_today': 'Due today',
	'state_due_tomorrow': 'Due tomorrow',
	'state_due_days_ago': 'Due yesterday',
	'state_due_days_ago_plural': 'Due {{count}} days ago',
	'state_due_to_be_completed_on_date': 'Due to be completed on {{date}}',
	'state_due_to_be_opened_on_date': 'Due to be opened on {{date}}',
	'state_with_due_date': 'With due date',
	'state_event_on_date': 'Event {{date}}',
	'state_event_today': 'Event today',
	'state_event_tomorrow': 'Event tomorrow',
	'state_outstanding': 'Outstanding',
	'state_target_on_date': 'Target {{date}}',
	'state_shared_on_date': 'Shared on {{date}}',
	'state_pinned_on_browse': 'Pinned on browse',
	'state_pinned_in_topic': 'Pinned in topic',
	'state_a_z': 'A-Z',
	'state_read_brackets': '(read)',
	'state_no_one': 'No one',
	'state_all_team_type_teams': 'All {{teamType}} teams',
	'state_google_calendar_connected': 'Google calendar connected',
	'state_microsoft_calendar_connected': 'Microsoft calendar connected',
	'state_google_calendar_deauthorised': 'Google calendar de-authorised',
	'state_microsoft_calendar_deauthorised': 'Microsoft calendar de-authorised',
	'state_booked': 'Booked',
	'state_cancelled': 'Cancelled',
	'state_attended': 'Attended',
	'state_no_show': 'No show',
	'state_not_booked': 'Not booked',
	'view': 'View',
	'profile_upload_avatar': 'Upload photo',
	'profile_remove_avatar': 'Remove photo',
	'profile_first_name': 'First name',
	'profile_last_name': 'Last name',
	'profile_edit_back_button': 'Back to profile',
	'profile_file_type_warning': 'Supported file extensions: png, jpeg, jpg.',
	'profile_choose_language': 'Choose Language',
	'profile_settings_autosubscription': 'Automatically subscribe to receive comment notifications when leaving a comment',
	'profile_settings_notifications': 'Notifications',
	'profile_settings_comment_subscriptions': 'Comment subscriptions',
	'profile_settings_notifications_channel': 'Receive notifications via',
	'profile_settings_notifications_channel_all': 'Both email and MS Teams',
	'profile_settings_notifications_channel_email': 'Email',
	'profile_settings_notifications_channel_ms_teams': 'MS Teams',
	'profile_settings_unsubscribe_comment_subscriptions': 'Unsubscribe from all current comment subscriptions',
	'profile_avatar_uploading_alert_title': 'Uploading new photo',
	'profile_avatar_updated_alert_title': 'Photo uploaded',
	'profile_avatar_removed_alert_title': 'Photo removed',
	'profile_avatar_removal_error_alert_title': 'Photo removal error',
	'comments_title': 'Comments',
	'comment_count': '1 comment',
	'comment_count_plural': '{{count}} comments',
	'comment_form_label': 'Write a comment',
	'comments_receive_notifications_label': 'Receive comment notifications',
	'comments_more_replies': 'More replies',
	'comments_more_comments': 'More comments',
	'deleted_comment_title': 'Deleted comment',
	'deleted_comment_content': 'This comment was deleted',
	'single_comment_title': 'Comment by {{author}}',
	'single_comment_by_you_title': 'Comment by you',
	'single_comment_reply_title': 'Reply by {{author}}',
	'single_comment_reply_by_you_title': 'Your reply',
	'reply_to_comment': 'Reply to {{name}}',
	'delete_comment_are_you_sure': 'Are you sure you want to delete this comment? This can’t be undone.',
	'you_have_commented': 'You have commented on this',
	'language_auto': 'Auto',
	'language_de_de': 'German (Du)',
	'language_de_de_sie': 'German (Sie)',
	'language_zh_cn': 'Chinese',
	'language_zh_tw': 'Chinese (Traditional)',
	'actions': 'Actions',
	'actions_logout': 'Log out',
	'actions_unknown': 'Unknown action',
	'actions_add_user_teams': 'Add user teams',
	'actions_add_members': 'Add members',
	'actions_send_invitation': 'Send invitation',
	'actions_send_reminder': 'Send reminder',
	'actions_send_request': 'Send request',
	'actions_edit': 'Edit',
	'actions_edit_content': 'Edit {{content}}',
	'actions_edit_comment': 'Edit comment',
	'actions_edit_badge': 'Edit badge',
	'actions_edit_badge_image': 'Edit badge image',
	'actions_edit_topics': 'Edit topics',
	'actions_edit_timezone': 'Edit time zone',
	'actions_edit_team_type': 'Edit team type',
	'actions_edit_user_teams': 'Edit user teams',
	'actions_edit_teams': 'Edit teams',
	'actions_edit_users': 'Edit members',
	'actions_edit_individuals': 'Edit individuals',
	'actions_edit_field': 'Edit field',
	'actions_edit_template': 'Edit template',
	'actions_edit_nudge': 'Edit nudge',
	'actions_edit_details': 'Edit details',
	'actions_add_hubs': 'Add hubs',
	'actions_edit_hubs': 'Edit hubs',
	'actions_edit_scorm_settings': 'Edit SCORM settings',
	'actions_edit_skill': 'Edit skill',
	'actions_edit_skill_set': 'Edit skill set',
	'actions_select_hubs': 'Select hubs',
	'actions_add_section': 'Add section',
	'actions_add_section_to': 'Add section to {{name}}',
	'actions_add_subsection': 'Add subsection',
	'actions_add_subsection_to': 'Add subsection to {{name}}',
	'actions_add_section_above': 'Add section above {{name}}',
	'actions_add_subsection_above': 'Add subsection above {{name}}',
	'actions_add_set': 'Add set',
	'actions_add_to_sets': 'Add to sets',
	'actions_edit_section': 'Edit section',
	'actions_edit_subsection': 'Edit subsection',
	'actions_edit_subtitles': 'Edit subtitles',
	'actions_edit_url': 'Edit URL',
	'actions_edit_web_link': 'Edit web link',
	'actions_edit_web': 'Edit web link',
	'actions_edit_image': 'Edit image',
	'actions_edit_video': 'Edit video',
	'actions_edit_asset': 'Edit asset',
	'actions_edit_asset_plural': 'Edit {{count}} assets',
	'actions_edit_zip': 'Edit microsite',
	'actions_edit_scorm': 'Edit SCORM',
	'actions_edit_file': 'Edit file',
	'actions_edit_audio': 'Edit audio',
	'actions_edit_document': 'Edit document',
	'actions_edit_link': 'Edit link',
	'actions_edit_audience': 'Edit audience',
	'actions_edit_selection': 'Edit selection',
	'actions_delete_section': 'Delete section',
	'actions_lock_section': 'Lock section',
	'actions_edited': 'Edited',
	'actions_back': 'Back',
	'actions_back_to_folder': 'Back to parent folder',
	'actions_back_to_playlist': 'Back to playlist',
	'actions_back_to_set': 'Back to set {{setName}}',
	'actions_back_to_sessions_list': 'Back to sessions list',
	'actions_browse_all_playlists': 'Browse all playlists',
	'actions_set_audience_to_everyone': 'Set to everyone',
	'actions_set_audience_to_none': 'Set to none',
	'actions_set_new_status_colon': 'Set new status:',
	'actions_discard': 'Discard',
	'actions_discard_audience': 'Discard audience',
	'actions_mark_done': 'Mark as done',
	'actions_mark_not_done': 'Mark as not done',
	'actions_done': 'Done',
	'actions_done_percentage': '{{percentage}} done',
	'actions_not_started': 'Not started',
	'actions_failed': 'Failed',
	'actions_opened': 'Opened',
	'actions_open_folder': 'Open folder',
	'actions_mark_read': 'Mark as read',
	'actions_mark_all_read': 'Mark all as read',
	'actions_stay': 'Stay on page',
	'actions_save': 'Save',
	'actions_save_and_enable': 'Save and enable',
	'actions_save_and_close': 'Save & close',
	'actions_save_for_later': 'Save for later',
	'actions_saved_for_later': 'Saved for later',
	'actions_save_and_add_to_playlist': 'Save & add to playlist',
	'actions_save_and_continue': 'Save & continue',
	'actions_remove_from_save_for_later': 'Remove from saved',
	'actions_remove': 'Remove',
	'actions_remove_name': 'Remove {{name}}',
	'actions_remove_from_playlist': 'Remove from playlist',
	'actions_remove_asset': 'Remove asset',
	'actions_remove_specific_asset': 'Remove asset {{name}}',
	'actions_remove_specific_playlist': 'Remove playlist {{name}}',
	'actions_remove_playlist_link': 'Remove playlist link',
	'actions_remove_owning_team': 'Remove owning team',
	'actions_remove_team': 'Remove team {{name}}',
	'actions_remove_user': 'Remove user {{name}}',
	'actions_disable_all_reminders': 'Disable all reminders',
	'actions_disable_share': 'Disable share',
	'actions_delete_badge_image': 'Delete badge image',
	'actions_reorder_content': 'Reorder content',
	'actions_apply_tag': 'Apply {{tag}}',
	'actions_apply_hub_status': 'Apply hub status',
	'actions_like': 'Like',
	'actions_rate': 'Rate',
	'actions_rated': 'Rated {{count}} star',
	'actions_rated_plural': 'Rated {{count}} stars',
	'actions_toggle_share_and_preview': 'Toggle share & preview options',
	'actions_share': 'Share',
	'actions_share_all': 'Share all',
	'actions_share_now': 'Share now',
	'actions_share_this_playlist': 'Share this playlist',
	'actions_share_selection': 'Share selection',
	'actions_share_asset': 'Share 1 asset',
	'actions_share_asset_plural': 'Share {{count}} assets',
	'actions_share_playlist': 'Share 1 playlist',
	'actions_share_playlist_plural': 'Share {{count}} playlists',
	'actions_search_related_content': 'Search related content',
	'actions_remind': 'Remind',
	'actions_download': 'Download',
	'actions_download_subtitle': 'Download subtitle',
	'actions_download_format': 'Download {{format}}',
	'actions_download_report': 'Download report',
	'actions_open': 'Open',
	'actions_open_link': 'Open link',
	'actions_join': 'Join',
	'actions_join_meeting': 'Join meeting',
	'actions_open_in_new_window': 'Open in new window',
	'actions_open_in_hub': 'Open in hub',
	'actions_open_in_admin_dashboard': 'Open in admin dashboard',
	'actions_replace_image': 'Replace image',
	'actions_replace_image_plural': 'Replace images',
	'actions_drop_image_to_replace': 'Drop image to replace',
	'actions_drop_image_to_upload': 'Drop image to upload',
	'actions_click_or_drag_to_replace_image': 'Click or drag and drop to replace image',
	'actions_click_or_drag_to_add_image': 'Click or drag and drop to add image',
	'actions_upload_image': 'Upload image',
	'actions_remove_image': 'Remove image',
	'actions_remove_image_plural': 'Remove images',
	'actions_get_shareable_link': 'Get shareable link',
	'actions_more': 'More',
	'actions_more_count': '{{count}} more',
	'actions_show_colon': 'Show:',
	'actions_show_more': 'Show more',
	'actions_show_less': 'Show less',
	'actions_show_templates_colon': 'Show templates:',
	'actions_show_section_content': 'Show content of {{sectionName}}',
	'actions_show_all_hubs': 'Show all hubs',
	'actions_go_back': 'Back to previous page',
	'actions_go_to_settings': 'Go to settings',
	'actions_close_modal': 'Close this window',
	'actions_close': 'Close',
	'actions_next': 'Next',
	'actions_next_page': 'Next page',
	'actions_prev_page': 'Previous page',
	'actions_undo': 'Undo',
	'actions_undo_all': 'Undo all',
	'actions_redo': 'Redo',
	'actions_play': 'Play',
	'actions_pause': 'Pause',
	'actions_fullscreen': 'View in fullscreen',
	'actions_exit_fullscreen': 'Exit fullscreen',
	'actions_view_assets': 'View assets',
	'actions_view_in_playlist': 'View in playlist',
	'actions_hide_detailed_permissions': 'Hide detailed permissions',
	'actions_view_detailed_permissions': 'View detailed permissions',
	'actions_view_artwork_guide': 'View artwork guide',
	'actions_view_all_announcements': 'View all announcements',
	'actions_view_skills': 'View skills',
	'actions_view_full_analysis': 'View full analysis',
	'actions_add': 'Add',
	'actions_add_content': 'Add content',
	'actions_add_content_above': 'Add content above {{name}}',
	'actions_add_content_to': 'Add content to {{name}}',
	'actions_add_skills': 'Add skills',
	'actions_add_new_content_and_folders': 'Add new content and folders',
	'actions_add_folders': 'Add folders',
	'actions_add_reminder': 'Add reminder',
	'actions_add_assets_sections_playlist_links': 'Add assets, sections or playlist links',
	'actions_add_asset': 'Add asset',
	'actions_add_asset_from_library': 'Add asset from library',
	'actions_add_new_playlists': 'Add new playlists',
	'actions_add_playlist_recommendation': 'Add playlist',
	'actions_add_playlist': 'Add playlist',
	'actions_add_playlist_details': 'Add playlist details',
	'actions_add_session': 'Add session',
	'actions_add_name': 'Add {{name}}',
	'actions_edit_playlist_details': 'Edit playlist details',
	'actions_edit_playlist': 'Edit playlist',
	'actions_edit_playlist_plural': 'Edit {{count}} playlists',
	'actions_edit_playlist_access': 'Edit playlist access',
	'actions_edit_playlist_access_plural': 'Edit {{count}} playlist\'s access',
	'actions_manage_content': 'Manage content',
	'actions_manage_attendees': 'Manage attendees',
	'actions_you_can_edit_playlist': 'You can edit this playlist',
	'actions_you_can_edit_this': 'You can edit this',
	'actions_add_badge': 'Add badge',
	'actions_add_badge_image': 'Add badge image',
	'actions_add_tag': 'Add "{{tag}}"',
	'actions_add_topics': 'Add topics',
	'actions_add_topic': 'Add topic',
	'actions_add_subtopic': 'Add subtopic',
	'actions_add_timezone': 'Add time zone',
	'actions_add_to_homescreen': 'Add to Home Screen',
	'actions_add_subtitles': 'Add subtitles',
	'actions_add_subtitle': 'Add subtitle',
	'actions_add_subtitles_file': 'Add subtitles file',
	'actions_add_team_type': 'Add team type',
	'actions_add_teams': 'Add teams',
	'actions_add_new_teams': 'Add new teams',
	'actions_add_new_team': 'Add team',
	'actions_add_new_smart_team': 'Add smart team',
	'actions_add_new_tag': 'Add new tag',
	'actions_add_role': 'Add role',
	'actions_add_accesskey': 'Add access key',
	'actions_add_web_links': 'Add web links',
	'actions_add_web_link': 'Add web link',
	'actions_add_web': 'Add web link',
	'actions_add_new_web_link': 'Add new web link',
	'actions_add_image': 'Add image',
	'actions_add_event': 'Add event',
	'actions_add_document': 'Add document',
	'actions_add_video': 'Add video',
	'actions_add_audio': 'Add audio',
	'actions_add_scorm': 'Add SCORM',
	'actions_add_microsite': 'Add microsite',
	'actions_add_zip': 'Add microsite',
	'actions_add_file': 'Add file',
	'actions_add_nudge': 'Add nudge',
	'actions_add_selected': 'Add selected',
	'actions_add_new_topics': 'Add new topics',
	'actions_add_new_subtopics': 'Add new subtopics',
	'actions_add_as_required': 'Add as required',
	'actions_add_as_optional': 'Add as optional',
	'actions_add_owner': 'Add owner',
	'actions_edit_owner': 'Edit owner',
	'actions_change_to_required': 'Change to required',
	'actions_leave_as_optional': 'Leave as optional',
	'actions_type_to_add': 'Type to add',
	'actions_view_team': 'View team',
	'actions_view_team_assets': 'View team assets',
	'actions_view_smart_teams': 'View smart teams',
	'actions_view': 'View',
	'actions_view_meeting': 'View meeting {{name}}',
	'actions_view_activity': 'View activity',
	'actions_view_profile': 'View profile',
	'actions_view_in_dashboard': 'View in Admin dashboard',
	'actions_view_playlist': 'View playlist',
	'actions_view_playlists': 'View playlists',
	'actions_view_users': 'View users',
	'actions_view_who_has_access': 'View who has access',
	'actions_review_smart_team': 'Review {{teamName}}',
	'actions_review_cover_image': 'Review cover image',
	'actions_review_settings': 'Review settings',
	'actions_filter': 'Filter',
	'actions_filter_by_progress': 'Filter by progress',
	'actions_filter_by_progress_colon': 'Filter by progress:',
	'actions_filter_by_status_colon': 'Filter by status:',
	'actions_filter_by_attendance_status_colon': 'Filter by attendance status:',
	'actions_filter_by_type': 'Filter by type',
	'actions_filter_by_type_colon': 'Filter by type:',
	'actions_filter_by_topic': 'Filter by topic',
	'actions_filter_by_action': 'Filter by action',
	'actions_filter_by_action_colon': 'Filter by action:',
	'actions_reset_language': 'Reset language',
	'actions_reset_filter': 'Reset filter',
	'actions_reset_ranks_a_z': 'Reset Ranks A-Z',
	'actions_reset': 'Reset',
	'actions_rank': 'Rank',
	'actions_pin': 'Pin',
	'actions_pin_selection': 'Pin selection',
	'actions_unpin': 'Unpin',
	'actions_unpin_selection': 'Unpin selection',
	'actions_update_pin': 'Update pin',
	'actions_update_selection': 'Update selection',
	'actions_skip_navigation': 'Skip navigation',
	'actions_change_avatar': 'Change your photo',
	'actions_set_name_or_language': 'Set your name or language',
	'actions_toggle_nav': 'Toggle navigation',
	'actions_submit': 'Submit',
	'actions_submit_feedback': 'Submit feedback',
	'actions_post': 'Post',
	'actions_reply': 'Reply',
	'actions_delete': 'Delete',
	'actions_deleted': 'Deleted',
	'actions_delete_playlist': 'Delete playlist',
	'actions_delete_asset': 'Delete asset',
	'actions_delete_folder': 'Delete folder',
	'actions_delete_all': 'Delete all',
	'actions_delete_selection': 'Delete selection',
	'actions_delete_reminder': 'Delete reminder',
	'actions_keep': 'Keep',
	'actions_reactivate': 'Reactivate',
	'actions_change_name': 'Change name',
	'actions_change': 'Change',
	'actions_change_owning_team': 'Change owning team',
	'actions_change_type': 'Change type',
	'actions_change_settings': 'Change settings',
	'actions_continue': 'Continue',
	'actions_view_all': 'View all',
	'actions_refine_rules': 'Refine rules',
	'actions_select': 'Select',
	'actions_select_playlists': 'Select playlists',
	'actions_select_assets': 'Select assets',
	'actions_select_teams': 'Select teams',
	'actions_select_users': 'Select members',
	'actions_select_individuals': 'Select individuals',
	'actions_select_owner': 'Select owner',
	'actions_select_timezone': 'Select time zone',
	'actions_select_language': 'Select language',
	'actions_select_topics': 'Select topics',
	'actions_select_nudge_type': 'Select nudge type',
	'actions_select_all': 'Select all',
	'actions_select_skills': 'Select skills',
	'actions_select_sets': 'Select sets',
	'actions_deselect_all': 'Deselect all',
	'actions_select_all_assets': 'Select all assets',
	'actions_select_all_playlists': 'Select all playlists',
	'actions_select_only': 'Select only {{item}}',
	'actions_toggle_single_select': 'Toggle single selection',
	'actions_view_selection': 'View selection',
	'actions_confirm_selection': 'Confirm selection',
	'actions_try_again': 'Try again',
	'actions_cancel': 'Cancel',
	'actions_cancel_upload': 'Cancel upload',
	'actions_confirm': 'Confirm',
	'actions_confirm_import': 'Confirm and import',
	'actions_confirm_delete': 'Confirm and delete',
	'actions_confirm_and_send_email': 'Confirm and send email',
	'actions_confirm_and_send_email_plural': 'Confirm and send emails',
	'actions_confirm_update': 'Confirm update',
	'actions_confirm_how_to_proceed': 'Please confirm how you want to proceed.',
	'actions_quit_editing_playlist': 'Quit editing your playlist',
	'actions_quit_creating_playlist': 'Quit playlist creation',
	'actions_quit_editing_section': 'Quit editing section',
	'actions_quit_creating_section': 'Quit section creation',
	'actions_quit_creating_asset': 'Quit asset creation',
	'actions_quit_editing_your_asset': 'Quit editing your asset',
	'actions_quit_editing_badge_image': 'Quit editing badge image',
	'actions_quit_creating_badge_image': 'Quit badge image creation',
	'actions_quit_creating_smart_team': 'Quit smart team creation',
	'actions_quit_editing_smart_team': 'Quit editing smart team',
	'actions_quit_creating_nudge': 'Quit nudge creation',
	'actions_assign_topics': 'Assign topics',
	'actions_assign_timezone': 'Assign time zone',
	'actions_add_import_users': 'Add or import new users',
	'actions_add_new_users': 'Add new users',
	'actions_add_users_plural': 'Add users',
	'actions_add_users': 'Add user',
	'actions_import_users_from_csv': 'Import users from a CSV',
	'actions_duplicate': 'Duplicate',
	'actions_duplicate_all': 'Duplicate all',
	'actions_change_asset_location': 'Change asset location',
	'actions_change_asset_type': 'Change asset type',
	'actions_move_to_location': 'Move to {{location}}',
	'actions_move_selected_here': 'Move selected items here',
	'actions_move_selected_to': 'Move selected items to {{name}}',
	'actions_move_selected_above': 'Move selected items above {{name}}',
	'actions_keep_in_current_location': 'Keep in current location',
	'actions_retry': 'Retry',
	'actions_move': 'Move',
	'actions_move_topic': 'Move {{topicName}}',
	'actions_move_topic_plural': 'Move {{count}} topics',
	'actions_move_subtopic_plural': 'Move {{count}} subtopics',
	'actions_feature_new_content': 'Feature new content',
	'actions_manage': 'Manage',
	'actions_manage_tags': 'Manage tags',
	'actions_manage_subtopics': 'Manage subtopics',
	'actions_manage_images': 'Manage images',
	'actions_insert': 'Insert',
	'actions_invite': 'Invite',
	'actions_distribute': 'Distribute',
	'actions_edit_distribution': 'Edit distribution',
	'actions_load_more': 'Load more',
	'actions_more_options': 'More options',
	'actions_more_actions': 'More actions',
	'actions_create': 'Create',
	'actions_create_content': 'Create content',
	'actions_create_course': 'Create course',
	'actions_create_field': 'Create field',
	'actions_create_role': 'Create role',
	'actions_create_set_from_selection': 'Create set from selection',
	'actions_create_session': 'Create session',
	'actions_replace': 'Replace',
	'actions_replace_file': 'Replace file',
	'actions_replace_badge_image': 'Replace badge image',
	'actions_update': 'Update',
	'actions_update_link': 'Update link',
	'actions_get_new_colour': 'Get a new colour',
	'actions_distribute_playlist': 'Distribute playlist',
	'actions_distribute_playlist_plural': 'Distribute playlists',
	'actions_return_to_admin_dashboard': 'Return to Admin dashboard',
	'actions_return_to_home': 'Return to Home',
	'actions_dismiss': 'Dismiss',
	'actions_upload': 'Upload',
	'actions_upload_file': 'Upload file',
	'actions_upload_files': 'Upload files',
	'actions_upload_a_file': 'Upload a file',
	'actions_upload_microsite_scorm': 'Upload microsite / SCORM course',
	'actions_upload_new_file': 'Upload new file',
	'actions_upload_as_zip': 'Upload as zip',
	'actions_upload_new_image': 'Upload new image',
	'actions_please_select': 'Please select',
	'actions_max_characters': 'Max {{maxLength}} characters',
	'actions_characters_used': '{{valueLength}}/{{maxLength}} characters used',
	'actions_characters_used_simple': '{{value}} characters used',
	'actions_revert': 'Revert',
	'actions_revert_to_default': 'Revert to default',
	'actions_revert_to_default_subject': 'Revert to default subject',
	'actions_revert_to_default_message': 'Revert to default message',
	'actions_discard_changes': 'Discard changes',
	'actions_discard_unsaved_changes': 'Discard unsaved changes',
	'actions_save_changes': 'Save changes',
	'actions_save_content_changes': 'Save content changes',
	'actions_proceed': 'Proceed',
	'actions_restore': 'Restore',
	'actions_restored': 'Restored',
	'actions_restore_all': 'Restore all',
	'actions_restore_original_content': 'Restore original content',
	'actions_copy': 'Copy',
	'actions_copy_item': 'Copy {{children}}',
	'actions_send_email': 'Send Email',
	'actions_add_personal_message': 'Add personal message',
	'actions_preview': 'Preview',
	'actions_exit_preview': 'Exit preview',
	'actions_preview_content': 'Preview content',
	'actions_preview_image': 'Preview image',
	'actions_preview_changes': 'Preview changes',
	'actions_review_changes': 'Review changes',
	'actions_search': 'Search',
	'actions_search_hellip': 'Search…',
	'actions_search_teams': 'Search teams',
	'actions_search_users': 'Search users',
	'actions_search_members': 'Search members',
	'actions_search_team_members': 'Search team members',
	'actions_search_tags': 'Search tags',
	'actions_search_subtopics': 'Search subtopics',
	'actions_search_nudges': 'Search nudges',
	'actions_search_topics': 'Search topics',
	'actions_search_playlists': 'Search playlists',
	'actions_search_asset_library': 'Search asset library',
	'actions_search_assets_playlists_hellip': 'Search assets/playlists…',
	'actions_search_user_changelog': 'Search user changelog',
	'actions_search_nudge_changelog': 'Search nudge changelog',
	'actions_search_content_changelog': 'Search content changelog',
	'actions_search_team_changelog': 'Search team changelog',
	'actions_search_skills_changelog': 'Search skills changelog',
	'actions_search_message_log': 'Search message log',
	'actions_search_user_import_log': 'Search user import log',
	'actions_search_sets': 'Search sets',
	'actions_search_skills': 'Search skills',
	'actions_search_by_alt_text_hellip': 'Search by alternative text…',
	'actions_search_by_tag_colon': 'Search by tag:',
	'actions_search_or_ask': 'Search or ask anything',
	'actions_coach_me_on_this': 'Coach me on this',
	'actions_coach_me_on': 'Coach me on {{name}}',
	'actions_processing_import_hellip': 'Processing import…',
	'actions_import_user_data': 'Import user data',
	'actions_disable_autosharing': 'Disable auto-sharing',
	'actions_link_to_another_playlist': 'Link to another playlist',
	'actions_click_to_edit': 'Click to edit',
	'actions_pick_badge_image': 'Select badge image',
	'actions_include': 'Include',
	'actions_exclude': 'Exclude',
	'actions_exclude_from_ai': 'Exclude from AI',
	'actions_exclude_content_from_ai_coach': 'Exclude this content from AI Coach',
	'actions_info': 'Info',
	'actions_got_it': 'Got it',
	'actions_clear_topic_filter': 'Clear topic filter',
	'actions_clear_search': 'Clear search',
	'actions_close_search': 'Close search',
	'actions_enable': 'Enable',
	'actions_enabled': 'Enabled',
	'actions_disabled': 'Disabled',
	'actions_enable_all': 'Enable all',
	'actions_disable_all': 'Disable all',
	'actions_set_to_repeat': 'Set to repeat',
	'actions_set_to_not_repeat': 'Set to not repeat',
	'actions_display_content_numbers': 'Display content numbers',
	'actions_hide_content_numbers': 'Hide content numbers',
	'actions_ok': 'Ok',
	'actions_make_optional': 'Make optional',
	'actions_make_required': 'Make required',
	'actions_resolve_errors_to_save': 'Resolve any errors to be able to save',
	'actions_view_nudge': 'View nudge',
	'actions_give_it_a_try': 'Give it a try',
	'actions_scroll_right': 'Scroll right',
	'actions_scroll_left': 'Scroll left',
	'actions_scorm_settings_updated': 'SCORM settings updated',
	'actions_change_optional_content_status': 'Also change status of optional content in playlists',
	'actions_do_not_change_optional_content_status': 'Do not change status of optional content in playlists',
	'actions_do_not_change': 'Do not change',
	'actions_update_completion_status': 'Update completion status',
	'actions_customise_subject_and_message': 'Customise subject and message',
	'actions_set_to_not_started': 'Set to "Not started"',
	'actions_set_to_completed': 'Set to "Completed"',
	'actions_set_to_completed_on_date': 'Set to "Completed" on {{date}}',
	'actions_share_selected_content': 'Share selected content',
	'actions_new_status_update': 'New status update',
	'actions_reset_status': 'Reset status',
	'actions_reset_status_and_share': 'Reset status and share',
	'actions_share_on_reset': 'Share on reset',
	'actions_notify': 'Notify',
	'actions_use_this_hub_for_helix': 'Use this hub for Helix',
	'actions_repeat': 'Repeat',
	'actions_repeat_every': 'Repeat every',
	'actions_edit_above_in_reset_status_section': 'Edit above in "Reset status" section',
	'actions_unsubscribe': 'Unsubscribe',
	'actions_subscribe_to_comment_notifications': 'Subscribe to comment notifications',
	'actions_disconnect': 'Disconnect',
	'actions_reauthorise': 'Re-authorise',
	'actions_connect_calendar': 'Connect calendar',
	'actions_select_calendar_provider': 'Select a calendar provider',
	'actions_manage_connected_calendar': 'Manage connected calendar',
	'actions_increase_hours': 'Increase hours',
	'actions_increase_minutes': 'Increase minutes',
	'actions_decrease_hours': 'Decrease hours',
	'actions_decrease_minutes': 'Decrease minutes',
	'created_by': 'Created by',
	'by_author': 'by <1>{{author}}</1>',
	'no': 'No',
	'yes': 'Yes',
	'on': 'On',
	'off': 'Off',
	'and': 'And',
	'not_applicable': 'N/A',
	'amount_none': 'None',
	'links_placeholder': 'https://www.example.com',
	'required_field': 'Required',
	'required_fields_note': 'Fields marked with a * must be filled in.',
	'content_type_content': 'Content',
	'content_type_content_plural': 'Content',
	'content_type_new': 'New',
	'content_type_existing': 'Existing',
	'content_type_subscribed_content': 'Subscribed content',
	'content_type_nudge': 'Nudge',
	'content_type_nudge_plural': 'Nudges',
	'content_type_user': 'User',
	'content_type_user_plural': 'Users',
	'content_type_badge': 'Badge',
	'content_type_badge_plural': 'Badges',
	'content_type_badge_image': 'Badge image',
	'content_type_topic': 'Topic',
	'content_type_topic_plural': 'Topics',
	'content_type_topic_all': 'All topics',
	'content_type_subtopic': 'Subtopic',
	'content_type_subtopic_plural': 'Subtopics',
	'content_type_subtopic_count': 'One subtopic',
	'content_type_subtopic_count_plural': '{{count}} subtopics',
	'content_type_new_topic': 'New topic',
	'content_type_new_subtopic': 'New subtopic',
	'content_type_team_playlist_count': '1 team playlist',
	'content_type_team_playlist_count_plural': '{{count}} team playlists',
	'content_type_playlist': 'Playlist',
	'content_type_playlist_plural': 'Playlists',
	'content_type_collections_and_playlists': 'Playlists',
	'content_type_distributed_playlist': 'Distributed playlist',
	'content_type_team_playlist': 'Team playlist',
	'content_type_section': 'Section',
	'content_type_asset': 'Asset',
	'content_type_asset_plural': 'Assets',
	'content_type_distributed_asset': 'Distributed asset',
	'content_type_asset_from_file': 'Asset from file',
	'content_type_team': 'Team',
	'content_type_team_plural': 'Teams',
	'content_type_smart_team': 'Smart team',
	'content_type_line_manager_team': 'Line manager team',
	'content_type_line_manager_team_plural': 'Line manager teams',
	'content_type_tag': 'Tag',
	'content_type_tag_plural': 'Tags',
	'content_type_related_playlist': 'Related playlist',
	'content_type_related_playlist_plural': 'Related playlists',
	'content_type_related_content': 'Related content',
	'content_type_content_related_to': 'Content related to {{name}}',
	'content_type_recommended_content': 'Recommended content',
	'content_type_recommended_content_for': 'Recommended content for {{name}}',
	'content_type_folder': 'Folder',
	'content_type_folder_plural': 'Folders',
	'content_type_new_folder': 'New folder',
	'content_type_upload': 'Upload',
	'content_type_url': 'URL',
	'content_type_event_details': 'Event details',
	'content_type_link_details': 'Link details',
	'content_type_image_details': 'Image details',
	'content_type_video_details': 'Video details',
	'content_type_video_subtitles': 'Video subtitles',
	'content_type_scorm_details': 'SCORM details',
	'content_type_microsite_details': 'Microsite details',
	'content_type_file_details': 'File details',
	'content_type_document_details': 'Document details',
	'content_type_audio_details': 'Audio details',
	'content_type_system_image': 'System image',
	'content_type_system_image_plural': 'System images',
	'content_type_custom_image': 'Custom image',
	'content_type_custom_image_plural': 'Custom images',
	'content_type_no_image': 'No image',
	'content_type_skill': 'Skill',
	'content_type_skill_plural': 'Skills',
	'content_type_set': 'Set',
	'content_type_set_plural': 'Sets',
	'content_type_skill_set': 'Skill set',
	'content_type_skill_set_plural': 'Skill sets',
	'content_type_user_skill': 'User skill',
	'content_type_user_skill_plural': 'User skills',
	'content_type_event': 'Event',
	'content_type_event_plural': 'Events',
	'content_upload_complete': 'Upload complete',
	'content_uploading_image': 'Uploading image',
	'content_uploading_video': 'Uploading video',
	'content_uploading_document': 'Uploading document',
	'content_uploading_audio': 'Uploading audio',
	'content_uploading_scorm': 'Uploading SCORM',
	'content_uploading_microsite': 'Uploading microsite',
	'content_uploading_zip': 'Uploading microsite',
	'content_uploading_file': 'Uploading file',
	'content_uploading_transcript': 'Uploading transcript',
	'content_processing_transcript': 'Processing transcript',
	'content_uploading_file_info': 'Your file is still being uploaded. Don’t close this browser tab until uploading has finished.',
	'content_upload_successful': 'Your file was successfully uploaded.',
	'content_upload_successful_and_ready': 'Your file was successfully uploaded and is now ready to be viewed.',
	'content_processing_file_info': 'Before it can be viewed in the hub, the file needs to be processed. We\'ll let you know once this is done.',
	'content_processing_status_processing': 'Processing…',
	'content_processing_status_invalid': 'Processing failed',
	'content_processing_status_draft': 'Draft',
	'content_currently_not_available': 'Currently not available',
	'content_status_optional': 'Optional',
	'content_status_optional_info': 'Completing this item is not required to complete the playlist "{{playlistName}}"',
	'content_editor_select_to_move_or_edit': 'Select items to move or edit',
	'content_editor_select_to_move': 'Select items to move',
	'content_editor_move_hint': 'Click an arrow to move this',
	'lock_section_info': 'Prevent content from being accessed via this section',
	'section_unlocking_options': 'Unlocking options',
	'section_unlocking_manual': 'Manual',
	'section_unlocking_progress': 'Progress',
	'section_unlocking_time': 'Date and Time',
	'section_unlocking_manual_info': 'Manually unlock this section when it\'s ready',
	'section_unlocking_progress_info': 'Automatically unlock for people who have completed all previous content in this playlist',
	'section_unlocking_time_info': 'Automatically unlock at the specified time',
	'section_was_unlocked_info': 'This section was unlocked on {{date}} at {{time}}',
	'section_locked_status_locked': 'Locked',
	'section_locked_status_progress_user': 'Locked. Complete all previous content to unlock this section',
	'section_locked_status_progress_manager': 'Locked. Unlocks for users who completed all previous content',
	'section_locked_status_datetime_future': 'Locked. This content will unlock on {{date}} at {{time}}',
	'section_locked_status_datetime_past': 'Unlocked on {{date}} at {{time}}',
	'this_item_will_be_moved': 'This item will be moved',
	'current_location': 'Current location',
	'selection': 'Selection',
	'no_selection': 'No selection',
	'generic_selection_status_short': '1 selected',
	'generic_selection_status_short_plural': '{{count}} selected',
	'generic_selection_status': 'One item selected',
	'generic_selection_status_plural': '{{count}} items selected',
	'topic_selection_status': 'One topic selected',
	'topic_selection_status_plural': '{{count}} topics selected',
	'topic_non_available_for_move': 'No topics available to move into. Please deselect at least one topic.',
	'subtopic_selection_status': 'One subtopic selected',
	'subtopic_selection_status_plural': '{{count}} subtopics selected',
	'playlist_selection_status': 'One playlist selected',
	'playlist_selection_status_plural': '{{count}} playlists selected',
	'section_selection_status': 'One section selected',
	'section_selection_status_plural': '{{count}} sections selected',
	'nudge_selection_status_plural': '{{count}} nudges selected',
	'user_selection_status': 'One user selected',
	'user_selection_status_plural': '{{count}} users selected',
	'member_selection_status': 'One member selected',
	'member_selection_status_plural': '{{count}} members selected',
	'individual_selection_status': 'One individual selected',
	'individual_selection_status_plural': '{{count}} individuals selected',
	'asset_selection_status': 'One asset selected',
	'asset_selection_status_plural': '{{count}} assets selected',
	'no_team_selection_status': 'No teams selected',
	'team_selection_status': 'One team selected',
	'team_selection_status_plural': '{{count}} teams selected',
	'team_count_status': 'team',
	'team_count_status_plural': 'teams',
	'manager_selection_status': 'One manager selected',
	'manager_selection_status_plural': '{{count}} managers selected',
	'role_selection_status': 'One role selected',
	'role_selection_status_plural': '{{count}} roles selected',
	'domain_selection_status': 'One domain selected',
	'domain_selection_status_plural': '{{count}} domains selected',
	'picker_autoshare_title_colon': 'Auto-share with:',
	'top_level': 'Top level',
	'teams_count': '1 team',
	'teams_count_plural': '{{count}} teams',
	'set_selection_status': 'One set selected',
	'set_selection_status_plural': '{{count}} sets selected',
	'skill_selection_status': 'One skill selected',
	'skill_selection_status_plural': '{{count}} skills selected',
	'file_type_default': 'Default',
	'file_type_new': 'New file',
	'file_type_web': 'Web link',
	'file_type_event': 'Event',
	'file_type_activity': 'Activity',
	'file_type_assessment': 'Assessment',
	'file_type_elearning': 'E-learning',
	'file_type_survey': 'Survey',
	'file_type_webinar': 'Webinar',
	'file_type_workshop': 'Workshop',
	'file_type_pdf': 'PDF',
	'file_type_image': 'Image',
	'file_type_audio': 'Audio',
	'file_type_video': 'Video',
	'file_type_msword': 'Word document',
	'file_type_spreadsheet': 'Spreadsheet',
	'file_type_presentation': 'Presentation',
	'file_type_asset': 'Asset',
	'file_type_collection': 'Playlist',
	'file_type_playlist': 'Playlist',
	'file_type_article': 'Article',
	'file_type_fluidbook': 'Fluidbook',
	'file_type_infographic': 'Infographic',
	'file_type_podcast': 'Podcast',
	'file_type_quiz': 'Quiz',
	'file_type_text': 'Text',
	'file_type_topic': 'Topic',
	'file_type_section': 'Section',
	'file_type_microsite': 'Microsite',
	'file_type_scorm_course': 'SCORM course',
	'file_type_scorm': 'SCORM',
	'file_type_zip': 'Microsite',
	'file_type_file': 'File',
	'file_type_document': 'Document',
	'time_today': 'Today',
	'time_yesterday': 'Yesterday',
	'time_last_week': 'Last week',
	'time_earlier': 'Earlier',
	'time_ago_just_now': 'Just now',
	'time_ago_minute': '{{count}} minute ago',
	'time_ago_minute_plural': '{{count}} minutes ago',
	'time_hour': 'Hour',
	'time_hour_plural': 'Hours',
	'time_minute': 'Minute',
	'time_minute_plural': 'Minutes',
	'time_days_before': '{{count}} day before',
	'time_days_before_plural': '{{count}} days before',
	'time_weeks_before': '{{count}} week before',
	'time_weeks_before_plural': '{{count}} weeks before',
	'time_days_after': '{{count}} day after',
	'time_days_after_plural': '{{count}} days after',
	'time_weeks_after': '{{count}} week after',
	'time_weeks_after_plural': '{{count}} weeks after',
	'time_months_before': '{{count}} month before',
	'time_months_before_plural': '{{count}} months before',
	'time_years_before': '{{count}} year before',
	'time_years_before_plural': '{{count}} years before',
	'time_count': '{{count}} time',
	'time_count_plural': '{{count}} times',
	'hour': '{{count}} hour',
	'hour_plural': '{{count}} hours',
	'minute': '{{count}} minute',
	'minute_plural': '{{count}} minutes',
	'minute_count': 'minute',
	'minute_count_plural': 'minutes',
	'hour_short': '{{count}}h',
	'minute_short': '{{count}}min',
	'second_short': '{{count}}s',
	'week': 'week',
	'week_plural': 'weeks',
	'day': 'day',
	'day_plural': 'days',
	'month': 'month',
	'month_plural': 'months',
	'year': 'year',
	'year_plural': 'years',
	'pagination_current_slash_total': '{{current}}/{{total}}',
	'pagination_current_page_of_total': 'Page {{current}} of {{count}}',
	'pagination_current_page': 'Page {{count}}',
	'pagination_previous': 'Previous page',
	'pagination_next': 'Next page',
	'pagination_jump_to_page': 'Jump to page',
	'pagination_jump_to_page_submit': 'Go',
	'unread_messages': '{{count}} unread message',
	'unread_messages_plural': '{{count}} unread messages',
	'badges_unlocked_title': 'One badge unlocked',
	'badges_unlocked_title_plural': '{{count}} badges unlocked',
	'badges_unlocked_title_0': 'Unlocked badges',
	'badges_remaining_title': 'One badge left to unlock',
	'badges_remaining_title_plural': '{{count}} badges left to unlock',
	'badges_remaining_title_0': 'Badges left to unlock',
	'badge_locked_tooltip': 'Complete this playlist to unlock this badge',
	'badge_unlocked_tooltip': 'You have unlocked this badge',
	'unlocked_badges_empty': 'You have not unlocked any badges yet.',
	'remaining_badges_empty': 'You have unlocked all available badges!',
	'playlist_with_badge_info': 'A badge can be unlocked for completing this playlist',
	'title_congratulations': 'Congratulations!',
	'only_admins_can_see_this': 'Only admins can see this',
	'asset_next_up': 'Next up',
	'asset_next_content': 'Next: {{name}}',
	'you_are_here': 'You are here',
	'end_of_playlist': 'End of playlist',
	'asset_viewer_close': 'Close asset viewer',
	'asset_viewer_info': 'Info',
	'asset_viewer_mark_done_automatic': 'This asset is automatically marked as done when completed',
	'asset_viewer_error_processing': 'This asset is not available as it is still being processed. Please try again later.',
	'asset_viewer_error_invalid': 'This asset is not available as the zip file was invalid. The top level of the zip file must contain imsmanifest.xml for SCORM courses or index.html for microsites.',
	'asset_viewer_error_video': 'This video is corrupted and cannot be played.',
	'asset_viewer_error_processing_issue': 'This asset is not available as there has been an issue in processing the zip file. Please re-upload the file and try again.',
	'asset_viewer_error_visible': 'This asset is not yet visible.',
	'asset_viewer_error_video_unavailable': 'This video is currently unavailable. Please try again later.',
	'asset_in_playlists_colon': 'In playlist:',
	'asset_in_playlists_colon_plural': 'In {{count}} playlists:',
	'asset_type_selection': 'Please select an asset type',
	'role_inspector_title': 'Admin roles',
	'role_inspector_info': 'Create custom roles to control which areas of the Admin dashboard are accessible to users.',
	'accesskey_inspector_title': 'Access keys',
	'accesskey_inspector_info': 'Create access keys for long life programmatic authorisation',
	'external_link_opens_in_new_tab': 'This will open in a new tab or window',
	'direct_download': 'Direct download',
	'contact_form_title': 'Contact us',
	'contact_form_description': 'Use this form to leave feedback, suggest missing content or request training that you are interested in.',
	'contact_form_description_helix': 'Use this form to leave feedback.',
	'contact_form_your_request': 'Your request',
	'asset_feedback_title': 'Feedback',
	'asset_feedback_description': 'Was this content useful for you? How could we improve it? Let us know!',
	'asset_feedback_your_message': 'Write your feedback',
	'you_have_liked': 'You have liked this',
	'you_and_users_have_liked': 'You and one other user have liked this',
	'you_and_users_have_liked_plural': 'You and {{count}} other users have liked this',
	'users_have_liked': 'One user has liked this',
	'users_have_liked_plural': '{{count}} users have liked this',
	'no_likes': 'No one has liked this yet',
	'alert_updated': 'Updated',
	'alert_updated_failed': 'Update failed',
	'alert_warning': 'Warning',
	'alert_save_msg': 'Successfully saved playlist',
	'alert_remove_from_saved_msg': 'Successfully removed playlist from saved',
	'alert_reset_success': 'Successfully reset',
	'alert_reset_error': 'Could not be reset',
	'alert_download_pending_title': 'Download Pending',
	'alert_download_pending_msg': 'Please be patient, this can take a while',
	'alert_no_data_title': 'No data',
	'alert_no_data_msg': 'This report is empty, try changing any available filters and run it again',
	'alert_nothing_to_upload': 'Nothing to upload',
	'alert_download_complete_title': 'Download complete',
	'alert_download_complete_msg': 'Download not started?',
	'alert_download_failed_title': 'Download failed',
	'alert_profile_updated_msg': 'Profile has been updated successfully',
	'alert_profile_not_updated_msg': 'Profile could not be updated',
	'alert_logout_failed': 'Logout failed',
	'alert_playlist_added_successfully': 'Playlist added successfully',
	'alert_playlist_added_successfully_plural': 'Playlists added successfully',
	'alert_playlist_not_added': 'Playlist could not be added',
	'alert_playlist_updated_successfully': 'Playlist updated successfully',
	'alert_playlist_updated_successfully_plural': 'Playlists updated successfully',
	'alert_playlist_not_updated': 'Playlist could not be updated',
	'alert_playlist_not_updated_plural': 'Playlists could not be updated',
	'alert_playlist_deleted_successfully': 'Playlist deleted successfully',
	'alert_playlist_deleted_successfully_plural': 'Playlists deleted successfully',
	'alert_playlist_not_deleted': 'Playlist could not be deleted',
	'alert_playlist_not_deleted_plural': 'Playlists could not be deleted',
	'alert_playlist_access_update_success': 'Playlist access updated successfully',
	'alert_playlist_access_update_success_plural': 'Access for {{count}} playlists updated successfully',
	'alert_playlist_access_update_error': 'Playlist access could not be updated',
	'alert_playlist_access_update_error_plural': 'Access for {{count}} playlists could not be updated',
	'alert_playlist_sharing_update_success': 'Playlist sharing updated successfully',
	'alert_playlist_sharing_update_error': 'Playlist sharing could not be updated',
	'alert_create_playlist_success': 'Playlist created successfully',
	'alert_create_playlist_error': 'Playlist could not be created',
	'alert_duplicate_playlist_success': 'Playlist duplicated successfully',
	'alert_duplicate_playlist_success_plural': 'Playlists duplicated successfully',
	'alert_duplicate_playlist_error': 'Playlist could not be duplicated',
	'alert_duplicate_playlist_error_plural': 'Playlists could not be duplicated',
	'alert_playlist_distribution_update_success': 'Playlist distribution update successful',
	'alert_playlist_distribution_update_error': 'Playlist distribution update failed',
	'alert_playlist_distribution_update_success_plural': 'Playlist distribution update successful',
	'alert_playlist_distribution_update_error_plural': 'Playlist distribution update failed',
	'alert_reset_playlist_rank_success_plural': 'Playlist ranks successfully reset',
	'alert_reset_playlist_rank_error_plural': 'Playlist ranks could not be reset',
	'alert_reset_playlist_rank_success': 'Playlist rank successfully reset',
	'alert_reset_playlist_rank_error': 'Playlist rank could not be reset',
	'alert_playlist_audience_error': 'Playlist audience could not be updated',
	'alert_playlist_audience_error_plural': 'Playlist audiences could not be updated',
	'alert_create_section_success': 'Section created successfully',
	'alert_create_section_error': 'Section could not be created',
	'alert_section_added_successfully': 'Section added successfully',
	'alert_section_not_added': 'Section could not be added',
	'alert_section_updated_successfully': 'Section updated successfully',
	'alert_section_not_updated': 'Section could not be updated',
	'alert_section_deleted_successfully': 'Section deleted successfully',
	'alert_section_not_deleted': 'Section could not be deleted',
	'alert_asset_removed_successfully': 'Asset removed successfully',
	'alert_asset_deleted_success': 'Asset deleted successfully',
	'alert_asset_updated_success': 'Asset updated successfully',
	'alert_assets_updated_success': 'Assets updated successfully',
	'alert_assets_moved_success': 'Asset(s) moved to {{location}}',
	'alert_assets_moved_error': 'Moving asset(s) failed',
	'alert_asset_not_removed': 'Asset could not be removed',
	'alert_asset_added_successfully': 'Asset added successfully',
	'alert_asset_added_successfully_plural': 'Assets added successfully',
	'alert_asset_not_added': 'Asset could not be added',
	'alert_asset_not_added_plural': 'Assets could not be added',
	'alert_reset_asset_rank_success': 'Asset rank successfully reset',
	'alert_reset_asset_rank_error': 'Asset rank could not be reset',
	'alert_reset_asset_rank_success_plural': 'Asset ranks successfully reset',
	'alert_reset_asset_rank_error_plural': 'Asset ranks could not be reset',
	'alert_playlist_link_not_added': 'Playlist link could not be added',
	'alert_playlist_link_not_added_plural': 'Playlist links could not be added',
	'alert_playlist_link_removed_successfully': 'Playlist link removed successfully',
	'alert_playlist_link_not_removed': 'Playlist link could not be removed',
	'alert_enter_name': 'Please enter a name to continue.',
	'alert_tag_already_added': '"{{tag}}" was already added',
	'alert_topic_moved_success': 'Topic moved successfully',
	'alert_subtopic_moved_success': 'Subtopic moved successfully',
	'alert_topic_moved_error': 'Topic could not be moved',
	'alert_subtopic_moved_error': 'Subtopic could not be moved',
	'alert_topics_added_to_playlist_success': 'Added topics to playlist(s) successfully',
	'alert_topics_removed_from_playlist_success': 'Removed topics from playlist(s) successfully',
	'alert_topic_created_existing_topics_error_colon': 'Error, some topics already exist:',
	'alert_subtopic_created_existing_subtopics_error_colon': 'Error, some subtopics already exist:',
	'alert_topic_created_success': 'Topic created successfully',
	'alert_subtopic_created_success': 'Subtopic created successfully',
	'alert_topic_created_error': 'Topic could not be created',
	'alert_subtopic_created_error': 'Subtopic could not be created',
	'alert_topic_deleted_success': 'Topic deleted successfully',
	'alert_topic_deleted_error': 'Topic could not be deleted',
	'alert_subtopic_deleted_success': 'Subtopic deleted successfully',
	'alert_subtopic_deleted_error': 'Subtopic could not be deleted',
	'alert_topic_updated_success': 'Topic updated successfully',
	'alert_subtopic_updated_success': 'Subtopic updated successfully',
	'alert_topic_updated_error': 'Topic could not be updated',
	'alert_subtopic_updated_error': 'Subtopic could not be updated',
	'alert_topic_rank_set_success': 'Topic rank successfully set',
	'alert_subtopic_rank_set_success': 'Subtopic rank successfully set',
	'alert_topic_rank_set_error': 'Topic rank could not be set',
	'alert_subtopic_rank_set_error': 'Subtopic rank could not be set',
	'alert_topic_ranks_reset_success': 'Topic ranks successfully reset',
	'alert_subtopic_ranks_reset_success': 'Subtopic ranks successfully reset',
	'alert_topic_rank_reset_error': 'Topic ranks could not be reset',
	'alert_subtopic_rank_reset_error': 'Subtopic ranks could not be reset',
	'alert_uploading_cover_image': 'Uploading new cover image',
	'alert_cover_image_uploaded': 'New cover image successfully uploaded',
	'alert_tag_not_added': 'Tag "{{tag}}" could not be added',
	'alert_no_topics_found': 'No topics found',
	'alert_badge_image_uploading': 'Uploading new badge image',
	'alert_badge_image_updated_successfully': 'Badge image updated successfully',
	'alert_badge_image_not_updated': 'Badge image could not be updated',
	'alert_badge_image_deleted_successfully': 'Badge image deleted successfully',
	'alert_badge_image_not_deleted': 'Badge image could not be deleted',
	'alert_update_language_success': 'Language updated successfully.',
	'alert_update_language_error': 'Updating the language failed.',
	'alert_remove_subtitles_success': 'Removed subtitles file successfully.',
	'alert_remove_subtitles_error': 'Removing subtitles file failed.',
	'alert_edit_tag_success': 'Tag edited successfully',
	'alert_edit_tag_error': 'Could not edit tag',
	'alert_delete_tag_success': 'Tag deleted successfully',
	'alert_delete_tag_error': 'Tag deletion failed',
	'alert_create_tag_success': 'Tag created successfully',
	'alert_create_tag_error': 'Tag could not be created',
	'alert_too_many_files_title': 'Too many files',
	'alert_too_many_files_error': 'You can only update one file at a time.',
	'alert_upload_failed_zip_error': 'Unable to upload content. If you are adding a file from a zip then please unzip it first.',
	'alert_upload_zip_file_error': '{{name}} uploaded is not a .zip file.',
	'alert_file_validation_title': 'Validating files',
	'alert_zip_file_validation_error': 'Error validating zip file',
	'alert_invalid_file_title': '{{name}} is not a valid Microsite / SCORM course',
	'alert_identical_description': 'Identical description',
	'alert_team_type_reordered_success': 'Team types re-ordered',
	'alert_team_type_reordered_error': 'Couldn’t re-order team types',
	'alert_team_type_deleted_success': 'Team type deleted',
	'alert_team_type_deleted_error': 'Couldn’t delete team type',
	'alert_team_type_created_success': 'Team type created',
	'alert_team_type_created_error': 'Couldn’t create team type',
	'alert_team_type_updated_success': 'Team type updated',
	'alert_team_type_updated_error': 'Couldn’t update team type',
	'alert_teams_created_success': 'Team(s) created successfully',
	'alert_teams_created_error': 'Couldn’t create team(s)',
	'alert_team_updated_success': 'Team updated successfully',
	'alert_team_updated_error': 'Team could not be updated',
	'alert_team_deleted_success': 'Team deleted successfully',
	'alert_team_deleted_error': 'Team could not be deleted',
	'alert_team_delete_disabled': 'Unable to delete team',
	'alert_team_delete_disabled_plural': 'Unable to delete teams',
	'alert_team_delete_disabled_text': 'This team must be removed from any smart teams before it can be deleted.',
	'alert_team_delete_disabled_text_plural': 'All teams  must be removed from any smart teams before they can be deleted.',
	'alert_team_with_users_managers_delete_disabled_text': 'Any users and managers must be removed from the team before it can be deleted.',
	'alert_team_managers_updated_success': 'Team managers updated successfully',
	'alert_team_managers_updated_error': 'Team managers could not be updated',
	'alert_smart_team_created_success': 'Smart team created successfully',
	'alert_smart_team_created_error': 'Couldn\'t create smart team',
	'alert_create_custom_field_error': 'Could not create custom field',
	'alert_custom_field_already_exists': 'This custom field already exists',
	'alert_uploading_profile_picture': 'Uploading profile picture',
	'alert_user_memberships_updated_success': 'User memberships updated successfully',
	'alert_user_memberships_updated_error': 'User memberships could not be updated',
	'alert_update_user_teams_success': 'User teams updated successfully',
	'alert_update_user_teams_error': 'User teams could not be updated',
	'alert_add_users_to_team_error': 'Failed to add users to this team',
	'alert_update_user_success': 'User updated successfully',
	'alert_update_user_error': 'User could not be updated',
	'alert_delete_users_success': 'User(s) deleted successfully',
	'alert_delete_users_error': 'User(s) could not be deleted',
	'alert_users_invited_success': 'User(s) invited successfully',
	'alert_users_invited_error': 'User(s) could not be invited',
	'alert_create_users_error': 'Users could not be created',
	'alert_add_user_success': 'Successfully added a user',
	'alert_add_user_error': 'The user already exists',
	'alert_add_user_success_plural': 'Successfully added {{count}} users',
	'alert_add_user_error_plural': 'The users {{users}} already exist',
	'alert_add_users_success': 'Adding user(s)…',
	'alert_add_users_error': 'Adding user(s), however one or more emails are invalid: {{invalidItems}}',
	'alert_update_user_language_success': 'User language updated successfully',
	'alert_update_user_language_error': 'User language could not be updated',
	'alert_update_employee_id_error': 'Employee Id could not be updated',
	'alert_another_user_has_employee_id': 'Another user already has this Employee Id',
	'alert_invalid_emails_error': '{{invalidItems}} is not a valid email.',
	'alert_create_team_type_before_title': 'You must create a team type before you can create teams',
	'alert_create_team_type_before_no_reg_type': 'There are no regular team types in the hub',
	'alert_create_team_type_before_no_team_type': 'There are no team types in the hub',
	'alert_updating_microsite_or_scorm': 'Updating a Microsite / SCORM course',
	'alert_uploading_microsite_or_scorm': 'Uploading a Microsite / SCORM course',
	'alert_role_creation_error': 'Role could not be created',
	'alert_delete_roles_success': 'Role(s) deleted',
	'alert_delete_roles_error': 'Could not delete role(s)',
	'alert_update_role_success': 'Role updated',
	'alert_update_role_error': 'Could not update role',
	'alert_update_role_error_info': 'A role with this data already exists.',
	'alert_folders_created_success': 'Folder(s) created successfully',
	'alert_folders_created_error': 'Couldn’t create folder(s)',
	'alert_links_created_success': 'Links(s) created successfully',
	'alert_links_created_error': 'Couldn’t create link(s)',
	'alert_links_created_info': 'Please check the format of your links.',
	'alert_uploading_topic_thumbnail': 'Uploading topic thumbnail',
	'alert_uploading_thumbnail': 'Uploading thumbnail',
	'alert_uploading_thumbnail_success': 'Thumbnail uploaded',
	'alert_uploading_thumbnail_error': 'Thumbnail upload failed',
	'alert_add_nudge_success': 'Nudge added',
	'alert_add_nudge_error': 'Couldn’t add nudge',
	'alert_nudge_updated_success': 'Nudge updated',
	'alert_duplicate_nudge_success': 'Nudge duplicated successfully',
	'alert_duplicate_nudge_success_plural': 'Nudges duplicated successfully',
	'alert_duplicate_nudge_error': 'Nudge could not be duplicated',
	'alert_duplicate_nudge_error_plural': 'Nudges could not be duplicated',
	'alert_restore_default_template_error': 'Could not restore to default template',
	'alert_save_template_error': 'Could not save the template',
	'alert_playlist_not_selected_error': 'Playlist not selected',
	'alert_share_content_success': 'Successfully shared content',
	'alert_share_content_error': 'Failed to share content',
	'alert_uploading_file': 'Uploading file',
	'alert_uploading_users_file': 'Uploading users’ file',
	'alert_update_asset_success': 'Asset updated successfully',
	'alert_update_asset_error': 'Couldn\'t update asset',
	'alert_update_asset_success_plural': 'Assets updated successfully',
	'alert_update_asset_error_plural': 'Couldn\'t update assets',
	'alert_move_asset_success': 'Asset moved successfully',
	'alert_move_asset_error': 'Failed to move one asset',
	'alert_move_asset_success_plural': 'Assets moved successfully',
	'alert_move_asset_error_plural': 'Failed to move {{count}} assets',
	'alert_uploading_subtitle_file': 'Uploading subtitles file',
	'alert_upload_subtitle_file_success': 'Subtitles file successfully uploaded',
	'alert_upload_subtitle_file_error': 'Failed to upload subtitles file',
	'alert_uploading_subtitle_file_warning': 'Subtitles uploaded, but failed to update app state, please reload page',
	'alert_updating_autoshares': 'Updating auto shares',
	'alert_updating_autoshares_success': 'Auto shares successfully updated',
	'alert_updating_autoshares_error': 'Auto shares could not be updated',
	'alert_removing_autoshares_success': 'Auto shares successfully removed',
	'alert_update_custom_field_success': 'Custom field updated to {{value}}',
	'alert_update_custom_field_error': 'Custom field could not be updated',
	'alert_create_custom_field_success': 'Custom field was created',
	'alert_edit_custom_field_success': 'Custom field was edited',
	'alert_delete_custom_field_success': 'Custom field was deleted',
	'alert_delete_custom_field_error': 'Custom field could not be deleted',
	'alert_file_uploaded_error': 'Failed to upload {{name}}',
	'alert_file_uploaded_success': 'Uploaded {{name}}',
	'alert_upload_users_file_error': 'Unable to upload the users’ file',
	'alert_update_settings_success': '{{title}} has been updated',
	'alert_update_settings_error': 'Settings could not be saved',
	'alert_add_asset_error': 'Failed to add asset',
	'alert_add_web_error': 'Failed to add web link',
	'alert_add_event_error': 'Failed to add event',
	'alert_add_upload_error': 'Failed to add upload',
	'alert_update_web_error': 'Failed to update web link',
	'alert_asset_processing_error_replace_or_delete': 'There was an error when processing the file "<1>{{name}}</1>". Please <4>upload a new file</4> or <6>delete the asset</6>.',
	'alert_edit_asset_processing_error_replace': 'There was an error when processing the file "<1>{{name}}</1>". Please <4>upload a new file</4>.',
	'alert_no_subtitles_added': 'No subtitles added',
	'alert_badge_updated_successfully': 'Badge updated successfully',
	'alert_badge_not_updated': 'Couldn\'t update badge',
	'alert_badge_created_successfully': 'Badge created successfully',
	'alert_badge_not_created': 'Couldn\'t create badge',
	'alert_badge_deleted_successfully': 'Badge deleted successfully',
	'alert_badge_not_deleted': 'Couldn\'t delete badge',
	'alert_content_restored_successfully': 'Content successfully restored',
	'alert_content_restored_successfully_plural': 'Contents successfully restored',
	'alert_content_restored_error': 'Content could not be restored',
	'alert_content_restored_error_plural': 'Contents could not be restored',
	'alert_playlist_restored_successfully': 'Playlist successfully restored',
	'alert_playlist_restored_successfully_plural': 'Playlists successfully restored',
	'alert_playlist_restored_error': 'Playlist could not be restored',
	'alert_playlist_restored_error_plural': 'Playlists could not be restored',
	'alert_user_changelog_download_error': 'Failed to download the user changelog report',
	'alert_team_changelog_download_error': 'Failed to download the team changelog report',
	'alert_content_changelog_download_error': 'Failed to download the content changelog report',
	'alert_nudges_changelog_download_error': 'Failed to download the nudge changelog report',
	'alert_skill_changelog_download_error': 'Failed to download the skill changelog report',
	'alert_nudges_analytics_report_download_error': 'Failed to download the nudge analytics report',
	'alert_copied_to_clipboard': 'Copied to clipboard',
	'alert_reset_mark_as_done_mode_success': 'Mark As Done was reset to the default option successfully',
	'alert_reset_mark_as_done_mode_error': 'Failed to reset Mark As Done to the default option',
	'alert_empty_subject_error': 'Please enter a subject',
	'alert_empty_message_error': 'Please enter a message',
	'alert_empty_date_error': 'Please enter a date',
	'alert_nudge_updated_successfully': 'Nudge updated successfully',
	'alert_nudge_updated_successfully_plural': '{{count}} nudges updated successfully',
	'alert_nudge_not_updated': 'Couldn\'t update nudge',
	'alert_nudge_not_updated_plural': 'Couldn\'t update nudges',
	'alert_nudge_deleted_successfuly': 'Nudge deleted successfully',
	'alert_nudge_deleted_successfuly_plural': '{{count}} nudges deleted successfully',
	'alert_nudge_not_deleted': 'Couldn\'t delete nudge',
	'alert_nudge_not_deleted_plural': 'Couldn\'t delete nudges',
	'alert_asset_deleted_error': 'Couldn\'t delete asset',
	'alert_folder_deleted_success': 'Folder deleted successfully',
	'alert_folder_deleted_error': 'Couldn\'t delete folder',
	'alert_selected_content_deleted_success_plural': '{{count}} selected contents deleted successfully',
	'alert_selected_content_deleted_error_plural': 'Couldn\'t delete selected content',
	'alert_comment_deleted_success': 'Comment deleted successfully',
	'alert_comment_deleted_error': 'Couldn\'t delete comment',
	'alert_comment_updated_error': 'Couldn\'t update comment',
	'alert_comment_updated_success': 'Comment updated successfully',
	'alert_comment_posted_success': 'Comment posted successfully',
	'alert_comment_posted_error': 'Couldn\'t post comment',
	'alert_contact_form_submit_success': 'Thank you! Request sent successfully.',
	'alert_contact_form_submit_error': 'Your request could not be sent.',
	'alert_delete_success': 'Successfully deleted',
	'alert_delete_error': 'Failed to delete',
	'alert_update_success': 'Successfully updated',
	'alert_update_error': 'Failed to update',
	'alert_feedback_success': 'Thanks for your feedback!',
	'alert_feedback_error': 'Feedback couldn\'t be sent.',
	'alert_invalid_placeholder_tag': '<<tag>> is an invalid placeholder.',
	'alert_invalid_placeholder_tag_suggestion': '<<tag>> is an invalid placeholder. Did you mean to use one of these? <<list>>',
	'alert_dismiss_share_error': 'Could not dismiss shared content',
	'alert_missing_owning_team_in_playlist_audience': 'The owning team must be in this playlist’s audience. Remove the owning team or change the audience to include the owning team.',
	'alert_missing_owning_team_in_playlist_audience_plural': 'The owning team must be in these playlists’ audiences. Remove the owning team or change the audience to include the owning team.',
	'alert_playlist_unpinned_success': 'Playlist successfully unpinned',
	'alert_playlist_unpinned_success_plural': '{{count}} playlists successfully unpinned',
	'alert_playlist_unpinned_error': 'Playlist could not be unpinned',
	'alert_playlist_unpinned_error_plural': 'Playlists could not be unpinned',
	'alert_playlist_pinned_success': 'Playlist successfully pinned',
	'alert_playlist_pinned_success_plural': '{{count}} playlists successfully pinned',
	'alert_playlist_pinned_error': 'Playlist could not be pinned',
	'alert_playlist_pinned_error_plural': 'Playlists could not be pinned',
	'alert_playlist_pinned_to_topic_success': 'Playlist successfully pinned to topic',
	'alert_playlist_pinned_to_topic_success_plural': '{{count}} playlists successfully pinned to topic',
	'alert_playlist_pinned_to_topic_error': 'Playlist could not be pinned to topic',
	'alert_playlist_pinned_to_topic_error_plural': 'Playlists could not be pinned to topic',
	'alert_playlist_unpinned_from_topic_success': 'Playlist successfully unpinned from topic',
	'alert_playlist_unpinned_from_topic_success_plural': '{{count}} playlists successfully unpinned from topic',
	'alert_playlist_unpinned_from_topic_error': 'Playlist could not be unpinned from topic',
	'alert_playlist_unpinned_from_topic_error_plural': 'Playlists could not be unpinned from topic',
	'alert_playlist_pin_moved_in_topic_success': 'Playlist successfully moved in topic',
	'alert_playlist_pin_moved_in_topic_error': 'Playlist could not be moved in topic',
	'alert_playlist_pin_moved_success': 'Playlist successfully moved',
	'alert_playlist_pin_moved_error': 'Playlist could not be moved',
	'alert_content_status_update_error': 'Status for selected content could not be updated',
	'alert_content_status_no_required_assets_error': 'The playlists that you selected don\'t directly contain any required assets so there is nothing to reset. Please review the content selected.',
	'alert_content_status_no_assets_error': 'The playlists that you selected don\'t directly contain any assets so there is nothing to reset. Please review the content selected.',
	'alert_content_status_no_users_error': 'All users in the selected audience already have the desired completion status so there is nothing to update. Please review the selected audience.',
	'alert_feedback_added_success': 'Feedback successfully sent',
	'alert_feedback_added_error': 'Feedback could not be sent',
	'alert_feedback_updated_success': 'Feedback successfully updated',
	'alert_feedback_updated_error': 'Feedback could not be updated',
	'alert_my_helix_domain_update_success': 'Helix successfully linked to this hub',
	'alert_add_skill_set_success': 'Skill set successfully added',
	'alert_add_skill_set_error': 'Skill set could not be added',
	'alert_update_skill_set_success': 'Skill set successfully updated',
	'alert_update_skill_set_error': 'Skill set could not be updated',
	'alert_delete_skill_set_success': 'Skill set successfully deleted',
	'alert_delete_skill_set_success_plural': 'Skill sets successfully deleted',
	'alert_delete_skill_set_error': 'Skill set could not be deleted',
	'alert_delete_skill_set_error_plural': 'Skill set could not be deleted',
	'alert_update_skill_success': 'Skill successfully updated',
	'alert_update_skill_error': 'Skill could not be updated',
	'alert_update_skill_success_plural': 'Skills successfully updated',
	'alert_update_skill_error_plural': 'Skills could not be updated',
	'alert_unsubscribe_success': 'Successfully unsubscribed',
	'alert_unsubscribe_error': 'Could not unsubscribe',
	'alert_calendar_deauthorised_info': 'Your calendar connection is no longer authorised so Helix is unable to view your calendar.',
	'alert_calendar_deauthorised_helix_behaviour_info': 'Helix might have already pre-scheduled meetings to join and will still attend these meetings. It is unable to auto-join meetings it hasn’t already scheduled to join, and will still try to auto-join declined or cancelled meetings if they were already scheduled.',
	'alert_calendar_disconnect_success': 'Calendar disconnected successfully',
	'alert_calendar_disconnect_error': 'Could not disconnect calendar',
	'alert_calendar_auto_join_update_success': 'Auto-join settings successfully updated',
	'alert_calendar_auto_join_update_error': 'Could not update auto-join settings',
	'alert_create_session_success': 'Session successfully created',
	'alert_create_session_error': 'Session could not be created',
	'alert_update_session_success': 'Session successfully updated',
	'alert_update_session_error': 'Session could not be updated',
	'alert_delete_session_success': 'Session successfully deleted',
	'alert_delete_session_error': 'Session could not be deleted',
	'alert_create_team_mindset_context_failed': 'Could not create Mindset context for team. Check if a context already exists with this hub and team name.',
	'alert_add_session_attendees_error': 'Could not add attendees to session',
	'alert_add_session_attendees_success': 'Attendees successfully added to session',
	'alert_update_session_attendee_status_error': 'Could not update status',
	'alert_update_session_attendee_status_success': 'Status successfully updated',
	'alert_added_section_to_homepage_success': 'Successfully added section to homepage',
	'alert_removed_section_from_homepage_success': 'Successfully removed section from homepage',
	'alert_reordered_homepage_sections_success': 'Successfully reordered homepage sections',
	'alert_reset_homepage_sections_success': 'Successfully reset homepage sections',
	'alert_unsaved_playlist_changes': 'There are unsaved changes to the playlist.',
	'alert_save_changes_before_session_management': 'You must save the changes before viewing and managing event sessions.',
	'alert_save_the_changes_before_sharing': 'You must save the changes before sharing.',
	'alert_save_changes_before_sharing': 'Save changes before sharing',
	'hints_disable_option_for_secure_url': 'This option can only be disabled for secure URLs that begin with https://',
	'email': 'Email',
	'email_colon': 'Email:',
	'email_placeholder': 'yourname@example.com',
	'password': 'Password',
	'new_password': 'New Password',
	'reveal_password': 'Show password',
	'hide_password': 'Hide password',
	'login_submit': 'Log in',
	'login_forgot_password': 'Forgot password?',
	'login_use_5app': 'Log in with email and password',
	'login_with_sso': 'Log in with {{name}}',
	'login_with_different_method': 'Log in with different method',
	'login_previously_used': 'Previously used',
	'login_admin_access': 'Admin access',
	'login_help': 'Need help?',
	'login_creds_incorrect': 'Incorrect email address or password',
	'login_creds_missing': 'Missing email address or password',
	'login_forbidden': 'Not authorised to access this hub',
	'login_limit_exceeded': 'Too many login attempts. Please try again in {{minutes}} minutes, or reset your password',
	'login_email_missing': 'Missing email address',
	'login_password_missing': 'Missing password',
	'login_change_email': 'Change email',
	'back_to_login': 'Back to login',
	'forgot_pw_title': 'Reset your password',
	'forgot_pw_description': 'Please enter your email address and we will send you a link to reset your password.',
	'forgot_pw_submit': 'Send password reset email',
	'forgot_pw_success_title': 'New password requested',
	'forgot_pw_success_description': 'You will receive an email shortly if this email address is registered with us.',
	'forgot_pw_expired_title': 'Password link expired',
	'forgot_pw_expired_description': 'Your password reset link has expired. Please press the button below to request another link.',
	'forgot_pw_request_new_link': 'Request new link',
	'forgot_pw_too_recent': 'Please wait 5 minutes before requesting another password',
	'change_pw_title': 'Change your password',
	'change_pw_title_initial': 'Welcome!',
	'change_pw_description': 'Please choose a new password for your account <1><0>{{email}}</0></1>',
	'change_pw_rules': 'The password must be at least 8 characters long',
	'change_pw_submit': 'Reset password',
	'change_pw_submit_initial': 'Save & get started',
	'change_pw_fail': 'Couldn’t save password',
	'password_strength': 'Password strength',
	'password_strength_weak': 'Weak',
	'password_strength_could_be_better': 'Could be better',
	'password_strength_okay': 'Okay',
	'password_strength_good': 'Good',
	'password_strength_strong': 'Strong',
	'managed_teams_count': 'You’re managing one team',
	'managed_teams_count_plural': 'You’re managing {{count}} teams',
	'managed_team_user_count': '1 member',
	'managed_team_user_count_plural': '{{count}} members',
	'managed_team_not_found': 'Unknown team',
	'team': 'Team',
	'teams': 'Teams',
	'manager': 'Manager',
	'managers': 'Managers',
	'select_managers': 'Select managers',
	'manager_reference': 'Manager reference',
	'managed_team': 'Managed team',
	'managed_team_plural': 'Managed teams',
	'teams_coach_knowledge_bank': 'Coach knowledge bank',
	'teams_coach_knowledge_bank_is_active': 'Active for this team',
	'reorder_playlist_title': 'Reorder playlist',
	'reorder_playlist_description': 'Click or tap and drag content up and down to reorder the content of this playlist',
	'analytics_open_rate': 'Open rate',
	'analytics_completion_rate': 'Completion rate',
	'analytics_user_progress': 'Member progress',
	'analytics_people': 'People',
	'analytics_average_user_progress': 'Average member progress',
	'user_progress_any': 'Any',
	'user_progress_none': 'None',
	'analytics_team_progress': 'Team progress',
	'analytics_from': 'from',
	'analytics_to': 'to',
	'analytics_current_view': 'Current view',
	'analytics_global_stats': 'Global stats',
	'analytics_activity_view': 'Activity view',
	'analytics_activity_period': 'Activity period',
	'analytics_recent_updates': 'Recent updates',
	'analytics_trend_positive': 'Up by {{percent}}',
	'analytics_trend_negative': 'Down by {{percent}}',
	'analytics_trend_neutral': 'No change',
	'analytics_trend_description': 'Percentages reflect changes compared to previous time period',
	'analytics_per_day': 'Per day',
	'analytics_per_week': 'Per week',
	'analytics_per_month': 'Per month',
	'analytics_last_7_days': 'Last 7 days',
	'analytics_last_12_months': 'Last 12 months',
	'analytics_last_week': 'Last week',
	'analytics_last_30_days': 'Last 30 days',
	'analytics_last_365_days': 'Last 365 days',
	'analytics_no_team_insights': 'Team insights couldn’t be retrieved',
	'analytics_no_team_trends': 'No activity in this period',
	'analytics_no_team_trends_subtitle': 'Share some content with your team to encourage them in.',
	'analytics_trending_asset_plural': 'Popular assets',
	'analytics_trending_playlist_plural': 'Popular playlists',
	'analytics_trending': 'Trending',
	'analytics_recently_changed_asset_plural': 'Recently changed assets',
	'analytics_recent_users': 'Recent visitors',
	'analytics_unique_user_plural': 'Unique users',
	'analytics_user_sessions_chart_plural': 'User sessions',
	'analytics_user_stats': 'User stats',
	'analytics_team_stats': 'Team stats',
	'analytics_views': '1 view',
	'analytics_views_plural': '{{count}} views',
	'analytics_user_sessions': 'Session',
	'analytics_user_sessions_plural': 'Sessions',
	'analytics_opened_asset_plural': 'Opened assets',
	'analytics_popular_asset_plural': 'Popular assets',
	'analytics_open': '{{count}} open',
	'analytics_open_plural': '{{count}} opens',
	'analytics_assets_opened': 'Asset opened',
	'analytics_assets_opened_plural': 'Assets opened',
	'analytics_assets_completed': 'Asset completed',
	'analytics_assets_completed_plural': 'Assets completed',
	'analytics_people_asset_opens': 'Asset open',
	'analytics_people_asset_opens_plural': 'Asset opens',
	'analytics_completed_playlists': 'Completed playlists',
	'analytics_playlists_opened': 'Playlist opened',
	'analytics_playlists_opened_plural': 'Playlists opened',
	'analytics_playlists_completed': 'Playlist completed',
	'analytics_playlists_completed_plural': 'Playlists completed',
	'analytics_people_playlist_opens': 'Playlist open',
	'analytics_people_playlist_opens_plural': 'Playlist opens',
	'analytics_most_active_users': 'Most active users',
	'analytics_active_users': 'Active users',
	'analytics_inactive_users': 'Inactive users',
	'analytics_activity_log': 'Activity log',
	'analytics_mobile_usage': 'Mobile usage',
	'analytics_insights': 'Insights',
	'analytics_trends': 'Trends',
	'analytics_members': 'Members',
	'analytics_most_saved': 'Most saved',
	'analytics_most_opened': 'Most opened',
	'analytics_most_completed': 'Most completed',
	'analytics_most_liked': 'Most liked',
	'analytics_most_comments': 'Most comments',
	'analytics_reports': 'Reports',
	'analytics_team_playlists': 'Team Playlists',
	'analytics_activity': 'Activity',
	'analytics_team_members': 'Team members',
	'analytics_people_user': 'Member',
	'analytics_people_sessions': 'Sessions',
	'analytics_people_time_spent_learning': 'Time spent learning',
	'analytics_people_no_results_title': 'No people found',
	'analytics_people_no_results_before_search': 'Please add some people to the team',
	'analytics_people_no_results_after_search': 'Change your search to try again',
	'analytics_team_member_last_opened': 'Last opened',
	'analytics_team_member_times_opened': 'Times opened',
	'analytics_team_member_assets_opened': 'Assets opened',
	'analytics_team_member_assets_completed': 'Assets completed',
	'analytics_team_member_playlist_progress': 'Playlist progress',
	'analytics_team_time_since_last_session': 'Time since last session',
	'analytics_team_learning_completed': 'Content completed',
	'analytics_team_no_playlists_title': 'No playlists',
	'analytics_team_no_playlists_message': 'This member did not open any playlist',
	'analytics_team_member_never_logged_in': 'This member hasn’t ever logged in',
	'analytics_progress_of_user': '{{userName}}’s playlist progress',
	'analytics_report_category_combined': 'New',
	'analytics_report_category_lists': 'Lists',
	'analytics_report_category_status': 'Current status',
	'analytics_report_category_summary_activity': 'Summary activity in time period',
	'analytics_report_category_detailed_activity': 'Detailed activity in time period',
	'analytics_report_category_miscellaneous': 'Miscellaneous',
	'analytics_report_category_extract': 'Data Extracts',
	'analytics_report_settings': 'Report settings',
	'analytics_report_no_settings': 'No report settings',
	'analytics_report_format': 'Format',
	'analytics_reports_label_start_date': 'Start date',
	'analytics_reports_label_end_date': 'End date',
	'analytics_reports_label_latest_attempt': 'Latest attempt only',
	'analytics_reports_label_interactions': 'Interactions',
	'analytics_reports_label_alert_invalid': 'Invalid entry for: {{error}}',
	'analytics_reports_label_alert_date_order': 'Start date must not be after the end date.',
	'analytics_reports_label_alert_date_required': 'You must enter both a start date and an end date',
	'analytics_reports_label_alert_both_date_fields_required': 'Either both dates should be entered or both should be blank',
	'analytics_reports_label_alert_missing_asset': 'You must select an asset when using the All member filter',
	'analytics_reports_label_alert_missing_playlist': 'You must select a playlist when using the All member filter',
	'analytics_reports_deleted_members_title': 'Deleted members',
	'analytics_reports_deleted_members_checkbox': 'Include deleted members in the report',
	'analytics_reports_latest_attempt_checkbox': 'Only include the latest attempt for each member',
	'analytics_reports_user_type_hint_active': 'Members who have interacted with the playlist',
	'analytics_reports_user_type_hint_shared': 'All members who have been shared the playlist or have interacted with the playlist',
	'analytics_reports_user_type_hint_all': 'All members who have access to the playlist or have interacted with the playlist.  You must filter the playlists to use this option',
	'analytics_reports_asset_user_type_hint_active': 'Members who have interacted with the asset',
	'analytics_reports_asset_user_type_hint_shared': 'All members who have been shared the asset and can access the asset',
	'analytics_reports_asset_user_type_hint_all': 'All members who have access to the asset, you must filter the assets to use this option',
	'analytics_reports_interaction_id_tooltip': 'Enter the Interaction Ids that you want to filter on as a comma separated list e.g. interaction-1,interaction-2. You may need to run the full report once to see the possible Interaction Ids for each asset.',
	'analytics_reports_activity_title': 'Activity',
	'analytics_reports_activity_checkbox': 'Include activity data in the report',
	'analytics_reports_due_date': 'Due date',
	'analytics_reports_due_date_checkbox': 'Include due date column in report',
	'report_asset_likes_by_name_name': 'Asset likes by name',
	'report_asset_likes_by_name_desc': 'Asset likes ordered by name',
	'report_user_activity_name': 'Member activity',
	'report_user_activity_desc': 'The amount of activity for each member within the timeframe selected',
	'report_asset_opens_by_day_of_the_week_name': 'Asset opens by day of the week',
	'report_asset_opens_by_day_of_the_week_desc': 'The number of assets opened on each day of the week',
	'report_asset_opens_name': 'Asset opens',
	'report_asset_opens_desc': 'Details of each time a member opened an asset in the timeframe selected',
	'report_asset_completions_name': 'Asset completions',
	'report_asset_completions_desc': 'Details of each time a member completed an asset in the timeframe selected',
	'report_daily_system_usage_name': 'Daily system usage',
	'report_daily_system_usage_desc': 'The overall activity on each day within the timeframe selected',
	'report_playlist_status_name': 'Playlist status',
	'report_playlist_status_desc': 'The progress that each member has made through each playlist that they have opened',
	'report_user_list_name': 'Member list',
	'report_user_list_desc': 'Details of each member including overall activity stats',
	'report_asset_status_name': 'Asset status',
	'report_asset_status_desc': 'The progress that each member has made through each asset that they have opened',
	'report_asset_activity_name': 'Asset activity',
	'report_asset_activity_desc': 'The amount of activity on each asset within the timeframe selected',
	'report_playlist_popularity_name': 'Playlist popularity',
	'report_playlist_popularity_desc': 'Playlists popularity ordered by name',
	'report_playlist_activity_name': 'Playlist activity',
	'report_playlist_activity_desc': 'The amount of activity on each playlist within the timeframe selected',
	'report_asset_list_name': 'Asset list',
	'report_asset_list_desc': 'Details of assets in playlists including overall activity data',
	'report_playlist_list_name': 'Playlist list',
	'report_playlist_list_desc': 'Details of each playlist including overall activity stats.',
	'report_scorm_asset_status_name': 'SCORM asset status',
	'report_scorm_asset_status_desc': 'The current status of each SCORM course for each learner',
	'report_scorm_asset_answers_name': 'SCORM asset answers',
	'report_scorm_asset_answers_desc': 'A detailed report to show you what answer each learner gave to each question for each attempt. This is useful for either looking at what an individual learner has been up to, or for analysing the overall responses given to different questions.',
	'report_security_audit_name': 'Security audit',
	'report_security_audit_desc': 'Audit of all attempted log in and log out events',
	'report_playlist_opens_name': 'Playlist opens',
	'report_playlist_opens_desc': 'Details of each time a member opened a playlist in the timeframe selected',
	'report_playlist_completions_name': 'Playlist completions',
	'report_playlist_completions_desc': 'Details of each time a member completed a playlist in the timeframe selected',
	'report_extract_asset_opens_name': 'Extract asset opens',
	'report_extract_asset_opens_desc': 'Asset opens in date range, designed to be imported into other systems',
	'report_extract_user_activity_name': 'Extract member activity',
	'report_extract_user_activity_desc': 'Member activity in date range, designed to be imported into other systems',
	'report_extract_playlist_opens_name': 'Extract playlist opens',
	'report_extract_playlist_opens_desc': 'Playlist opens in date range, designed to be imported into other systems',
	'report_extract_user_details_name': 'Extract member details',
	'report_extract_user_details_desc': 'Member details, designed to be imported into other systems.  Note that the activity columns are intentionally 0 and will be deprecated',
	'report_comments_name': 'Comments',
	'report_comments_desc': 'All comments left against playlists and assets',
	'report_extract_events_name': 'Events extract',
	'report_extract_events_desc': 'A log of activities performed in the Hub. Doesn’t include shares or comments. Designed to be imported into other systems',
	'report_extract_shares_name': 'Shares extract',
	'report_extract_shares_desc': 'Shares in date range with one row per person being shared to, designed to be imported into other systems',
	'report_member_combined_name': 'Member combined',
	'report_member_combined_desc': 'A report of all members with the option to include activity',
	'report_events_list_name': 'Events list',
	'report_events_list_desc': 'Event sessions in the time period',
	'report_events_per_user_name': 'Events',
	'report_events_per_user_desc': 'Details of events a member has been a part of',
	'duration_days': '{{count}} day',
	'duration_days_plural': '{{count}} days',
	'duration_days_ago': '{{count}} day ago',
	'duration_days_ago_plural': '{{count}} days ago',
	'duration_hours': '{{count}} hour',
	'duration_hours_plural': '{{count}} hours',
	'powered_by_5app': 'Powered by <1>5app</1>',
	'powered_by_5app_and_client': '<0><1>{{client}}</1></0> - Powered by <2>5app</2>',
	'no_data_found': 'No data found',
	'error_internal': 'Internal error',
	'error_generic': 'Error',
	'error_unknown': 'Unknown error',
	'error_code': 'Error Code',
	'error_404': 'Page not found',
	'error_500': 'Something went wrong',
	'error_feature_disabled': 'Feature disabled',
	'error_update_failed': 'Update failed',
	'error_whoops': 'Whoops!',
	'error_whoops_there_has_been_an_error': 'Whoops! It looks like there has been an error.',
	'error_bug_contact_admin': 'This is likely a bug. Please contact the administrator and include the error details below.',
	'error_details': 'Error details',
	'error_empty': 'No results',
	'error_invalid_value': 'Invalid value',
	'error_invalid_formatting': 'Invalid formatting',
	'error_empty_search': 'No results found for this search',
	'error_invalid_email': 'Invalid email',
	'error_forbidden': 'Access denied',
	'error_unauthorised': 'Unauthorised',
	'error_not_a_team_manager': 'You are not a team manager',
	'error_not_allowed': 'You are not allowed to do this action',
	'error_no_data': 'We could not fetch results from the server',
	'error_no_permission_to_change_settings': 'Your current permissions don’t allow you to change these settings',
	'error_content_access_denied': 'You don’t have permission to view this content. If you think this is an error, please <1>let us know</1>',
	'error_no_skills_found': 'No skills were found. If you think this is an error, please <1>let us know</1>.',
	'error_content_no_access': 'You do not have access to this content',
	'error_content_access_to_page_denied': 'You do not have permission to access this page. If you think this is an error, please contact the site owner.',
	'error_content_not_found': 'There is no content at this location. Try using search to find content that has been moved.',
	'error_player_not_loaded': 'Player could not be loaded',
	'error_no_data_to_display': 'No data to display yet',
	'error_could_not_load_data': 'Could not load data :(',
	'error_file_too_large': 'File size too large, maximum image size allowed is {{maxFileSizeInMb}} MB.',
	'error_file_type_unsupported_thumbnail': 'File type unsupported (jpeg, jpg, svg or png only).',
	'error_file_type_unsupported_badge_image': 'File type unsupported (svg or png only).',
	'error_file_not_supported': 'File not supported.',
	'error_uploading_subtitle_file': 'Error uploading subtitle file',
	'error_uploading_file': 'Error uploading file.',
	'error_upload_only_single_file': 'You can only upload a single file.',
	'error_required_field': 'This field is required',
	'error_subtitles_vtt_format': 'Subtitles must be in .vtt file format.',
	'error_not_found_under_link': 'No asset or folder was found under this link.',
	'error_name_is_required': 'Name is required',
	'error_colour_must_be_hex': 'Colour must be a valid hexadecimal string i.e. #33cc33 or #33c',
	'error_playlist_not_distributed_to_hub': 'Unable to view playlist as it has not been distributed to your hub',
	'error_topics_with_subtopics_not_deleted': 'Topics with subtopics cannot be deleted',
	'error_topics_with_subtopics_not_moved': 'Topics with subtopics cannot be moved',
	'error_view_missing_colon': 'View missing:',
	'error_no_valid_folder_name_specified': 'No valid folder name specified.',
	'error_no_empty_field': 'This field can’t be left empty.',
	'error_search_no_results_matching': 'Could not find any results matching <1><0>{{searchTerm}}</0></1>',
	'error_no_assets_selected': 'No assets selected',
	'error_no_content_selected': 'No content selected',
	'error_import_time_out': 'The operation timed out but the import is still in progress. Please check your email box or the log page for updates.',
	'error_unknown_subtitle_file': 'Unknown subtitles file {{id}}',
	'error_team_name_type_must_be_unique': 'Team(s) name and type must be unique',
	'error_invalid_json': 'Invalid JSON',
	'error_invalid_url': 'Invalid URL. Please check that the submitted URL is correct.',
	'error_no_custom_badges': 'You have not uploaded any badge images yet.',
	'error_missing_fields_list': 'Missing field: {{fields}}',
	'error_missing_fields_list_plural': 'Missing fields: {{fields}}',
	'error_code_unauthorized': 'Unauthorized',
	'error_code_unpublishing_asset': 'You cannot unpublish a published asset',
	'error_code_validation_error': 'Invalid data',
	'error_code_unknown_tags': 'Unknown tags',
	'error_code_missing_definitions_in_creation_payload': 'Missing definitions in creation payload',
	'error_code_missing_name_or_weblink': 'Missing name or weblink',
	'error_code_unsupported_asset_type': 'Unsupported asset type',
	'error_code_no_data_to_update': 'No data to update',
	'error_code_unknown_asset': 'Unknown asset',
	'error_code_cannot_edit_distributed_assets': 'Cannot edit distributed assets',
	'error_code_cannot_create_assets': 'Cannot create assets',
	'error_code_cannot_assign_content_to_team': 'Cannot assign content to team',
	'error_code_unknown_subtitles': 'Unknown subtitles',
	'error_code_restricted_asset_files': 'Restricted asset files',
	'error_code_duplicate_subtitles': 'Subtitles for this language already exist',
	'error_code_publishing_asset_without_file': 'Publishing asset without file',
	'error_code_publishing_asset_without_weburl': 'Publishing asset without URL',
	'error_code_invalid_circular_reference': 'Invalid circular reference',
	'error_no_saved_content': 'You have not saved any content yet',
	'error_no_filter_results': 'No results for the selected filters',
	'error_no_outstanding_todos': 'You do not currently have any To Dos',
	'error_no_achieved_todos': 'No items yet',
	'error_no_viewed_or_completed_content': 'You have not viewed or completed any content yet.',
	'error_account_cannot_be_authenticated': 'Sorry but you don\'t have permission to use {{hubName}}.  If you think that you should have access then please contact your administrator.',
	'error_code_obsolete_endpoint': 'Obsolete endpoint',
	'error_code_cannot_unpin_unpinned_playlists': 'Cannot unpin playlists which are not pinned',
	'error_code_cannot_move_unpinned_playlists': 'Cannot move unpinned playlists',
	'error_code_playlist_already_pinned': 'Playlist is already pinned',
	'error_code_cannot_pin_over_max_playlists': 'A maximum of 100 playlists can be pinned',
	'error_code_playlist_not_in_topic': 'Playlist is not in topic',
	'error_code_opening_insecure_links_in_asset_viewer': 'Unsecure links must be opened in a new window',
	'error_code_cannot_pin_unavailable_playlists': 'Cannot pin playlists which are unavailable in the hub',
	'error_code_no_assets_to_update': 'No assets to update found',
	'error_code_no_users_to_update': 'No users to update found',
	'error_end_time_after_start_time': 'End time must be after start time',
	'success_user_data_imported': 'New user data was successfully imported.',
	'success_msteams_integration': 'The hub was successfully linked to your tenant. You will soon receive a welcome message in Microsoft Teams.',
	'hub_status_current': 'Current hub status',
	'hub_status_default': '(default)',
	'hub_status_maintenance': 'We are creating some exciting new stuff for you. Please come back tomorrow.',
	'hub_status_archived': 'This hub has been archived and is no longer available',
	'hub_status_deleted': 'This hub has been removed and is no longer available',
	'hub_status_active_title': 'Active',
	'hub_status_active_info': 'The hub can be accessed by all users',
	'hub_status_maintenance_title': 'Maintenance',
	'hub_status_maintenance_info': 'The hub is closed to users and displays a message that the hub is temporarily disabled',
	'hub_status_maintenance_cta': 'Enable maintenance mode',
	'hub_status_archived_title': 'Archived',
	'hub_status_archived_info': 'The hub is closed to users and displays a message that the hub has been archived',
	'hub_status_archived_cta': 'Archive this hub',
	'hub_status_deleted_title': 'Deleted',
	'hub_status_deleted_info': 'The hub is closed to both users and admins and displays a message that the hub has been removed',
	'hub_status_deleted_cta': 'Delete this hub',
	'hub_status_deleted_warning': 'This will lock yourself and all other admins and users out of the hub.<br/>The hub will be marked for deletion. Only do this if you’re sure you want to delete the hub.',
	'hub_status_generic_warning': 'This will prevent users from logging into the hub. Admins will still be able to log in.',
	'scorm_message_after_open_popup': 'Your course has been launched in a new window. Use the menu on the left to select another module.',
	'scorm_message_when_cannot_open_popup': 'We tried to launch your course in a new window but it was blocked by your browser. Please disable popup blockers for this site and reopen the page to try again.',
	'form_title': 'Title',
	'form_description': 'Description',
	'form_language': 'Language',
	'form_time_zone': 'Time zone',
	'form_cover_image': 'Cover image',
	'form_cover_image_hint': 'Recommended size (pixels): {{size}}',
	'form_badge_image_hint': 'Badge image should be a square .PNG or .SVG image with a transparent background.',
	'form_displayed_type': 'Displayed type',
	'form_completion_time': 'Completion time',
	'form_url_colon': 'URL:',
	'form_last_updated_colon': 'Last updated:',
	'form_asset_library': 'Asset library',
	'form_asset_library_colon': 'Asset library:',
	'form_error_details_colon': 'Error details:',
	'form_file_name_colon': 'File name:',
	'form_file_size_colon': 'File size:',
	'form_uploaded_progress': '{{progress}} uploaded',
	'form_preview': 'Preview',
	'form_preview_download_colon': 'Downloading the original file is:',
	'form_allow_download': 'Allow download',
	'form_alternative_text': 'Alternative text',
	'form_alternative_text_info': 'Add alternative text to your image to make it accessible to more people, including people who are blind or have low vision. A good description is short, but presents what’s in the image accurately enough to convey its context.',
	'form_badge_alternative_text_info': 'Add a short description of the image to make it accessible to more people, including people who are blind or have low vision. E.g. "A white document with a red ribbon".',
	'form_old_type_colon': 'The old type was:',
	'form_new_type_colon': 'The new type is:',
	'form_style': 'Style',
	'form_badge_style_rose': 'Rose',
	'form_badge_style_sticker': 'Sticker',
	'form_mark_as_done_mode': 'Mark as done',
	'form_completion_mode': 'Completion',
	'form_owning_team': 'Owning team',
	'form_owning_team_plural': 'Owning teams',
	'form_custom_data': 'Custom data',
	'form_content_plural': 'Content',
	'form_other_hubs': 'Other hubs',
	'form_autoshare_audience': 'Auto-share audience',
	'form_user_created_assets': 'User-created assets',
	'form_share_with': 'Share with',
	'form_shareable_link': 'Shareable link',
	'form_scorm_settings': 'SCORM settings',
	'form_details': 'Details',
	'form_linked_content': 'Linked content',
	'form_week_colon': 'Week:',
	'form_owner': 'Owner',
	'form_joining_instructions': 'Joining instructions',
	'form_booking_instructions': 'Booking instructions',
	'form_sessions_starting_after_colon': 'Sessions starting after:',
	'form_alert_required_field': 'Required field',
	'form_facilitator': 'Facilitator',
	'form_capacity': 'Capacity',
	'form_meeting_link': 'Meeting link',
	'form_joining_link': 'Joining link',
	'modal_confirm_quit_edit_without_save': 'Are you sure you want to quit without saving your changes?',
	'modal_confirm_quit_creation_without_save': 'Are you sure you want to quit without saving your changes?',
	'modal_confirm_delete_playlist': 'Do you really want to delete this playlist?',
	'modal_confirm_delete_playlist_info': 'Assets in this playlist will not be deleted and will remain in the Asset library.',
	'modal_confirm_delete_section': 'Do you really want to delete this section?',
	'modal_confirm_remove_asset': 'Do you really want to remove this asset from this playlist?',
	'modal_confirm_remove_playlist_link': 'Do you really want to remove this playlist link from this playlist?',
	'modal_confirm_remove_playlist_owning_team_info': 'Removing the owning team will stop them from managing the playlist.',
	'modal_confirm_remove_playlist_owning_team_info_plural': 'Removing the owning team will stop them from managing the playlists.',
	'modal_confirm_remove_playlist_owning_team_admins': 'Admins will still be able to manage the playlist.',
	'modal_confirm_remove_playlist_owning_team_admins_plural': 'Admins will still be able to manage the playlists.',
	'modal_confirm_remove_owning_team': 'Are you sure that you want to remove the owning team?',
	'modal_confirm_remove_deleted_users_title': 'Remove deleted users',
	'modal_confirm_remove_deleted_users_plural': 'You have deleted users selected and by removing deleted users from the report these users will be deselected.',
	'modal_confirm_remove_deleted_users': 'You have a deleted user selected and by removing deleted users from the report this user will be deselected.',
	'modal_confirm_remove_deleted_users_confirmation': 'Are you sure you want to remove deleted users?',
	'modal_confirm_disable_all_reminders': 'Are you sure you want to disable all reminders?',
	'modal_confirm_disable_share': 'Are you sure you want to disable sharing?',
	'modal_confirm_quit_asset_creation_without_save': 'Are you sure you want to quit without saving your changes? The asset will not be created.',
	'modal_confirm_quit_asset_editing_without_save': 'Are you sure you want to quit without saving your changes?',
	'modal_confirm_delete_badge_image': 'Are you sure you want to delete this badge image?',
	'modal_confirm_delete_badge_image_used_in_playlists': 'This image is being used in a playlist, deleting it will cause this playlist to use the default badge image.',
	'modal_confirm_delete_badge_image_used_in_playlists_plural': 'This image is being used in {{count}} playlists, deleting it will cause all of these playlists to use the default badge image.',
	'modal_confirm_replace_badge_image_used_in_playlists': 'This image is being used in a playlist, replacing it will cause this playlist to use the new image.',
	'modal_confirm_edit_badge_image_used_in_playlists': 'This image is being used in a playlist, editing it will cause this playlist to use the edited image.',
	'modal_confirm_replace_badge_image_used_in_playlists_plural': 'This image is being used in {{count}} playlists, replacing it will cause all of these playlists to use the new image.',
	'modal_confirm_edit_badge_image_used_in_playlists_plural': 'This image is being used in {{count}} playlists, editing it will cause all of these playlists to use the edited image.',
	'modal_confirm_replace_badge_image': 'Are you sure you want to replace this badge image?',
	'modal_confirm_edit_badge_image': 'Are you sure you want to edit this badge image?',
	'modal_confirm_quit_smart_team_creation': 'Are you sure you want to cancel the creation of this smart team?',
	'modal_confirm_quit_smart_team_editing': 'Are you sure you want to cancel the editing of this smart team?',
	'modal_save_removed_changed_content_warning': 'You have made changes to the following items which you are removing from the playlist:',
	'modal_save_removed_changed_content_confirmation': 'Would you like to save the changes that you made now?',
	'modal_reset_ranking_topic_title': 'Reset topic ranking',
	'modal_reset_ranking_topic_message': 'Are you sure you want to reset the ranks for these topics back to alphabetical?',
	'modal_reset_ranking_subtopic_title': 'Reset subtopic ranking',
	'modal_reset_ranking_subtopic_message': 'Are you sure you want to reset the ranks for these subtopics back to alphabetical?',
	'modal_reset_ranking_asset_title': 'Reset asset ranking',
	'modal_reset_ranking_asset_message': 'Are you sure you want to reset the ranks for the assets in this playlist to alphabetical?',
	'modal_reset_ranking_playlist_title': 'Reset playlist ranking',
	'modal_reset_ranking_playlist_message': 'Are you sure you want to reset the ranks for these playlists back to alphabetical? This will change the order that they appear in the browse page for all users and can\'t be reverted.',
	'modal_update_file_title': 'Update file',
	'modal_upload_files_title': 'Upload files',
	'modal_update_file_message': 'Drop file here or <1>browse</1> to upload',
	'modal_update_file_message_plural': 'Drop files here or <1>browse</1> to upload',
	'modal_upload_file_drop_file_message': 'Drop a file here or <1>browse</1> to upload',
	'modal_upload_file_select_asset_message': 'or select an existing asset',
	'modal_upload_file_loading': 'Checking file…',
	'modal_upload_badge_image_message': 'Drop an image file or <1>browse</1> to upload',
	'modal_replace_badge_image_message': 'Drop an image file or <1>browse</1> to replace this image',
	'modal_delete_user_data_title': 'Delete user data',
	'modal_delete_user_data_message': 'Deleting this custom user field will hide all user data stored against this field. Re-creating the field with the same name will restore the data.',
	'modal_update_web_link_message': 'Website URL',
	'modal_edit_team_type_hint': 'Name can only contain letters, numbers, spaces and dashes',
	'modal_edit_team_type_name_placeholder': 'e.g. Country, Department',
	'modal_edit_team_type_role_default': 'Default',
	'modal_edit_team_type_role_manager_email': 'Line manager (Email reference)',
	'modal_edit_team_type_role_manager_employeeid': 'Line manager (Employee ID reference)',
	'modal_admin_roles_title': 'Admin roles',
	'modal_delete_asset_message': 'Are you sure you want to delete this asset?',
	'modal_delete_folder_message': 'Are you sure you want to delete this folder?',
	'modal_delete_folder_hint': 'All assets and folders contained within this folder will also be deleted.',
	'modal_delete_assets_and_folders_message': 'Are you sure you want to delete the selected assets/folders?',
	'modal_delete_assets_and_folders_hint': 'All assets and folders contained within selected folders will also be deleted.',
	'modal_delete_topic_title': 'Delete topic',
	'modal_delete_subtopic_title': 'Delete subtopic',
	'modal_delete_topic_message': 'Are you sure you want to delete {{topicName}}?',
	'modal_delete_topic_message_plural': 'Are you sure you want to delete {{count}} topics?',
	'modal_delete_subtopic_message_plural': 'Are you sure you want to delete {{count}} subtopics?',
	'modal_user_progress_checkbox': 'Only show inactive users',
	'modal_user_progress_hint': 'Only show users that have not made any progress in the last 30 days',
	'modal_remove_asset_title': 'Remove asset',
	'modal_remove_asset_message': 'Do you really want to remove this asset from this playlist?',
	'modal_add_users_title': 'Add users',
	'modal_add_users_email_title': 'Emails',
	'modal_add_users_email_hint': 'To add multiple users, separate their emails by comma',
	'modal_add_users_email_placeholder': 'user@example.com',
	'modal_add_users_invite_title': 'Invite by email now',
	'modal_add_users_invite_info_one': 'Untick this box to add users without sending them an invite.',
	'modal_add_users_invite_info_two': 'You can always do so later.',
	'modal_update_microsite_title': 'Update microsite / SCORM course',
	'modal_upload_microsite_title': 'Upload microsite / SCORM course',
	'modal_delete_role_title': 'Delete role',
	'modal_delete_role_title_plural': 'Delete roles',
	'modal_delete_role_info': 'Roles that are still assigned to users can not be deleted. Please remove all users from the role {{roleNames}} and try again.',
	'modal_delete_role_info_plural': 'Roles that are still assigned to users can not be deleted. Please remove all users from the roles {{roleNames}} and try again.',
	'modal_delete_role_message': 'Do you really want to delete this role?',
	'modal_delete_role_message_plural': 'Do you really want to delete these roles?',
	'modal_create_role_error': 'A role with this name already exists.',
	'modal_create_role_message': 'Control which areas of the admin dashboard users with this role will have access to.',
	'modal_create_role_info': 'A role with these permissions already exists. Each role must have unique permissions.',
	'modal_new_folder_title': 'Add folder',
	'modal_new_folder_input': 'Folder name',
	'modal_new_folder_info': 'To add multiple folders, separate their names by comma',
	'modal_new_topic_info': 'To add multiple topics, separate their names by comma',
	'modal_add_web_links_title': 'Add web links',
	'modal_add_web_links_info': 'To add multiple links, separate them by comma',
	'modal_add_web_links_input': 'URLs',
	'modal_add_web_links_checkbox': 'Open link in new window',
	'modal_add_web_links_checkbox_info_one': 'URLs starting with http:// can’t be embedded and have to be opened in a new window.',
	'modal_add_web_links_checkbox_info_two': 'Make sure the URL starts with https:// to be able to disable this option.',
	'modal_add_web_link_title': 'Add web link',
	'modal_add_web_link_check_info': 'Checking link...',
	'modal_upload_plain_zip_title': 'Upload plain zip file?',
	'modal_upload_plain_zip_message': 'The zip file that you have selected isn’t either a SCORM course or a microsite. Do you want to upload it as a zip file that will be downloadable?',
	'modal_upload_plain_zip_disclosure_toggle': 'About SCORM courses and microsites',
	'modal_upload_plain_zip_info_microsite': 'A <strong>microsite</strong> is a small, self-contained website that can be embedded in the Digital Hub. It must be a zip file that contains a file named <i>index.html</i> at its root.',
	'modal_upload_plain_zip_info_scorm': 'A <strong>SCORM course</strong> is standardised e-learning content. It must be a zip file that contains a file named <i>imsmanifest.xml</i> at its root.',
	'modal_upload_microsite_info_microsite': 'A <strong>microsite</strong> is a small, self-contained website that we can host in the Digital Hub for you. It must be uploaded as a zip file and needs to contain a file named <i>index.html</i> at its root.',
	'modal_upload_microsite_info_scorm': 'A <strong>scorm course</strong> is standarised e-learning content. It must be uploaded as a zip file and needs to contain a file named <i>imsmanifest.xml</i> at its root.',
	'modal_upload_microsite_message': 'Drop zip file(s) here or <1>browse</1> to upload',
	'modal_upload_microsite_hint_new_window': 'The microsite / SCORM course opens within the hub by default. Enable this to open in a new window.',
	'modal_delete_message': 'Do you really want to delete these items?',
	'modal_delete_nudge_title': 'Delete nudge',
	'modal_delete_nudge_title_plural': 'Delete nudges',
	'modal_delete_nudge_message': 'Do you really want to delete this nudge?',
	'modal_delete_nudge_message_plural': 'Are you sure you want to delete {{count}} nudges?',
	'modal_delete_reminder_message': 'Do you really want to delete this reminder?',
	'modal_discarded_changes_warning_title': 'Some changes will be discarded',
	'modal_discarded_changes_warning_message': 'Reminders which haven\'t been finalised by clicking the Done button will be discarded.',
	'modal_discarded_changes_warning_message_action': 'If you want to save these reminders then click Cancel and finalise them by clicking Done before saving again.',
	'modal_reset_views_title': 'Confirm reset',
	'modal_reset_views_message': 'You are about to force all users to see the welcome page next time they log in, even if they have seen it before. This action can’t be reverted, are you sure you want to proceed?',
	'modal_unsaved_changes_title': 'You have unsaved changes',
	'modal_unsaved_changes_message': 'Changing the language will discard your changes. Are you sure you want to proceed?',
	'modal_restore_default_title': 'Restore to default',
	'modal_restore_default_message': 'Do you really want to restore template to default?',
	'modal_share_content_title': 'Share content',
	'modal_share_content_admin_error': 'Some of the selected content is admin-only, so cannot be shared.',
	'modal_share_content_message': 'Who do you want to share this content with?',
	'modal_share_content_permission_info': 'The selected content has differing access permissions. It will only be shared with people who have access to <strong>all</strong> of the content.',
	'modal_share_with_users_title': 'Share with one user?',
	'modal_share_with_users_title_plural': 'Share with {{count}} users?',
	'modal_share_with_users_title_empty': 'No one to share with',
	'modal_share_with_users_cta': 'Confirm and share',
	'modal_share_with_users_message_users': 'This will share <strong><1>{{content}}</1></strong> with one user.',
	'modal_share_with_users_message_users_plural': 'This will share <strong><1>{{content}}</1></strong> with {{count}} users.',
	'modal_share_with_users_message_users_playlist': 'This will share <strong><1>{{contentCount}} playlists</1></strong> with one user.',
	'modal_share_with_users_message_users_playlist_plural': 'This will share <strong><1>{{contentCount}} playlists</1></strong> with {{count}} users.',
	'modal_share_with_users_message_users_asset': 'This will share <strong><1>{{contentCount}} assets</1></strong> with one user.',
	'modal_share_with_users_message_users_asset_plural': 'This will share <strong><1>{{contentCount}} assets</1></strong> with {{count}} users.',
	'modal_share_with_users_message_proceed': 'Are you sure you want to proceed?',
	'modal_share_with_users_message_no_users': 'The audience you selected returned no users.',
	'modal_share_with_users_message_no_users_info': 'Users must have access to all content to be included, please check the permissions and your audience and try again',
	'modal_disable_advanced_audience_title': 'Disable advanced audience',
	'modal_disable_advanced_audience_info': 'Your advanced audience settings will be discarded.',
	'modal_disable_advanced_audience_message': 'Are you sure you want to proceed?',
	'modal_remove_manager_title': 'Remove manager?',
	'modal_remove_manager_message': 'At least one of the selected users is a manager of the team {{name}}. Would you like to continue and remove them as the manager?',
	'modal_markdown_title': 'Markdown cheat sheet',
	'modal_markdown_block_markdown_title': 'What is Markdown?',
	'modal_markdown_block_markdown_message_colon': 'Markdown is an easy to learn way to add formatting to text. Use it to make text bold, add headings, lists, or links. Here’s how:',
	'modal_markdown_block_headings_title': 'Headings',
	'modal_markdown_block_headings_message_1_colon': 'On a new line, add a <1>#</1> character and a space before the first word of the heading:',
	'modal_markdown_block_headings_message_2_colon': 'Add more #’s for increasingly smaller subheadings:',
	'modal_markdown_block_headings_top_level': '# Top-level heading',
	'modal_markdown_block_headings_2nd_level': '## Second-level heading',
	'modal_markdown_block_headings_3rd_level': '### Third-level heading',
	'modal_markdown_block_paragraphs_title': 'Paragraphs and line breaks',
	'modal_markdown_block_paragraphs_message': 'Leave an empty line between two blocks of text to create a paragraph. Single line breaks will be preserved, too.',
	'modal_markdown_block_bold_title': 'Bold text',
	'modal_markdown_block_bold_message': 'Surround the words that you want to make bold with two asterisks <1>**on either side**</1>. In the final email, these words will be formatted <strong>bold</strong>.',
	'modal_markdown_block_lists_title': 'Lists',
	'modal_markdown_block_lists_message_1_colon': 'Create a bulleted list by writing each list item on a new line, and adding a <1>-</1> or <1>*</1> in front of it:',
	'modal_markdown_block_lists_message_2_colon': 'To make it an ordered list, use numbers instead:',
	'modal_markdown_block_links_title': 'Links',
	'modal_markdown_block_links_message_1_colon': 'To add a link, at first surround the word that you want to be clickable with <1>[square brackets]</1>. Add the URL of your link immediately after, in regular brackets:',
	'modal_markdown_block_links_message_2_colon': 'This will display as:',
	'modal_markdown_block_learn_more_title': 'Learn more',
	'modal_markdown_block_learn_more_message': 'This was only a short overview of the most common Markdown commands to get you started. For a more in-depth overview, you can refer to <1>this external reference</1>.',
	'modal_delete_team_title': 'Delete team',
	'modal_delete_team_title_plural': 'Delete teams',
	'modal_delete_team_with_user_warning': 'Deleting this team will permanently remove one member from it.',
	'modal_delete_team_with_user_warning_plural': 'Deleting this team will permanently remove {{count}} members from it.',
	'modal_delete_team_message': 'Do you really want to delete this team?',
	'modal_delete_team_message_plural': 'Do you really want to delete these teams?',
	'modal_delete_team_type_title': 'Delete team type',
	'modal_delete_team_type_message': 'Do you really want to delete this team type?',
	'modal_add_teams_title': 'Add teams',
	'modal_add_teams_teams_hint': 'To add multiple teams, separate them by comma',
	'modal_add_teams_team_placeholder': 'e.g. Marketing, Sales etc.',
	'modal_add_smart_team_title': 'Add smart team',
	'modal_add_smart_team_hint': 'A smart team is automatically populated with members based on their memberships in other teams',
	'modal_add_smart_team_placeholder': 'e.g. Finance UK',
	'modal_edit_smart_team_title': 'Edit smart team',
	'modal_refine_rules_smart_team': 'Refine rules',
	'modal_new_playlist_title': 'New playlist',
	'modal_invite_user_title': 'Invite user',
	'modal_invite_user_message': 'Do you really want to invite this user?',
	'modal_invite_user_message_plural': 'Do you really want to invite these users?',
	'modal_get_accesskey_message': 'This access token can be used by third parties to access the hub. Please copy it and store it safely. Once this window is closed it will not be possible to retrieve the token and a new token will need to be generated.',
	'modal_delete_user_title': 'Delete user',
	'modal_delete_user_message': 'Do you really want to delete this user?',
	'modal_delete_user_message_plural': 'Do you really want to delete these users?',
	'modal_delete_playlist_title': 'Delete playlist',
	'modal_delete_playlist_title_plural': 'Delete {{count}} playlists',
	'modal_delete_playlist_message': 'Do you really want to delete this playlist?',
	'modal_delete_playlist_message_plural': 'Do you really want to delete these <strong>{{count}}</strong> playlists?',
	'modal_delete_playlist_info': 'The content of this playlist will not be deleted.',
	'modal_delete_playlist_info_plural': 'The content of these playlists will not be deleted.',
	'modal_delete_set_title': 'Delete set',
	'modal_delete_set_title_plural': 'Delete {{count}} sets',
	'modal_delete_set_message': 'Do you really want to delete this set?',
	'modal_delete_set_message_plural': 'Do you really want to delete these <strong>{{count}}</strong> sets?',
	'modal_delete_set_info': 'The skills within this set will not be deleted.',
	'modal_delete_set_info_plural': 'The skills within these sets will not be deleted.',
	'modal_confirmation_title': 'Are you sure?',
	'modal_change_hub_status_title': 'Change hub status',
	'modal_confirm_type_change_title': 'Change file type?',
	'modal_confirm_type_change_message': 'This file is a different type to the original file. Are you sure that you want to replace the file?',
	'modal_upload_failed_title': 'Upload failed',
	'modal_upload_failed_message': 'There was an error when trying to upload "{{name}}".',
	'modal_upload_failed_cta': 'Please try again.',
	'modal_processing_failed_title': 'Processing failed',
	'modal_processing_failed_message': 'There was an error when trying to process the file "{{name}}".',
	'modal_processing_failed_cta': 'Please upload a new file or delete the asset.',
	'modal_processing_failed_while_editing_cta': 'Please upload a new file.',
	'modal_playlist_completion_message_with_badge': 'Playlist completed, you have unlocked the <strong>"{{name}}"</strong> badge!',
	'modal_playlist_completion_message_no_badge': 'You have completed the <strong>"{{name}}"</strong> playlist!',
	'modal_smart_team_member_heading_message': 'At this moment, your Smart team has 1 member.',
	'modal_smart_team_member_heading_message_plural': 'At this moment, your Smart team has {{count}} members.',
	'modal_reset_assets_mark_as_done_manually_message': 'You are about to set {{count}} assets to be manually marked as done, are you sure that you want to proceed?',
	'modal_reset_assets_mark_as_done_automatically_message': 'You are about to set {{count}} assets to be automatically marked as done, are you sure that you want to proceed?',
	'modal_allow_content_contribution_title': 'Allowing asset contributions',
	'modal_allow_content_contribution_intro': 'By default, playlists can only be edited by admins with the “Playlists & Topics” permission. If the playlist has an owning team, its managers can edit it, too.',
	'modal_allow_content_contribution_abilities_included_subheading': 'The option “Allow everyone in audience to add and edit their own assets” will give everyone with access to the playlist these <strong>basic content contribution abilities: </strong>',
	'modal_allow_content_contribution_abilities_included_upload_files': 'Upload files or add web links to the playlist',
	'modal_allow_content_contribution_abilities_included_edit_delete_content': 'Edit or delete assets that they added',
	'modal_allow_content_contribution_abilities_included_reorder_content': 'Reorder the playlist’s content',
	'modal_allow_content_contribution_abilities_excluded_subheading': 'Not included are the following abilities:',
	'modal_allow_content_contribution_abilities_excluded_edit_name': 'Edit the playlist’s name, image, or other details',
	'modal_allow_content_contribution_abilities_excluded_edit_delete_content': 'Edit or delete content that wasn’t added by them',
	'modal_allow_content_contribution_abilities_excluded_add_sections': 'Add sections or content from other playlists',
	'modal_allow_content_contribution_abilities_excluded_view_analytics': 'View analytics around the content they added',
	'modal_action_can_not_be_reverted': 'This action can’t be reverted.',
	'modal_optional_content_title': 'Making content completion optional',
	'modal_optional_content_intro': 'By default, a playlist is complete when all content within it was completed. To loosen that requirement, you can make the completion of individual items optional.',
	'modal_optional_content_info_1': 'Optional items are not counted towards a person’s playlist progress.',
	'modal_optional_content_info_2': 'Optional items don’t have to be opened or completed for people to complete the parent playlist.',
	'modal_optional_content_outro': 'This option can be set individually for each item of a playlist. An item can be optional in one playlist and required in another.',
	'modal_change_optional_content_title': 'Change of permissions',
	'modal_change_optional_content_1': 'If you change them to be <strong>required</strong> then they will inherit the parent’s permissions.',
	'modal_change_optional_content_2': 'Leaving them as <strong>optional</strong> won’t inherit any permissions and anyone who doesn’t have access will not see the playlist.',
	'modal_change_optional_content_3': 'Would you like to continue changing them to be required?',
	'modal_circular_reference_title': 'Playlists will be added as optional',
	'modal_circular_reference_intro': 'The following playlists contain the playlist you are adding them to:',
	'modal_circular_reference_outro': 'As circular references to required playlists are not permitted, they will be added as optional content.',
	'modal_playlist_link_permission_message_1': 'The following playlists have limited access permissions compared to the parent playlist.',
	'modal_playlist_link_permission_message_2': 'If you add them as <strong>required</strong> then they will inherit the parent’s permissions.',
	'modal_playlist_link_permission_message_3': 'Adding them as <strong>optional</strong> won’t inherit any permissions and anyone who doesn’t have access will not see the playlist.',
	'modal_how_to_add': 'How would you like to add them?',
	'modal_restore_circular_reference_playlist_message': 'This playlist has been made optional to prevent a circular reference from being created.',
	'modal_reset_language_message': 'Changing the language to <strong>Auto</strong> will cause the Subject and Message for all shares and reminders to be reset to the default.',
	'modal_reset_language_confirmation': 'Are you sure that you would like to proceed?',
	'modal_unsaved_changes_description': 'The page you are on has unsaved changes.',
	'modal_unsaved_changes_without_submit_description': 'The page you are on has unsaved changed that can not be submitted yet.',
	'modal_asset_admin_edit_event_sessions_aria_label': 'Manage session for event {{name}}',
	'modal_asset_admin_manage_sessions_title': 'Manage sessions for {{name}}',
	'modal_delete_access_key_title': 'Delete access key',
	'modal_delete_access_key_title_plural': 'Delete access keys',
	'modal_delete_access_key_message': 'Deleting will prevent the access key from being accessed',
	'modal_delete_access_key_message_plural': 'Deleting these will prevent the access keys from being accessed',
	'modal_emailaddress_edit_title': 'Change member email address',
	'modal_emailaddress_edit_description': 'Change this member\'s email to <strong>{{email}}</strong>.',
	'modal_emailaddress_edit_description_plural': 'Change this member\'s email to <strong>{{email}}</strong>. This will change their email address across all {{count}} hubs they are a member of.',
	'modal_emailaddress_edit_forbidden': 'Unfortunatly, you do not have the authority across all of the hubs this user is a member of, please contact support@5app.com',
	'modal_unsubscribe_content_comments_title': 'Unsubscribe from all content subscriptions',
	'modal_unsubscribe_content_comments_body_1': 'Unsubscribe from all current asset and playlist subscriptions.',
	'modal_unsubscribe_content_comments_body_2': 'You will no longer receive comment updates for these.',
	'modal_disconnect_calendar_microsoft_title': 'Disconnect your Microsoft calendar?',
	'modal_disconnect_calendar_google_title': 'Disconnect your Google calendar?',
	'modal_disconnect_calendar_message_1': 'Once your calendar is disconnected, you will no longer be able to set Helix to auto-join your events.',
	'modal_disconnect_calendar_message_2': 'You can reconnect your calendar and set Helix to auto-join your events again at any time.',
	'modal_delete_session_title': 'Delete session',
	'modal_delete_session_message': 'Do you really want to delete this session?',
	'modal_add_knowledge_bank_to_team_title': 'Add a knowledge bank to a team',
	'modal_add_knowledge_bank_to_team_message_1': 'To give members of this team access to a knowledge bank, either add the UID from the Mindset platform, or click the "Add" button to automatically create one in Mindset.',
	'modal_add_knowledge_bank_to_team_message_2': 'Hub content will be synced with the knowledge bank the next time the process runs.',
	'modal_coach_knowledge_bank_message_1': 'The Coach will use assets from this team\'s playlists to answer questions for members of this team.',
	'modal_coach_knowledge_bank_message_2': 'Content from their other team memberships will not be included unless those teams also have an active knowledge bank.',
	'modal_create_team_knowledge_bank_title': 'Create knowledge bank in Mindset',
	'modal_create_team_knowledge_bank_message_1': 'This will create a knowledge bank in Mindset and synchronise all data visible to this team.',
	'modal_create_team_knowledge_bank_message_2': 'Are you sure you want to continue?',
	'modal_confirm_attendees_title_member': 'Confirm member selection',
	'modal_confirm_attendees_title_team': 'Confirm team member selection',
	'modal_confirm_attendees_message': 'You are about to add <strong>{{count}}</strong> member to the session.',
	'modal_confirm_attendees_message_plural': 'You are about to add <strong>{{count}}</strong> members to the session.',
	'modal_confirm_attendees_alert_booking_conflict': '<strong>{{count}}</strong> selected member is already booked on another session for this event. Adding them will cancel them from the other session.',
	'modal_confirm_attendees_alert_booking_conflict_plural': '<strong>{{count}}</strong> selected members are already booked on another session for this event. Adding them will cancel them from the other session.',
	'modal_confirm_attendees_alert_over_session_capacity': 'The session capacity is <strong>{{sessionCapacity}}</strong>. Adding this member will bring to total to <strong>{{count}}</strong>.',
	'modal_confirm_attendees_alert_over_session_capacity_plural': 'The session capacity is <strong>{{sessionCapacity}}</strong>. Adding these members will bring to total to <strong>{{count}}</strong>.',
	'modal_confirm_attendees_alert_no_members': 'No members from the selection can be assigned to this session.',
	'modal_confirm_attendees_alert_no_members_plural': 'No members from the selection can be assigned to this session.',
	'modal_confirm_attendees_already_booked_members_title': 'Already booked members:',
	'modal_confirm_attendees_no_access_members_title': 'Team members without access:',
	'modal_confirm_attendees_alert_partial_members': '<strong>{{count}}</strong> member from your selection does not have access to this event and will not be added.',
	'modal_confirm_attendees_alert_partial_members_plural': '<strong>{{count}}</strong> members from your selection do not have access to this event and will not be added.',
	'modal_update_attendees_title': 'Update attendance status',
	'modal_update_attendees_alert_booking_conflict_booked': '<strong>{{count}}</strong> selected member is already booked on another session for this event. Setting their status to "booked" will cancel them from the other session.',
	'modal_update_attendees_alert_booking_conflict_booked_plural': '<strong>{{count}}</strong> selected members are already booked on another session for this event. Setting their status to "booked" will cancel them from the other session.',
	'modal_update_attendees_alert_booking_conflict_attended': '<strong>{{count}}</strong> selected member is already booked on another session for this event. Setting their status to "attended" will cancel them from the other session.',
	'modal_update_attendees_alert_booking_conflict_attended_plural': '<strong>{{count}}</strong> selected members are already booked on another session for this event. Setting their status to "attended" will cancel them from the other session.',
	'modal_update_attendees_alert_over_session_capacity': 'The session capacity is <strong>{{sessionCapacity}}</strong>. Updating this member will bring to total to <strong>{{count}}</strong>.',
	'modal_update_attendees_alert_over_session_capacity_plural': 'The session capacity is <strong>{{sessionCapacity}}</strong>. Updating these members will bring to total to <strong>{{count}}</strong>.',
	'modal_upload_meeting_transcript_message_1': '<0>Click</0> or drag and drop to upload a meeting transcript file.',
	'modal_upload_meeting_transcript_message_2': 'Accepted formats are PDF, DOC, DOCX, VTT, TXT or SRT.',
	'modal_upload_meeting_transcript_title': 'Upload a meeting transcript',
	'modal_upload_meeting_transcript_cta': '<0>Click</0> or drag and drop to replace file.',
	'role_selector_title': 'Role',
	'role_selector_loading': 'Loading roles…',
	'role_selector_hint_own_role': 'You can not change your own role.',
	'role_selector_hint_no_permission': 'You do not have permission to change the role of this user.',
	'select_from_options': 'Select from options...',
	'thumbnail_guideline_playlists_title': 'Guidelines for Playlist cover images:',
	'thumbnail_guideline_playlists_recommendation_1': 'Image size recommended between 1200x300 and 1200x600 pixels.',
	'thumbnail_guideline_playlists_recommendation_2': 'Avoid text in images unless purely decorative.',
	'thumbnail_guideline_playlists_recommendation_3': 'Images will be cropped to fit each format. Edges might be cut.',
	'thumbnail_guideline_playlists_recommendation_4': 'Resize your browser window or turn your phone to landscape view to preview how your image will appear across different screen sizes.',
	'thumbnail_playlist_size_title': 'Playlist size',
	'thumbnail_playlist_size_description': 'Displayed at the top of the <strong>Playlist</strong> page.',
	'thumbnail_playlist_content_size_title': 'Playlist content size',
	'thumbnail_playlist_content_size_description': 'Displayed on the <strong>Playlist</strong> and <strong>Search results</strong> page.',
	'thumbnail_billboard_size_title': 'Billboard size',
	'thumbnail_billboard_size_description': 'Displayed at the top of the <strong>Home</strong> page.',
	'thumbnail_standard_card_size_title': 'Standard size',
	'thumbnail_standard_card_size_description': 'Displayed on <strong>every</strong> page.',
	'thumbnail_large_card_size_title': 'Large size',
	'thumbnail_large_card_size_description': 'Displayed on the <strong>Home</strong> and <strong>Profile</strong> page.',
	'thumbnail_preview_asset_card': 'Asset card',
	'thumbnail_preview_asset_list_card': 'Asset list card',
	'thumbnail_preview_size_shared_asset_billboard': 'Shared asset, "billboard" size',
	'thumbnail_preview_item_image_preview': '{{itemName}} image preview',
	'thumbnail_preview_aspect_ratio_flexible': 'flexible',
	'thumbnail_preview_aspect_ratio': 'Aspect ratio',
	'thumbnail_preview_recommended_file_size': 'Recommended source file size (pixels)',
	'thumbnail_preview_view_guide': 'Please also view the <1>Content Artwork Guide</1> on our website and resize your browser window to preview what these components look like across different screen sizes.',
	'thumbnail_image_options': 'Image options',
	'drag_drop_instructions': 'Press space bar to start a drag. When dragging you can use the arrow keys to move the item up or down and escape to cancel.',
	'drag_drop_drag_started': 'You have lifted an item in position {{position}} of {{total}}',
	'drag_drop_dragging': 'You have moved the item from position {{startPosition}} to position {{position}} of {{total}}',
	'drag_drop_dragging_outside_area': 'You are currently not dragging over a droppable area',
	'drag_drop_drag_ended': 'You have dropped the item. It has moved from position {{startPosition}} to {{endPosition}} of {{total}}',
	'drag_drop_drag_ended_outside_area': 'The item has been dropped while not over a droppable location. The item has returned to its starting position of {{startPosition}}',
	'drag_drop_drag_cancelled': 'Movement cancelled. The item has returned to its starting position of {{startPosition}}',
	'panel_owning_team_description_asset_plural': 'Managers of the owning team will be able to edit these assets.',
	'panel_owning_team_description_asset': 'Managers of the owning team will be able to edit this asset.',
	'panel_owning_team_description_playlists': 'Managers of the owning team will be able to edit these playlists. You can only select an owning team who has access to the playlists.',
	'panel_owning_team_description_playlist': 'Managers of the owning team will be able to edit this playlist. You can only select an owning team who has direct access to the playlist.',
	'panel_visibility_title': 'Who can see this?',
	'panel_visibility_hint': 'Permissions have been altered by adding this playlist to another playlist. Click edit to see details.',
	'panel_visibility_subtitle_this_playlist': 'Permissions from this playlist',
	'panel_visibility_subtitle_other_playlists': 'Permissions from other playlists',
	'panel_autoshare_title_colon': 'Auto-share this with:',
	'panel_autoshare_disabled_info': 'Auto-sharing is disabled until assets are added to this playlist.',
	'panel_autoshare_description': 'Auto-sharing with everyone or all existing members of a team plus anyone who joins the team in the future. You can only auto-share with teams who have direct access to the playlist.',
	'panel_other_domains_title': 'Other domains',
	'panel_other_domains_none_info': 'This playlist has not been distributed to any other domains.',
	'panel_other_domains_none_info_plural': 'These playlists have not been distributed to any other domains.',
	'panel_additional_options_title': 'Additional options',
	'panel_description_title': 'Description',
	'panel_topics_description': 'Greyed-out topics don’t apply to all selected playlists.',
	'panel_tags_description': 'Greyed-out tags don’t apply to all selected playlists.',
	'panel_language_title': 'Language',
	'panel_language_none_info': 'No language selected.',
	'panel_playlist_stats_title': 'Playlist stats',
	'panel_asset_stats_title': 'Asset stats',
	'panel_type_title': 'Type',
	'panel_type_info': 'You are unable to change the type of line manager teams',
	'panel_type_multiple_selected': 'Multiple selected',
	'panel_parent_playlists_title': 'Used in these playlists',
	'panel_asset_in_playlist_none_info': 'This asset has not been added to any playlists yet.',
	'panel_parent_playlist_none_info': 'This playlist has not been added to any playlists.',
	'panel_completion_time_title': 'Completion time',
	'panel_content_nudges_none_info': 'This content isn\'t used in any nudges.',
	'panel_file_download_info_colon': 'Downloading the original file is:',
	'panel_alt_text_title': 'Alt text',
	'panel_custom_fields': 'Custom fields',
	'panel_employee_id_title': 'Employee Id',
	'panel_public_link_title': 'Web link',
	'panel_public_link_info_one': 'Insecure URLs starting with http:// can’t be embedded.',
	'panel_public_link_info_two': 'Change the URL to start with https:// to enable embedding.',
	'panel_autoshared_with_title': 'Auto-shared with {{name}}',
	'panel_autoshared_with_everyone': 'everyone',
	'panel_autoshared_with_none': 'No auto-shared playlists.',
	'panel_team_types_title': 'Team types',
	'panel_user_name_title': 'Name',
	'panel_role_title': 'Role',
	'panel_role_info': 'Role details',
	'panel_profile_title': 'Profile',
	'panel_permissions_title': 'Permissions',
	'panel_permissions_hint_admin': 'In addition to these permissions, admins are also able to view (not change) the settings of this hub.',
	'panel_permissions_hint_owner': 'In addition to these permissions, owners are also able to change the settings of this hub.',
	'panel_folder_stats_title': 'Folder stats',
	'panel_subtitles_language_title': 'Subtitles language',
	'panel_member_contribution': 'Member contribution',
	'panel_member_contribution_description': 'Allow anyone with access to this playlist to create and edit their own assets in the playlist',
	'panel_member_contribution_hint': 'This option has moved and can now be found in “Additional options” under the “Details” tab',
	'panel_smart_team_rules_title': 'Membership rules',
	'panel_smart_team_rules_include': 'Include',
	'panel_smart_team_rules_exclude': 'Exclude',
	'panel_linked_teams_title': 'Linked smart teams',
	'panel_linked_included_smart_teams': 'Included in',
	'panel_linked_excluded_smart_teams': 'Excluded from',
	'panel_mark_as_done_explanation_title': 'How does “Automatic mark as done” work?',
	'panel_mark_as_done_title': 'Mark as done',
	'panel_mark_as_done_explanation_introduction_colon': 'This setting controls whether people have to manually click “Mark as done” to mark content as completed, or whether this is done automatically based on the following rules:',
	'panel_mark_as_done_explanation_rule1': 'Video and audio: marked as complete after 95% has been played',
	'panel_mark_as_done_explanation_rule2': 'SCORM course: marked as complete according to its built-in completion criteria',
	'panel_mark_as_done_explanation_rule3': 'Other assets: marked as complete when opened for at least 5 seconds',
	'panel_mark_as_done_selector_title': 'Select the mode of Mark As Done',
	'panel_mark_as_done_explanation_changing_default_setting': 'Changing the default setting will only change new assets added to the hub, the Update button will change all assets to the default setting.',
	'panel_curation_checklist_title': 'Curation checklist',
	'panel_in_parent_playlist_title': 'In parent playlist',
	'panel_veecreate_info_title': 'VeeCreate content',
	'panel_veecreate_info_description': 'You don\'t have a licence to edit this content.',
	'custom_field_editable_by_users_colon': 'Editable by users:',
	'custom_field_required_colon': 'Required:',
	'custom_field_wizard_title_edit': 'Edit custom field',
	'custom_field_wizard_title_new': 'New custom field',
	'custom_field_wizard_hint': 'Custom fields allow you to add bespoke metadata fields (e.g. employee ID or department) to the user records of this hub. This data can be used for filtering or other uses and will also appear in user reports.',
	'custom_field_wizard_label': 'Label',
	'custom_field_wizard_label_placeholder': 'e.g. Department, Employee ID',
	'custom_field_wizard_label_hint': 'Maximum 32 characters',
	'custom_field_wizard_type': 'Type',
	'custom_field_wizard_single_line_text': 'Single-line text',
	'custom_field_wizard_visibility_title': 'Visibility and access',
	'custom_field_wizard_visibility_option_admin': 'Only admins can see & set the value of this field',
	'custom_field_wizard_visibility_option_user': 'Users can see & set the value of this field',
	'custom_field_wizard_require_title': 'Require field',
	'custom_field_wizard_require_info': 'Require users to fill this in when they next log in',
	'custom_field_wizard_hint_title': 'Hint text',
	'custom_field_wizard_hint_info': 'Add a hint text (just like this one) to the field to help users fill it in correctly, or to explain why you’re collecting this information.',
	'panel_tab_details': 'Details',
	'panel_tab_access': 'Access',
	'panel_tab_analytics': 'Analytics',
	'panel_tab_content': 'Content',
	'panel_tab_share_and_nudge': 'Share & nudge',
	'panel_tab_sessions': 'Sessions',
	'panel_tab_attendees': 'Attendees',
	'property_name': 'Name',
	'property_id': 'Id',
	'property_first_name': 'First name',
	'property_last_name': 'Last name',
	'property_email': 'Email',
	'property_email_subject': 'Email subject',
	'property_email_message': 'Email message',
	'property_last_update': 'Last update',
	'property_visibility': 'Visibility',
	'property_asset': 'Asset',
	'property_asset_count': 'Asset count',
	'property_asset_name': 'Asset name',
	'property_author': 'Author',
	'property_team_id': 'Team id',
	'property_user_count': 'User count',
	'property_user_name': 'User name',
	'property_last_active': 'Last active',
	'property_audience': 'Audience',
	'property_trigger': 'Trigger',
	'property_offset': 'Offset',
	'property_status': 'Status',
	'property_status_colon': 'Status:',
	'property_attendance_status': 'Attendance status',
	'property_attendance_status_colon': 'Attendance status:',
	'property_progress': 'Progress',
	'property_action': 'Action',
	'property_date_device': 'Date / device',
	'property_date': 'Date',
	'property_date_colon': 'Date:',
	'property_send_time': 'Send time',
	'property_opens': 'Opens',
	'property_value': 'Value',
	'property_tag': 'Tag',
	'property_type': 'Type',
	'property_type_colon': 'Type:',
	'property_nudge_name': 'Nudge name',
	'property_colour': 'Colour',
	'property_role_name': 'Role name',
	'property_role_permissions': 'Role permissions',
	'property_role': 'Role',
	'property_file': 'File',
	'property_file_size': 'File size',
	'property_file_size_colon': 'File size:',
	'property_file_name': 'File name',
	'property_file_name_colon': 'File name:',
	'property_new_section_name': 'New section name',
	'property_new_subsection_name': 'New subsection name',
	'property_last_updated': 'Last updated',
	'property_last_updated_colon': 'Last updated:',
	'property_last_used': 'Last used',
	'property_new_window': 'New window',
	'property_new_field': 'New field',
	'property_title': 'Title',
	'property_timezone': 'Time zone',
	'property_subject': 'Subject',
	'property_subject_colon': 'Subject:',
	'property_message': 'Message',
	'property_message_type': 'Message type',
	'property_occurrences': 'Occurrences',
	'property_time': 'Time',
	'property_time_colon': 'Time:',
	'property_summary': 'Summary',
	'property_recipient': 'Recipient',
	'property_team_name': 'Team name',
	'property_team_name_plural': 'Team names',
	'property_team_type': 'Team type',
	'property_auto_share_audience_teams': 'Auto-share audience teams',
	'property_thumbnail': 'Thumbnail',
	'property_greyed_out': '{{content}} (greyed out)',
	'property_user': 'User',
	'property_changes': 'Changes',
	'property_changed_by': 'Changed by',
	'property_changed_on': 'Changed on',
	'property_employee_id': 'Employee ID',
	'property_language': 'Language',
	'property_details': 'Details',
	'property_goal_type': 'Goal type',
	'property_target_type': 'Target type',
	'property_target_date': 'Target date',
	'property_target_date_colon': 'Target date:',
	'property_due_date': 'Due date',
	'property_achievement_date': 'Achievement date',
	'property_target_offset': 'Target offset',
	'property_target_offset_unit': 'Target offset unit',
	'property_repetition_offset': 'Repetition offset',
	'property_repetition_offset_unit': 'Repetition offset unit',
	'property_scheduled_type': 'Scheduled type',
	'property_scheduled_offset': 'Scheduled offset',
	'property_scheduled_offset_unit': 'Scheduled offset unit',
	'property_scheduled_date': 'Scheduled date',
	'property_scheduled_time': 'Scheduled time',
	'property_accesstoken': 'Access Token',
	'property_scope': 'Scope',
	'property_scope_description': 'Access Key is permited on URL pathnames beginning with the value provided here',
	'property_signature': 'Signature',
	'property_repeat_frequency': 'Repeat frequency',
	'property_associated_playlists_colon': 'Associated playlists:',
	'property_template_language_colon': 'Template language:',
	'property_hint_colon': 'Hint:',
	'property_step_colon': 'Step {{count}}:',
	'property_metrics_time_frame': 'Time frame',
	'property_metrics_time_frame_colon': 'Time frame:',
	'property_created_date': 'Created date',
	'property_member': 'Member',
	'property_missing_brackets': '(missing)',
	'property_present_brackets': '(present)',
	'property_changelog': 'Changelog',
	'property_user_changelog': 'User changelog',
	'property_content_changelog': 'Content changelog',
	'property_nudge_changelog': 'Nudge changelog',
	'property_team_changelog': 'Team changelog',
	'property_skills_changelog': 'Skills changelog',
	'property_logs': 'Logs',
	'property_user_import_log': 'User import log',
	'property_message_log': 'Message log',
	'property_file_format': 'File format',
	'property_customisable': 'Customisable',
	'property_playlist_info': 'Playlist info',
	'property_asset_info': 'Asset info',
	'property_set_info': 'Set info',
	'property_common': 'Common',
	'property_individual': 'Individual',
	'property_dates': 'Dates',
	'property_rank': 'Rank',
	'property_platform_announcement': 'Platform announcement',
	'property_completion_date': 'Completion date',
	'property_settings': 'Settings',
	'property_success': 'Success',
	'property_not_sharing': 'Not sharing',
	'property_hubs': 'Hubs',
	'property_optional_content': 'Optional content',
	'property_relevant_quotes_colon': 'Relevant quotes:',
	'property_suggestions_colon': 'Suggestions:',
	'property_suggestions': 'Suggestions',
	'property_weekly_progression': 'Weekly progression',
	'property_week_overview': 'Week overview',
	'property_all': 'All',
	'property_positive': 'Positive',
	'property_negative': 'Negative',
	'property_positive_relevant_quotes': 'Positive relevant quotes',
	'property_negative_relevant_quotes': 'Negative relevant quotes',
	'property_helix_info': 'Helix info',
	'property_days_until_due': 'Days until due',
	'property_google_calendar': 'Google calendar',
	'property_microsoft_calendar': 'Microsoft calendar',
	'property_no_owner': 'No owner',
	'property_start_date': 'Start date',
	'property_start_time': 'Start time',
	'property_end_time': 'End time',
	'property_location': 'Location',
	'property_location_colon': 'Location:',
	'property_attendees': 'Attendees',
	'property_actions': 'Actions',
	'property_capacity': 'Capacity',
	'property_in_person': 'In person',
	'property_virtual': 'Virtual',
	'property_reference': 'Reference',
	'property_event_details': 'Event details',
	'property_due_date_colon': 'Only with due date:',
	'stats_like': 'Like',
	'stats_like_plural': 'Likes',
	'stats_open': 'Open',
	'stats_open_plural': 'Opens',
	'stats_save': 'Save',
	'stats_save_plural': 'Saves',
	'stats_comment': 'Comment',
	'stats_comment_plural': 'Comments',
	'stats_completed': 'Completed',
	'stats_completed_plural': 'Completed',
	'stats_saved': 'Saved',
	'stats_in_progress': 'In progress',
	'stats_global_empty_title': 'No data to display… yet :)',
	'stats_global_empty_content': 'Start adding <1>assets</1> to your Digital Hub to bring your analytics to life',
	'stats_count_new': '{{count}} new',
	'stats_count_deleted': '{{count}} deleted',
	'stats_count_updated': '{{count}} updated',
	'stats_count_new_memberships': '{{count}} new memberships',
	'stats_count_revoked_memberships': '{{count}} revoked memberships',
	'chart_name_desktop': 'desktop',
	'chart_name_mobile': 'mobile',
	'chart_name_total': 'total',
	'subtitles_file': 'Subtitles file',
	'subtitles_video': 'Video subtitles',
	'subtitles_none_uploaded': 'No subtitles uploaded',
	'subtitles_file_add': 'Add subtitles file (.vtt)',
	'subtitles_file_drop_to_upload': 'Drop file here to upload (file format .vtt)',
	'subtitles_drop_and_replace': '<0>Click</0> or drag and drop to replace',
	'subtitles_drop_and_upload': '<0>Click</0> or drag and drop to upload subtitles (file format .vtt).',
	'nudges_empty_state': 'No nudges have been added yet.',
	'nudges_count_show_more': '{{count}} more',
	'nudges_multiple_selected_title': '{{count}} nudges selected',
	'nudge_edit_save_disabled_info': 'Enter a name and resolve any errors to be able to save the nudge',
	'nudge_add_save_disabled_info': 'Enter a name to be able to save the nudge',
	'nudges_disable_all_info': 'Not available because all selected nudges are already disabled.',
	'nudges_enable_all_info': 'Not available because all selected nudges are already enabled.',
	'nudges_enable_all_incomplete_info': 'Not available because some selected nudges are incomplete.',
	'nudges_general_title': 'General',
	'nudge_goal_title': 'Goal',
	'nudge_goal_info': 'What would you like people to do?',
	'nudge_language_hint': 'Selecting a language will allow you to customise notification messaging.',
	'nudge_timezone_hint': 'Select the time zone used for sending messages. This will automatically update with daylight savings.',
	'nudge_timezone_none_hint': 'Select the time zone used for sending messages. Messages will be sent in UTC until then.',
	'nudge_goal_hint': 'Select whether people have to open or complete all selected content to meet the goal of this nudge.',
	'nudge_type_login_first_time_reminder': 'Log in for the first time',
	'nudge_type_login_again_reminder': 'Log in again',
	'nudge_type_content_reminder': 'Open or complete content',
	'nudge_name_scheduled_share': 'Scheduled share',
	'nudge_name_registration_reminder': 'Registration reminder',
	'nudge_name_log_in_first_time': 'Registration reminder',
	'nudge_name_inactivity_reminder': 'Inactivity reminder',
	'nudge_name_log_in_again': 'Inactivity reminder',
	'nudge_name_uncompleted_reminder': 'Uncompleted reminder',
	'nudge_name_complete_content': 'Uncompleted reminder',
	'nudge_name_unknown': 'Unknown email template',
	'nudge_step_general_panel': 'Complete the general information',
	'nudge_step_content_action': 'Enable one or more actions',
	'nudge_step_login_action': 'Set-up a reminder',
	'nudge_none_selected': 'No nudge selected',
	'nudge_none_selected_info': 'Nudges allow you to automatically message people to encourage them to complete a specific goal.',
	'nudge_none_selected_action': 'You can select a nudge or <1>add a new one</1>.',
	'nudge_audience_common': 'Common',
	'nudge_audience_common_hint': 'This audience applies to all selected nudges',
	'nudge_audience_individual': 'Individual',
	'nudge_audience_individual_hint': 'This audience applies to some, but not all selected nudges',
	'nudge_trigger_log_label_get_started': 'User has not registered',
	'nudge_trigger_log_label_multi': 'Multiple selected nudges',
	'nudge_panel_reminders': 'Reminder',
	'nudge_panel_reminders_plural': 'Reminders',
	'nudge_panel_count_reminders': '{{count}} reminder',
	'nudge_panel_count_reminders_plural': '{{count}} reminders',
	'nudge_panel_title_edit_reminder': 'Edit reminder',
	'nudge_panel_title_remind_and_target_date': 'Set target date and remind',
	'nudge_panel_description_remind_open': 'Notify members who have not opened the content and set a target date.',
	'nudge_panel_description_remind_complete': 'Notify members who have not completed the content and set a target date.',
	'nudge_panel_title_set_target_date': 'Set target date',
	'nudge_panel_description_target_date_open': 'This is the date by which you want your audience to have opened this nudge’s content.',
	'nudge_panel_description_target_date_complete': 'This is the date by which you want your audience to have completed this nudge’s content.',
	'nudge_panel_description_share_open': 'Notify everyone in audience (regardless of whether they have opened the content)',
	'nudge_panel_description_share_complete': 'Notify everyone in audience (regardless of whether they have completed the content)',
	'nudge_panel_description_reset_status': 'Schedule content status to be reset to "Not started"',
	'nudge_panel_last_nudge_date': 'Last nudge date',
	'nudge_panel_last_login_date': 'Last login date',
	'nudge_panel_invite_date': 'Invite date',
	'nudge_panel_user_created_date': 'User created date',
	'nudge_panel_subtitle_repeat_reminder': 'Repeat reminder',
	'nudge_panel_subtitle_repeat_every': 'Repeat every',
	'nudge_panel_subtitle_send_to': 'Send to',
	'nudge_panel_invite_days': 'day after invite',
	'nudge_panel_invite_days_plural': 'days after invite',
	'nudge_panel_invite_weeks': 'week after invite',
	'nudge_panel_invite_weeks_plural': 'weeks after invite',
	'nudge_panel_login_day': '1 day after login',
	'nudge_panel_login_day_plural': '{{count}} days after login',
	'nudge_panel_login_week': '1 week after login',
	'nudge_panel_login_week_plural': '{{count}} weeks after login',
	'nudge_panel_last_login_days': 'day after last login',
	'nudge_panel_last_login_days_plural': 'days after last login',
	'nudge_panel_last_login_weeks': 'week after last login',
	'nudge_panel_last_login_weeks_plural': 'weeks after last login',
	'nudge_panel_after_last_completion': 'after last completion',
	'nudge_panel_note_max_repetition': '(max 5 repetitions)',
	'nudge_panel_invite_day': '{{count}} day after invite',
	'nudge_panel_invite_day_plural': '{{count}} days after invite',
	'nudge_panel_invite_week': '{{count}} week after invite',
	'nudge_panel_invite_week_plural': '{{count}} weeks after invite',
	'nudge_analytics_time_period_days': 'Last {{count}} days',
	'nudge_analytics_time_period_year': 'Last year',
	'nudge_panel_time_unit': 'Time unit',
	'nudge_panel_repetition_time_unit': 'Repetition time unit',
	'nudge_panel_before_target_date': 'before target date',
	'nudge_panel_days_before_target': 'day before target date',
	'nudge_panel_days_before_target_plural': 'days before target date',
	'nudge_panel_days_after_target': 'day after target date',
	'nudge_panel_days_after_target_plural': 'days after target date',
	'nudge_panel_weeks_before_target': 'week before target date',
	'nudge_panel_weeks_before_target_plural': 'weeks before target date',
	'nudge_panel_weeks_after_target': 'week after target date',
	'nudge_panel_weeks_after_target_plural': 'weeks after target date',
	'nudge_panel_edit_target_date': 'Edit target date',
	'nudge_panel_count_day_before_target': '1 day before target date',
	'nudge_panel_count_day_before_target_plural': '{{count}} days before target date',
	'nudge_panel_count_day_after_target': '1 day after target date',
	'nudge_panel_count_day_after_target_plural': '{{count}} days after target date',
	'nudge_panel_count_week_after_target': '1 week after target date',
	'nudge_panel_count_week_after_target_plural': '{{count}} weeks after target date',
	'nudge_panel_on_target_date': 'On target date',
	'nudge_panel_on_due_date': 'On due date',
	'nudge_panel_text_show_as_due_date': 'Show as due date',
	'nudge_share_panel_hint_use_email_template': 'This notification uses the <1><0>"{{emailTemplate}}"</0></1> email template.',
	'nudge_member_remind_panel_hint_use_email_template': 'This reminder uses the <1><0>"{{emailTemplate}}"</0></1> email template.',
	'nudge_content_remind_panel_hint_use_email_template': 'This reminder uses the <1><0>"{{emailTemplate}}"</0></1> email template.',
	'nudge_share_panel_hint_select_language': 'To customise subject and message, please <1>select a language</1> for this nudge.',
	'nudge_hint_custom_email_data': 'A custom subject or message was previously set using the old nudge page but it can\'t be changed as no language has been selected.',
	'nudge_hint_update_custom_email_data': 'To update the customised subject and message, please <1>select a language</1> for this nudge.',
	'nudge_hint_target_repetition_will_be_discarded': 'Only nudges with "Complete content" goal can have repeating target dates. The target date repetition will be discarded for this nudge.',
	'nudge_hint_timeline_order': 'Action order might differ from timeline preview.',
	'nudge_remind_panel_days_after_account_creation': 'day after account creation',
	'nudge_remind_panel_days_after_account_creation_plural': 'days after account creation',
	'nudge_remind_panel_weeks_after_account_creation': 'week after account creation',
	'nudge_remind_panel_weeks_after_account_creation_plural': 'weeks after account creation',
	'nudge_remind_panel_months_after_account_creation': 'month after account creation',
	'nudge_remind_panel_months_after_account_creation_plural': 'months after account creation',
	'nudge_remind_panel_years_after_account_creation': 'year after account creation',
	'nudge_remind_panel_years_after_account_creation_plural': 'years after account creation',
	'nudge_remind_panel_days_after_joining_audience': 'day after joining audience',
	'nudge_remind_panel_days_after_joining_audience_plural': 'days after joining audience',
	'nudge_remind_panel_weeks_after_joining_audience': 'week after joining audience',
	'nudge_remind_panel_weeks_after_joining_audience_plural': 'weeks after joining audience',
	'nudge_remind_panel_months_after_joining_audience': 'month after joining audience',
	'nudge_remind_panel_months_after_joining_audience_plural': 'months after joining audience',
	'nudge_remind_panel_years_after_joining_audience': 'year after joining audience',
	'nudge_remind_panel_years_after_joining_audience_plural': 'years after joining audience',
	'nudge_remind_panel_count_days_after_account_creation': '1 day after account creation',
	'nudge_remind_panel_count_days_after_account_creation_plural': '{{count}} days after account creation',
	'nudge_remind_panel_count_weeks_after_account_creation': '1 week after account creation',
	'nudge_remind_panel_count_weeks_after_account_creation_plural': '{{count}} weeks after account creation',
	'nudge_remind_panel_count_months_after_account_creation': '1 month after account creation',
	'nudge_remind_panel_count_months_after_account_creation_plural': '{{count}} months after account creation',
	'nudge_remind_panel_count_years_after_account_creation': '1 year after account creation',
	'nudge_remind_panel_count_years_after_account_creation_plural': '{{count}} years after account creation',
	'nudge_remind_panel_count_days_after_joining_audience': '1 day after joining audience',
	'nudge_remind_panel_count_days_after_joining_audience_plural': '{{count}} days after joining audience',
	'nudge_remind_panel_count_weeks_after_joining_audience': '1 week after joining audience',
	'nudge_remind_panel_count_weeks_after_joining_audience_plural': '{{count}} weeks after joining audience',
	'nudge_remind_panel_count_months_after_joining_audience': '1 month after joining audience',
	'nudge_remind_panel_count_months_after_joining_audience_plural': '{{count}} months after joining audience',
	'nudge_remind_panel_count_years_after_joining_audience': '1 year after joining audience',
	'nudge_remind_panel_count_years_after_joining_audience_plural': '{{count}} years after joining audience',
	'nudge_remind_panel_due_date_tooltip': 'Enable this to display the date to the audience as a due date. Otherwise, the target date will only be visible to you.',
	'nudge_remind_panel_repetition_tooltip': 'Enable repeating target dates e.g. for annual compliance training. After initial completion, the target date for each piece of content will be set based on its last completion date. You will need to set-up a “Reset status” action to allow the user to retake the content. Can only be added for nudges with goal "Complete content".',
	'nudge_remind_panel_count_days_after_account_creation_due': 'Due 1 day after account creation',
	'nudge_remind_panel_count_days_after_account_creation_due_plural': 'Due {{count}} days after account creation',
	'nudge_remind_panel_count_weeks_after_account_creation_due': 'Due 1 week after account creation',
	'nudge_remind_panel_count_weeks_after_account_creation_due_plural': 'Due {{count}} weeks after account creation',
	'nudge_remind_panel_count_months_after_account_creation_due': 'Due 1 month after account creation',
	'nudge_remind_panel_count_months_after_account_creation_due_plural': 'Due {{count}} months after account creation',
	'nudge_remind_panel_count_years_after_account_creation_due': 'Due 1 year after account creation',
	'nudge_remind_panel_count_years_after_account_creation_due_plural': 'Due {{count}} years after account creation',
	'nudge_remind_panel_count_days_after_joining_audience_due': 'Due 1 day after joining audience',
	'nudge_remind_panel_count_days_after_joining_audience_due_plural': 'Due {{count}} days after joining audience',
	'nudge_remind_panel_count_weeks_after_joining_audience_due': 'Due 1 week after joining audience',
	'nudge_remind_panel_count_weeks_after_joining_audience_due_plural': 'Due {{count}} weeks after joining audience',
	'nudge_remind_panel_count_months_after_joining_audience_due': 'Due 1 month after joining audience',
	'nudge_remind_panel_count_months_after_joining_audience_due_plural': 'Due {{count}} months after joining audience',
	'nudge_remind_panel_count_years_after_joining_audience_due': 'Due 1 year after joining audience',
	'nudge_remind_panel_count_years_after_joining_audience_due_plural': 'Due {{count}} years after joining audience',
	'nudge_remind_panel_count_days_after_account_creation_target': 'Target 1 day after account creation',
	'nudge_remind_panel_count_days_after_account_creation_target_plural': 'Target {{count}} days after account creation',
	'nudge_remind_panel_count_weeks_after_account_creation_target': 'Target 1 week after account creation',
	'nudge_remind_panel_count_weeks_after_account_creation_target_plural': 'Target {{count}} weeks after account creation',
	'nudge_remind_panel_count_months_after_account_creation_target': 'Target 1 month after account creation',
	'nudge_remind_panel_count_months_after_account_creation_target_plural': 'Target {{count}} months after account creation',
	'nudge_remind_panel_count_years_after_account_creation_target': 'Target 1 year after account creation',
	'nudge_remind_panel_count_years_after_account_creation_target_plural': 'Target {{count}} years after account creation',
	'nudge_remind_panel_count_days_after_joining_audience_target': 'Target 1 day after joining audience',
	'nudge_remind_panel_count_days_after_joining_audience_target_plural': 'Target {{count}} days after joining audience',
	'nudge_remind_panel_count_weeks_after_joining_audience_target': 'Target 1 week after joining audience',
	'nudge_remind_panel_count_weeks_after_joining_audience_target_plural': 'Target {{count}} weeks after joining audience',
	'nudge_remind_panel_count_months_after_joining_audience_target': 'Target 1 month after joining audience',
	'nudge_remind_panel_count_months_after_joining_audience_target_plural': 'Target {{count}} months after joining audience',
	'nudge_remind_panel_count_years_after_joining_audience_target': 'Target 1 year after joining audience',
	'nudge_remind_panel_count_years_after_joining_audience_target_plural': 'Target {{count}} years after joining audience',
	'nudge_remind_resend_reminder': 'Resend reminder',
	'nudge_remind_resend_named_reminder': 'Resend {{subject}}',
	'nudge_remind_warn_will_not_repeat': 'This change will cause the reminder with the offset "{{value}}" not to repeat',
	'nudge_remind_repeat_times_impact': 'This change will cause the reminder with the offset "{{value}}" to repeat {{count}} time',
	'nudge_remind_repeat_times_impact_plural': 'This change will cause the reminder with the offset "{{value}}" to repeat {{count}} times',
	'nudge_remind_repeat_times': 'This reminder will now repeat {{count}} time',
	'nudge_remind_repeat_times_plural': 'This reminder will now repeat {{count}} times',
	'nudge_remind_will_not_repeat': 'This reminder will not repeat as the next reminder will be sent before the first repetition',
	'nudge_target_reset_every_day': 'Repeat every 1 day',
	'nudge_target_reset_every_day_plural': 'Repeat every {{count}} days',
	'nudge_target_reset_every_week': 'Repeat every 1 week',
	'nudge_target_reset_every_week_plural': 'Repeat every {{count}} weeks',
	'nudge_target_reset_every_month': 'Repeat every 1 month',
	'nudge_target_reset_every_month_plural': 'Repeat every {{count}} months',
	'nudge_target_reset_every_year': 'Repeat every 1 year',
	'nudge_target_reset_every_year_plural': 'Repeat every {{count}} years',
	'nudge_progress_report': 'Progress report',
	'nudge_progress_status': 'Progress status',
	'nudge_analytics_no_content_title': 'No content',
	'nudge_analytics_no_content_description': 'There\'s no content associated with this nudge so there is nothing to report on',
	'nudge_analytics_no_audience_title': 'No audience',
	'nudge_analytics_no_audience_description': 'The audience you\'ve selected doesn\'t contain anyone, try changing the audience or add users to the team(s)',
	'nudge_analytics_no_nudges_title': 'No nudges',
	'nudge_analytics_no_nudges_description': 'No nudges were sent in the selected date range, try selecting a different date range',
	'nudge_stats_label_achieved_goal': 'Achieved goal',
	'nudge_stats_label_users_nudged': 'Users nudged',
	'nudge_stats_label_achieved_on_time': 'Achieved on time',
	'nudge_stats_label_total_nudges': 'Total nudges',
	'nudge_stats_label_compliant': 'Compliant',
	'nudge_stats_label_overdue': 'Overdue',
	'nudge_stats_label_approaching_due_date': 'Approaching due date',
	'nudge_stats_label_unachieved_within_time': 'Unachieved within time',
	'nudge_stats_description_achieved_the_goal': 'How many of the audience have achieved the goal?',
	'nudge_stats_description_on_time_of_goal_achieved': 'Of the people who achieved the goal, how many were on time?',
	'nudge_stats_description_achieved_of_nudged': 'Of the people nudged in the time period, how many have achieved the goal?',
	'nudge_stats_description_not_achieved_in_time': 'Of the people who haven\'t achieved the goal, how many are still within the target time?',
	'nudge_stats_description_achieved_or_approaching': 'How many of the audience have either achieved the goal or are approaching renewal?',
	'nudge_stats_count_total': '{{count}} total',
	'nudge_stats_count_on_time': '{{count}} on time',
	'nudge_stats_count_within_time': '{{count}} within time',
	'nudge_stats_count_late': '{{count}} late',
	'nudge_stats_count_compliant': '{{count}} compliant',
	'nudge_stats_count_overdue': '{{count}} overdue',
	'nudge_stats_count_overdue_by_more_than_two_weeks': '{{count}} overdue by more than 2 weeks',
	'nudge_stats_count_due_within_one_week': '{{count}} due within 1 week',
	'nudge_stats_tooltip_users_overdue_by_days': '{{userCount}} users overdue by {{dayCount}} days',
	'nudge_stats_tooltip_users_due_in_days': '{{userCount}} users due in {{dayCount}} days',
	'immutability_note_shared_playlist_asset': 'This asset belongs to a shared playlist and can’t be edited here.',
	'immutability_note_distributed_playlist_asset': 'This asset belongs to a distributed playlist and can’t be edited here.',
	'immutability_note_distributed_playlist_section': 'This section belongs to a distributed playlist and can’t be edited here.',
	'immutability_note_distributed_playlist_in_selection': 'Your selection includes one or more distributed playlists which can’t be edited here. Some editing functions have been disabled.',
	'immutability_note_distributed_playlist_owned_by': 'This is a distributed playlist. It’s owned by <1>{{sourceName}}</1> and can not be edited here.',
	'immutability_note_distributed_playlist': 'This is a distributed playlist and can\'t be edited here',
	'immutability_note_parenthub_another_hub': 'another hub',
	'immutability_note_selection_contains_system_role': 'Your selection contains a system role and cannot be deleted.',
	'immutability_note_selection_is_system_role': 'This is a system role and cannot be changed or deleted.',
	'immutability_note_shared_playlist_items': 'Some of these items belong to shared playlists and can’t be edited here.',
	'immutability_note_distributed_item_fields': 'This item is distributed. Not all fields can be edited here.',
	'immutability_note_distributed_playlist_content': 'Editing content is limited because this playlist is distributed.',
	'immutability_note_selection_contains_distributed_playlist_fields': 'The selection contains one or more distributed playlists. Not all fields can be edited here.',
	'immutability_note_selection_contains_distributed_asset_fields': 'The selection contains one or more distributed assets. Not all fields can be edited here.',
	'empty_state_welcome_to_your_hub': 'Welcome to your Digital Hub!',
	'empty_states_tags': 'No tags found.',
	'empty_no_users': 'No users to display',
	'empty_no_members': 'No members to display',
	'empty_no_data': 'No data to display',
	'empty_folder_title': 'Empty folder',
	'empty_folder_cta': 'Add assets to this folder using the + button above.',
	'empty_hub_add_playlists': 'Create new playlists using the + button above.',
	'empty_playlist': 'This playlist has no content yet.',
	'empty_playlist_add_assets': 'Add content to this playlist using the + button above.',
	'empty_playlist_add_content': 'Add content to this playlist using the "Manage content" button above.',
	'empty_time_to_add_content_title': 'Time to add some content!',
	'empty_time_to_add_content_cta': 'Add folders and assets to the hub using the + button above.',
	'empty_add_subtopics': 'Add subtopics to this topic using the + button above.',
	'empty_add_topics': 'Add topics to your Digital Hub using the + button above.',
	'empty_add_users': 'Add users to your Digital Hub using the + button above.',
	'empty_no_comments': 'Be the first to add a comment',
	'empty_start_the_discussion': 'Start the discussion',
	'empty_no_data_for_filters': 'No data for the selected filters',
	'empty_skill_usage_not_recorded_in_period': 'Skill usage not recorded in this period',
	'empty_no_recommended_content_for_skill': 'There is no recommended content for this skill.',
	'empty_no_upcoming': 'You do not currently have anything upcoming',
	'scorm_settings_title': 'Advanced settings',
	'scorm_settings_info': 'The advanced settings change how your SCORM course is played in the Hub. These settings can stop your course from working properly and should be set and tested before the course goes live.',
	'scorm_general_title': 'General',
	'scorm_general_option_title_open_content': 'Open content in pop-up window?',
	'scorm_general_option_info_open_content': 'Should the content open in the asset viewer page or in a separate pop-up?',
	'scorm_general_option_title_height': 'Pop-up window height',
	'scorm_general_option_info_height': 'Fix the height of the pop-up window, leave blank if you do not want to set a height',
	'scorm_general_option_title_width': 'Pop-up window width',
	'scorm_general_option_info_width': 'Fix the width of the pop-up window, leave blank if you do not want to set a width',
	'scorm_general_option_title_multiple_attempts': 'Multiple attempts for incomplete SCO?',
	'scorm_general_option_info_multiple_attempts': 'Increase the number of attempts based on the data being returned from the SCO, even if it’s incomplete?',
	'scorm_general_option_title_get_credit': 'Course provides credit?',
	'scorm_general_option_title_reenter_activity': 'Allow activity re-enterance?',
	'scorm_general_option_info_reenter_activity': 'Allow re-entrance to an activity after it has been initialized and before it has been terminated',
	'scorm_general_option_title_comments_from_lms': 'Comments from LMS',
	'scorm_general_option_info_comments_from_lms': 'Send this data to the SCO in the field cmi.comments_from_lms.',
	'scorm_status_title': 'Status behaviour',
	'scorm_status_info': 'Overwrite the status being returned from the SCO',
	'scorm_status_option_title_change_after_completed': 'Allow status change after Completed?',
	'scorm_status_option_info_change_after_completed': 'Determines whether or not the course status is allowed to change after the course already has a completed status',
	'scorm_status_option_title_change_after_failed': 'Allow status change after Failed?',
	'scorm_status_option_info_change_after_failed': 'Determines whether or not the course status is allowed to change after the course already has a failed status',
	'scorm_status_option_title_change_after_passed': 'Allow status change after Passed?',
	'scorm_status_option_info_change_after_passed': 'Determines whether or not the course status is allowed to change after the course already has a passed status',
	'scorm_status_option_title_count_failed_as_done': 'Failed status counts as done?',
	'scorm_status_option_info_count_failed_as_done': 'Failing the course will still mark it as done so that the learner doesn’t have to take it again.',
	'scorm_status_option_title_start_incomplete': 'Set initial status to incomplete?',
	'scorm_status_option_info_start_incomplete': 'Forces the lesson status to incomplete if the status hasn’t already been initialized, otherwise remains as not attempted until it is updated',
	'scorm_status_option_title_autocomplete': 'Auto complete course with no status set?',
	'scorm_status_option_info_autocomplete': 'Should the status be set to complete if the course is initialized and doesn’t have a status set before being closed?',
	'scorm_status_option_title_mastery_score': 'Overwrite status based on Mastery Score?',
	'scorm_status_option_info_mastery_score': 'Decide whether the course status should be overwritten by comparing the learners score to the mastery score',
	'scorm_score_title': 'Score behaviour',
	'scorm_score_info': 'Overwrite the score being returned from the SCO',
	'scorm_score_option_title_change_after_completed': 'Allow score change after Completed?',
	'scorm_score_option_info_change_after_completed': 'Allows the score to be changed after the lesson has been marked as completed',
	'scorm_score_option_title_change_after_failed': 'Allow score change after Failed?',
	'scorm_score_option_info_change_after_failed': 'Allows the score to be changed after the lesson has been marked as failed',
	'scorm_score_option_title_change_after_passed': 'Allow score change after Passed?',
	'scorm_score_option_info_change_after_passed': 'Allows the score to be changed after the lesson has been marked as passed',
	'scorm_score_option_title_score_allow_reduced': 'Allow score to be reduced?',
	'scorm_score_option_info_score_allow_reduced': 'Setting this to disabled blocks the score from being set to a lower value even if the score is allowed to be changed',
	'scorm_multi_title': 'Multi SCO courses',
	'scorm_multi_info': 'Change the behaviour if your course has more than one SCO',
	'scorm_multi_option_title_autolaunch_first_sco': 'Auto launch first SCO?',
	'scorm_multi_option_info_autolaunch_first_sco': 'Determines whether or not the first SCO begins automatically when the user starts the course',
	'scorm_multi_option_title_return_last_sco_launch': 'Return to the last SCO on launch?',
	'scorm_multi_option_info_return_last_sco_launch': 'When set the user returns to the last SCO they viewed when reopening the course otherwise they will go to the first SCO',
	'scorm_multi_option_title_navigation_type': 'Navigation type',
	'scorm_multi_option_info_navigation_type': 'Change the way that the learner navigates through the SCOs',
	'scorm_multi_option_title_status_rollup_action': 'Status rollup for multi SCO courses',
	'scorm_multi_option_info_status_rollup_action': 'Determines which rolled up SCO score(s) to save',
	'scorm_multi_option_title_score_rollup_action': 'Score rollup for multi SCO courses',
	'scorm_multi_option_info_score_rollup_action': 'Define how the Hub calculates the score when there is more than one SCO',
	'scorm_multi_option_title_score_rollup_include_sco': 'Score rollup includes non-scoring SCOs?',
	'scorm_multi_option_info_score_rollup_include_sco': 'Should SCOs that have no specified score contribute to the score rollup?  Only applies to SCORM 1.2 or SCORM 2004 that doesn’t have a manifest with specified rollup rules',
	'scorm_data_title': 'Data saving issues',
	'scorm_data_info': 'Settings to change the way that the SCO saves its data',
	'scorm_data_option_title_save_on_commit': 'Save data on Commit?',
	'scorm_data_option_info_save_on_commit': 'Set whether or not data is saved every time a commit call is made',
	'scorm_data_option_title_save_on_set_value': 'Save data on Set Value?',
	'scorm_data_option_info_save_on_set_value': 'Set whether or not the data is saved every time the set call is made. This increases the number of times the data is saved so should be used with extreme care',
	'scorm_nav_type_default': 'Use behaviour from manifest',
	'scorm_nav_type_lockstep': 'SCOs must be taken in order',
	'scorm_nav_type_exam_after_content': 'All content must be taken before entering exam',
	'scorm_nav_type_only_once': 'Every SCO is only accessible once',
	'scorm_mastery_score_default': 'Ignore the mastery score, use the reported status',
	'scorm_mastery_score_always': 'Always update the status if a score is set, even if the SCO isn’t complete',
	'scorm_mastery_score_after_completion': 'Update completed only. Apply mastery score to completed SCOs only',
	'scorm_score_rollup_default': 'Use the average of all the SCO scores',
	'scorm_score_rollup_first': 'Use the first SCO’s score as the rolled up score',
	'scorm_score_rollup_last': 'Use the last SCO’s score as the rolled up score data',
	'scorm_status_rollup_default': 'Roll up the status based on all SCOs',
	'scorm_status_rollup_first': 'Uses the status of the first SCO',
	'scorm_status_rollup_last': 'Uses the status of the last SCO',
	'scorm_empty_file_msg': 'File could not be loaded, and it will not display correctly to users. Please upload a new file.',
	'format_csv': 'CSV',
	'format_xlsx': 'XLSX',
	'format_csv_info': 'CSV for data imports (unlimited rows)',
	'format_csv_bom_info': 'CSV for Excel (unlimited rows)',
	'format_xlsx_info': 'XLSX (up to 200k rows)',
	'settings_language_heading': 'Language',
	'settings_language_option_default': 'Default language',
	'settings_language_option_content_management': 'Content language management',
	'settings_language_option_user_management': 'User language management',
	'settings_hub_details_heading': 'Hub details',
	'settings_hub_details_option_company_name': 'Company name',
	'settings_hub_details_option_hub_name': 'Digital hub name',
	'settings_hub_details_option_short_name': 'Short name',
	'settings_hub_details_option_short_name_info': 'When pinned to a phone’s home screen, this name will be used',
	'settings_hub_details_option_theme': 'Theme',
	'settings_hub_details_option_theme_info': 'Please contact support@5app.com to change the theme colours and logos',
	'settings_complete_profile_heading': 'Profile completion pop up',
	'settings_complete_profile_info': 'Always shown to users who haven’t completed all required custom user fields. Shown once to everyone based on the setting below. Preview <1>here</1>.',
	'settings_complete_profile_option_message': 'Message',
	'settings_complete_profile_option_message_info': 'Customise the message shown at the top of the profile completion pop up',
	'settings_complete_profile_option_message_default': 'Before you get started, please fill in your profile to get the most out of your Digital Hub',
	'settings_complete_profile_option_complete': 'Show to everyone',
	'settings_complete_profile_option_complete_info': 'Show the profile completion pop up to anyone who hasn’t seen it before',
	'settings_complete_profile_option_reset': 'Reset views',
	'settings_complete_profile_option_reset_info': 'Force all users to see the profile completion pop up the next time they log in, even if they have seen it before',
	'settings_status_heading': 'Hub status',
	'settings_status_option_current': 'Current status',
	'settings_email_templates_heading': 'Email templates',
	'settings_email_templates_cta': 'Preview and edit email templates',
	'settings_email_sender_heading': 'Default email sender',
	'settings_email_sender_info': 'Customise the name and email address that system emails will be sent from as well as where replies to system emails go to. Please <1>contact 5app</1> to change the sending email address.',
	'settings_email_sender_option_name': 'Sender name',
	'settings_email_sender_option_email': 'Email address',
	'settings_email_sender_option_reply': 'Reply to address',
	'settings_email_sender_option_reply_info': 'The email address that’s used when a user replies to an email. This isn’t used for recommendations where the reply goes to the person who recommended the content',
	'settings_feedback_heading': 'Feedback email',
	'settings_feedback_info_header_colon': 'The feedback email address is used to receive replies for the following:',
	'settings_feedback_info_option_one': 'Enquiries sent via the <1>Contact form</1> option',
	'settings_feedback_info_option_two': 'Feedback option available for assets when <1>Comments</1> are disabled',
	'settings_feedback_option_email': 'Feedback email',
	'settings_login_heading': 'Messages',
	'settings_login_option_welcome_message': 'Welcome message',
	'settings_login_option_help_message': 'Help message',
	'settings_login_option_help_message_info': 'If needed, use this field to provide guidance for users who are unable to log in.',
	'settings_login_authentication_heading': 'Hub Authentication',
	'settings_login_password_option_placement': 'Show option to login with email and password',
	'settings_login_password_option_placement_info': 'Only hide this option if nobody is going to log in using an email and password',
	'settings_login_password_option_placement_option_link': 'Show as link',
	'settings_login_password_option_placement_option_button': 'Show as button',
	'settings_login_password_option_placement_option_hide': 'Hide',
	'settings_login_password_option_placement_option_domain_based': 'Domain based',
	'settings_sso_heading': 'SSO - {{identity}}',
	'settings_sso_option_provider_name': 'Name to show on login page',
	'settings_sso_option_provider_name_info': 'The name shown on the login button after "Log in with". Leave blank to hide this option from the login page.',
	'settings_sso_option_domain': 'Force on for users in these domains',
	'settings_sso_option_domain_info': 'Users with an email address in one of these domains will only be able to log in using this SSO provider',
	'settings_sso_option_domain_placeholder': 'my-domain.com, my-domain.com',
	'settings_sso_option_autocreate': 'Auto-create user accounts',
	'settings_sso_option_autocreate_enabled': 'Enabled',
	'settings_sso_option_autocreate_disabled': 'Disabled – users have to be invited.',
	'settings_sso_option_save_nameid_as_id': 'Save nameID as employee Id',
	'settings_sso_option_save_nameid_as_id_info': 'Note that an employee id attribute will always take precedence over the nameID',
	'settings_sso_option_save_nameid_as_email': 'Save nameID as email',
	'settings_sso_option_save_nameid_as_email_info': 'Note that an email attribute will always take precedence over the nameID',
	'settings_sso_metadata_download': 'Download metadata',
	'settings_domain_heading': 'Domain',
	'settings_domain_info': 'Override the hub domain',
	'settings_domain_option_hub_domain': 'Hub domain',
	'settings_domain_option_alias': 'Alias',
	'settings_hostname_heading': 'Canonical hostname',
	'settings_hostname_info': 'Override the hostname used if the site is aliased via a CDN',
	'settings_hostname_option_hostname': 'Hostname',
	'settings_hostname_option_hostname_placeholder': 'domain.com',
	'settings_user_import_option_enable': 'Enable user imports',
	'settings_user_import_option_enable_info': 'Allow users to be bulk uploaded from a csv file',
	'settings_user_import_option_manual': 'Manual user imports',
	'settings_user_import_option_manual_info': 'Allow site owners to bulk upload users via the Users page',
	'settings_user_import_option_invites': 'Send invites to new users',
	'settings_user_import_option_invites_info': 'Send a welcome email to newly imported users',
	'settings_user_import_option_download': 'Download import files from log page',
	'settings_user_import_option_download_info': 'Allow admins to download all user import csv files from the log page',
	'settings_user_import_option_notification': 'Notification email',
	'settings_user_import_option_notification_info': 'Change the address that user import feedbacks are sent to',
	'settings_user_import_option_csv_schema': 'CSV Schema',
	'settings_user_import_option_csv_schema_info': 'You can specify a custom schema for importing user data from CSV files',
	'settings_user_import_option_csv_schema_placeholder': 'Default schema',
	'settings_user_import_option_add_new_users': 'Add new users or update existing user data by uploading a CSV file matching the criteria described <1>in our documentation</1>.',
	'settings_user_import_option_download_template': 'Download a <1>CSV template here</1>.',
	'settings_admin_roles_heading': 'Admin roles',
	'settings_admin_roles_cta': 'Manage admin roles',
	'settings_team_manager_heading': 'Team manager permissions',
	'settings_team_manager_option_my_teams': 'My teams',
	'settings_team_manager_option_my_teams_info': 'Enable Team Managers to access My teams page and team activity data',
	'settings_team_manager_option_people_tab': 'Members tab in My teams',
	'settings_team_manager_option_people_tab_info': 'Provides access to activity data for individual team members',
	'settings_team_manager_option_team_reports': 'Report tab in My teams',
	'settings_team_manager_option_team_reports_info': 'Provides access to reports containing detailed activity data for a team and its members',
	'settings_team_manager_option_team_playlists': 'Team playlists',
	'settings_team_manager_option_team_playlists_info': 'Enable managers to create playlists for their team',
	'settings_team_manager_option_managers_create_assets': 'Managers can create assets',
	'settings_team_manager_option_managers_create_assets_info': 'Enable managers to create and manage assets in their playlists. This can only be enabled if Team playlists setting is enabled.',
	'settings_default_asset_folders': 'Default Asset Folders',
	'settings_default_asset_folders_desc': 'Here you can set the default asset library location for content that is created directly inside of a playlist.',
	'settings_default_folder_team_assets': 'Default folder for content in team playlists',
	'settings_team_manager_option_create_assets_in_folder_info': 'e.g. "Team Assets Directory/Team: {{team.name}}"',
	'settings_default_folder_other_assets': 'Default folder for content in other playlists',
	'settings_default_folder_other_assets_info': 'e.g. "Admin Assets Directory/{{playlist.name}}"',
	'settings_partner_link_heading': 'Partner link',
	'settings_partner_link_info': 'Add a partner’s name and link to the note in the footer of the Hub.',
	'settings_partner_link_provided_colon': 'Will be displayed as:',
	'settings_partner_link_empty': 'Please fill in both a name and a URL.',
	'settings_partner_link_option_name': 'Partner name',
	'settings_partner_link_option_link': 'Partner link',
	'settings_contact_form_heading': 'Contact form',
	'settings_contact_form_info': 'The contact option is displayed to end users in the menu or as an optional icon. All enquiries sent via the contact form will be sent to the email address specified in the <1>Feedback email</1>.',
	'settings_contact_form_option_label': 'Custom label',
	'settings_contact_form_option_link': 'Custom link',
	'settings_contact_form_option_link_info': 'This link will be opened in place of the built-in contact form',
	'settings_contact_form_option_floating_button': 'Floating contact button',
	'settings_contact_form_option_floating_button_info': 'Show a floating contact button in the bottom-right corner of the screen',
	'settings_nav_bar_link_heading': 'Custom navigation bar link',
	'settings_nav_bar_link_info': 'Add a custom link to the Hub’s main navigation bar.',
	'settings_nav_bar_link_option_label': 'Label',
	'settings_nav_bar_link_option_label_info': 'This label should be no longer than 10–15 characters to avoid line breaks',
	'settings_nav_bar_link_option_link': 'Link',
	'settings_custom_menu_links_heading': 'Custom user menu links',
	'settings_custom_menu_links_info': 'Add up to three custom links to the Hub’s user dropdown menu.',
	'settings_custom_menu_links_option_label': 'Label',
	'settings_custom_menu_links_option_url': 'URL',
	'settings_custom_menu_links_link_1': 'Link 1',
	'settings_custom_menu_links_link_2': 'Link 2',
	'settings_custom_menu_links_link_3': 'Link 3',
	'settings_option_content_log_info': 'View a change log of all content in your hub and undo accidental deletions.',
	'settings_option_message_log_info': 'View all messages sent from the hub.',
	'settings_option_nudge_log_info': 'View a log of any changes made to nudges.',
	'settings_option_user_log_info': 'View a log of user updates.',
	'settings_option_team_log_info': 'View a log of team updates.',
	'settings_option_user_imports_log_info': 'View a log of user imports from csv files.',
	'settings_functionality_heading': 'System functionality',
	'settings_functionality_info': 'Change the features available in the hub.',
	'settings_functionality_option_event_assets': 'Event session management',
	'settings_functionality_option_event_assets_info': 'Allows admins to create events, add sessions and manage bookings and attendance.',
	'settings_functionality_option_reports': 'Reports',
	'settings_functionality_option_user_sharing': 'User-to-user sharing',
	'settings_functionality_option_user_sharing_info': 'Allow users to share content with other team members',
	'settings_functionality_option_team_sharing': 'Cross-team sharing',
	'settings_functionality_option_team_sharing_info': 'Let users share content with members of other teams',
	'settings_functionality_everyone_sharing': 'Everyone sharing',
	'settings_functionality_everyone_sharing_info': 'Let admins share content with everyone with access',
	'settings_functionality_option_auto_sharing': 'Auto-sharing',
	'settings_functionality_option_auto_sharing_info': 'Set up automated sharing of playlists to teams and new users. Use with caution as this feature can send many emails to the users of the system.',
	'settings_functionality_option_edit_user_name': 'Users can edit name',
	'settings_functionality_option_edit_user_name_info': 'Allow users to update their own name',
	'settings_functionality_option_comments': 'Comments',
	'settings_functionality_option_comments_info': 'Allow commenting on assets and playlists',
	'settings_functionality_option_custom_data': 'Content custom data',
	'settings_functionality_option_custom_data_info': 'Allow admins to edit the Custom data for assets and playlists. This is only used if an integration has been set-up with another system which requires custom data to be sent.',
	'settings_functionality_option_mark_as_done': 'Automatic mark as done',
	'settings_functionality_option_mark_as_done_info': 'Allow assets to be marked as done automatically, without having to click on Mark as done?',
	'settings_functionality_option_manual_mark_as_done': 'Manually mark assets as done by default',
	'settings_functionality_option_manual_mark_as_done_info': 'The default behaviour for new assets, can be changed for individual assets. Changing this setting doesn\'t update existing assets, use the button below to do this.',
	'settings_functionality_option_reset_assets_mark_as_done_setting': 'Set existing assets to default option',
	'settings_functionality_option_reset_assets_mark_as_done_setting_to_auto_info': 'Update all existing assets in this hub to be automatically marked as done',
	'settings_functionality_option_reset_assets_mark_as_done_setting_to_manual_info': 'Update all existing assets in this hub to be manually marked as done',
	'settings_functionality_option_badges': 'Badges',
	'settings_functionality_option_badges_info': 'Allow badges to be added to playlists to be awarded on completion',
	'settings_functionality_option_member_contributions': 'Member contributions',
	'settings_functionality_option_member_contributions_info': 'Show the setting on playlists to allow member contributions',
	'settings_functionality_option_optional_content': 'Optional content (BETA)',
	'settings_functionality_option_optional_content_info': 'Allow assets and playlist to be marked as optional in a playlist',
	'settings_functionality_option_curation_checklist': 'Content curation checklist (BETA)',
	'settings_functionality_option_curation_checklist_info': 'Show a checklist of metadata to be added when editing playlists.',
	'settings_functionality_option_playlist_sections': 'Playlist sections',
	'settings_functionality_option_playlist_sections_info': 'Playlist sections act as containers for content rather than being text labels',
	'settings_functionality_option_new_playlist_and_pinning': 'New playlist page and Playlist pinning',
	'settings_functionality_option_new_playlist_and_pinning_info': 'Show the new playlist page layout, and replace the old playlist sorting to use the new concept of pinning playlist to either the browse page or topic page',
	'settings_functionality_option_emailaddress_editor': 'Email address editor (BETA)',
	'settings_functionality_option_emailaddress_editor_info': 'Allow admins to edit member email addresses',
	'settings_functionality_option_ai_natural_language_search': 'AI Natural Language Search (BETA)',
	'settings_functionality_option_ai_natural_language_search_info': 'Uses AI to fix spelling mistakes and expand the search to include derivatives of words. Whilst identifying key words within the search term to ensure the matches are still relevant',
	'settings_functionality_option_email_use_external_images': 'Use external sources for email images (old behaviour)',
	'settings_functionality_option_email_use_external_images_info': 'When enabled, images within emails will use external sources, rather than be embedded in the email.',
	'settings_functionality_option_enable_tracking': 'Product tracking',
	'settings_functionality_option_enable_tracking_info': 'Track the actions of admin users in this hub',
	'settings_functionality_option_asset_editor_auto_suggestions': 'Asset Editor auto content suggestions (BETA)',
	'settings_functionality_option_asset_editor_auto_suggestions_info': 'Automatically detect the language and summaries the content uploaded using AI (currently only works with PDFs)',
	'settings_functionality_option_topics_on_home': 'Display topics on homepage',
	'settings_functionality_option_topics_on_home_as_tiles': 'As tiles',
	'settings_functionality_option_topics_on_home_as_buttons': 'As buttons',
	'settings_experimental_heading': 'Experimental features',
	'settings_experimental_info': 'Try out new features available in the hub as we refine them for wider use.  Please speak to your customer success manager before enabling these features as they could still be changing.',
	'settings_experimental_option_real_time': 'Real-time events',
	'settings_experimental_option_real_time_info': 'Allow SCORM courses to update the asset status in real time.',
	'settings_experimental_option_recommendations': 'Recommendations',
	'settings_experimental_option_recommendations_info': 'Provide users with recommendations based on their activity',
	'settings_user_import_option_ignoring_bad_rows': 'Ignore bad rows in automated import',
	'settings_user_import_option_ignoring_bad_rows_info': 'Don\'t quit the import if bad data is detected, import the good data and report on the errors',
	'settings_playlist_content_numbering': 'Default playlist content numbering',
	'settings_playlist_content_numbering_enable_display': 'Display numbers',
	'settings_playlist_content_numbering_disable_display': 'Don\'t display numbers',
	'settings_playlist_content_numbering_tooltip_1': 'The default setting of the “Display content numbers” option when creating a new playlist. Can be changed for individual playlists.',
	'settings_playlist_content_numbering_tooltip_2': 'Changing this setting doesn’t update existing playlists, use the button below to do this.',
	'settings_playlist_content_numbering_display_in_all_enabled': 'Display content numbers in all playlists',
	'settings_playlist_content_numbering_dont_display_in_all_disabled': 'Don\'t display content numbers in all playlists',
	'settings_playlist_content_update_all_playlists': 'Update all playlists',
	'settings_accesskey_heading': 'Access keys',
	'settings_accesskey_cta': 'Manage access keys',
	'settings_distribution_heading': 'Distribution',
	'settings_distribution_description': 'This hub is set up to distribute content to {{count}} other hub',
	'settings_distribution_description_plural': 'This hub is set up to distribute content to {{count}} other hubs',
	'settings_distribution_open_editor': 'Select hubs for distribution',
	'settings_user_import_option_only_send_failure_emails': 'Only send failure emails',
	'settings_user_import_option_only_send_failure_emails_info': 'Don\'t send an email when the import ran successfully',
	'settings_maintenance_mode_custom_message': 'Custom maintenance mode message',
	'settings_maintenance_mode_custom_message_info': 'Customise the message that users will see when the hub is in maintenance mode',
	'settings_ai_coach_name': 'AI Coach name',
	'settings_ai_coach_name_info': 'The friendly name of your AI Coach as it appears to end users',
	'settings_ai_coach_content_permissions': 'Content allowed to be processed by AI Coach:',
	'settings_ai_coach_content_permissions_info': 'Assets can be excluded from AI processing individually',
	'settings_ai_coach_content_permissions_everyone': 'Assets visible to everyone',
	'settings_ai_coach_content_permissions_teams_or_everyone': 'Assets visible to selected teams or everyone',
	'settings_ai_coach_content_permissions_all': 'All assets in a playlist, including admin-only',
	'email_template_editor': 'Template editor',
	'email_all': 'All',
	'email_default': 'Default',
	'email_custom': 'Custom',
	'email_default_info': 'This is the default template.',
	'email_no_template_info': 'No template available in the selected language',
	'email_subject': 'Subject',
	'email_default_subject': 'Default subject',
	'email_banner_title': 'Banner title',
	'email_subject_as_banner_info': 'Use subject as banner title',
	'email_body': 'Body',
	'email_button_text': 'Button text',
	'email_signature': 'Signature',
	'email_footer': 'Footer',
	'email_status_copied': 'Copied!',
	'email_template_new_user_title': 'Account - Invitation',
	'email_template_new_user_info': 'Sent to people when they’re invited to the hub',
	'email_template_reset_password_title': 'Account - Password reset',
	'email_template_reset_password_info': 'Sent to people who request a password reset',
	'email_template_welcome_user_title': 'Account - Welcome message',
	'email_template_welcome_user_info': 'Inbox message (not an email) sent to people when they first log into the hub',
	'email_template_comment_notification_admin_title': 'Admin notification - Comments',
	'email_template_comment_notification_admin_info': 'Sent to hub’s feedback email address when a new comment is posted',
	'email_template_contact_request_notification_title': 'Admin notification - Contact form',
	'email_template_contact_request_notification_info': 'Sent to hub’s feedback email address when a user submits a contact form request',
	'email_template_review_notification_title': 'Admin notification - Feedback',
	'email_template_review_notification_info': 'Sent to hub’s feedback email address when someone submits feedback',
	'email_template_user_import_title': 'Admin notification - User import',
	'email_template_user_import_info': 'Summary email sent to the user import notification email address after each import',
	'email_template_new_reply_title': 'Comments - Reply notification',
	'email_template_new_reply_info': 'Sent when someone replies to a comment that the person left',
	'email_template_new_comment_title': 'Comments - Subscriber notification',
	'email_template_new_comment_info': 'Sent to subscribers of an asset/playlist when a new comment is posted',
	'email_template_inactivity_reminder_title': 'Nudge - Log in again reminder',
	'email_template_inactivity_reminder_info': 'Used for reminders for the "Log in again" nudge',
	'email_template_invitation_reminder_title': 'Nudge - Log in for the first time reminder',
	'email_template_invitation_reminder_info': 'Used for reminders for the "Log in for the first time" nudge',
	'email_template_uncompleted_reminder_title': 'Nudge - Content complete reminder',
	'email_template_uncompleted_reminder_info': 'Used for reminders when an "Open or complete content" nudge has a goal of "Complete content"',
	'email_template_open_reminder_title': 'Nudge - Content open reminder',
	'email_template_open_reminder_info': 'Used for reminders when an "Open or complete content" nudge has a goal of "Open content"',
	'email_template_auto_recommendation_title': 'Share - Auto-share',
	'email_template_auto_recommendation_info': 'Used for auto-shares and for shares in "Open or complete content" nudges',
	'email_template_recommendation_title': 'Share - Manual',
	'email_template_recommendation_info': 'Used for manual shares',
	'email_template_reset_recommendation_title': 'Share - Status reset',
	'email_template_reset_recommendation_info': 'Used when content is shared after updating its completion status',
	'email_template_event_booking_confirmation_title': 'Events - Booking confirmation',
	'email_template_event_booking_confirmation_info': 'Sent to users when they are booked onto an event session',
	'email_template_event_booking_update_title': 'Events - Booking update',
	'email_template_event_booking_update_info': 'Sent to users when their event session details are updated',
	'email_template_event_booking_cancellation_title': 'Events - Booking cancellation',
	'email_template_event_booking_cancellation_info': 'Sent to users when their event session booking is cancelled',
	'email_message_type_meeting_analysis_title': 'Helix meeting analysis',
	'email_message_type_meeting_analysis_info': 'Used for sending user feedback after a meeting',
	'email_message_type_weekly_analysis_title': 'Helix weekly analysis',
	'email_message_type_weekly_analysis_info': 'Used for sending weekly user feedback',
	'email_message_type_calendar_de_authorised_title': 'Helix calendar de-authorised',
	'email_message_type_calendar_de_authorised_info': 'Used for notifying user\'s when their calendar subscription must either be re-authorised or disconnected',
	'email_message_type_share_auto': 'Share (auto)',
	'email_message_type_admin_notification_contact_us': 'Admin notification - Contact us',
	'email_message_type_invitation': 'Invitation',
	'email_message_type_share_manual': 'Share (manual)',
	'email_message_type_password_reset': 'Password reset',
	'email_message_type_admin_notification_review': 'Admin notification - Review',
	'email_message_type_comment_asset': 'Comment (Asset)',
	'email_message_type_new_comment_subscribed_asset': 'New comment on subscribed asset',
	'email_message_type_new_comment_asset': 'New reply to comment on asset',
	'email_message_type_users_imported_to_hub': 'Users imported to hub',
	'email_formatting': 'Formatting',
	'email_formatting_info': 'Fields marked with <1 /> can be formatted using Markdown.',
	'email_formatting_link': 'Learn more in our <1>Markdown cheat sheet</1>.',
	'email_placeholder_tags': 'Placeholders',
	'email_placeholder_tags_info': 'Copy and paste these placeholders to add dynamic content such as the recipient’s name to the email template.',
	'unknown_user': 'Unknown',
	'share_widget_title': 'Share with',
	'share_widget_options': 'Suggested users and teams',
	'share_widget_empty': 'No users found',
	'share_widget_message': 'Search for members by their name or email address.',
	'parent_playlist_asset_panel_hint_title': 'This asset is in <2>1 playlist</2>',
	'parent_playlist_asset_panel_hint_title_plural': 'This asset is in <2>{{count}} playlists</2>',
	'parent_playlist_playlist_panel_hint_title': 'This playlist is in <2>1 playlist</2>',
	'parent_playlist_playlist_panel_hint_title_plural': 'This playlist is in <2>{{count}} playlists</2>',
	'parent_playlist_item_panel_popup_title_colon': 'Playlists that contain this item:',
	'advanced_audience_widget_audience_colon': 'Audience:',
	'advanced_audience_widget_advanced': 'Advanced',
	'widget_include_message_colon': 'Include people who are in one or more of these teams:',
	'widget_teams_message_colon': 'And they must be in one or more of these teams:',
	'widget_exclude_message_colon': 'Exclude people who are in one or more of these teams:',
	'widget_none_selected': 'None selected',
	'widget_team_disabled': 'Select at least one team in the panel above to enable this filter.',
	'widget_include_group': 'Include people, group {{id}}',
	'widget_exclude_group': 'Exclude people, group {{id}}',
	'editable_item_placeholder': 'Please enter new name..',
	'editable_item_delete_confirmation': 'Are you sure you want to delete <1><0>{{name}}</0></1>?',
	'user_import_property_ignored_bad_rows': 'Ignored bad rows',
	'user_import_partial_success_results': 'User import partial success results',
	'user_import_errors': 'User import errors',
	'user_import_results': 'User import results',
	'user_import_no_changes': 'No changes',
	'user_import_property_conflicts': 'Conflicting employees',
	'user_import_property_skipped': 'Skipped employees',
	'user_import_property_users_added': 'New users',
	'user_import_property_users_updated': 'Updated users',
	'user_import_property_users_deleted': 'Deleted users',
	'user_import_property_teams_added': 'New teams',
	'user_import_property_memberships_added': 'New team memberships',
	'user_import_property_memberships_deleted': 'Deleted team memberships',
	'user_import_property_manager_teams_created': 'New line manager team',
	'user_import_property_manager_teams_renamed': 'Updated line manager team',
	'user_import_property_manager_teams_deleted': 'Deleted line manager team',
	'user_import_property_manager_team_memberships_updated': 'New line manager team membership',
	'user_import_property_manager_team_memberships_deleted': 'Deleted line manager team membership',
	'user_importer_drop_file_cta': 'Drop CSV file here or <1>browse</1> to upload',
	'user_importer_wizard_template_information_colon': 'You can download a CSV template as a starting point:',
	'user_importer_wizard_download_blank_template': 'Blank template',
	'user_importer_wizard_download_filled_template': 'All active users',
	'user_importer_wizard_title': 'Import user data',
	'user_importer_wizard_upload_documentation_info': 'Add new users or update existing user data by uploading a CSV file matching the criteria described <1>in our documentation</1>.',
	'user_importer_wizard_template_info': 'You can also <1>download a CSV template</1> as a starting point.',
	'user_importer_wizard_hint': 'You will be able to safely review your changes after the upload, before any data is stored in the system.',
	'user_importer_error_title': 'Import failed',
	'user_importer_error_message_colon': 'The following error(s) occurred while processing the new user data:',
	'user_importer_error_guide_info': 'Please make sure that the CSV file is formatted correctly. See the <1>User import set-up guide</1> for more guidance.',
	'user_importer_stats_entries': 'There are a total of <strong>{{count}} user records</strong>.',
	'user_importer_stats_conflicting_ids_colon': 'The following employee IDs are conflicting:',
	'user_importer_stats_skipped_ids_colon': 'The following employee IDs were skipped:',
	'user_importer_review_title': 'Review provisional results',
	'user_importer_review_message_colon': 'Please review the simulated result of your changes:',
	'user_importer_review_invite_checkbox': 'Invite new users by email',
	'user_importer_success_title': 'Import successful',
	'autoshare_remove_title': 'Remove auto-shares',
	'autoshare_remove_message': 'This will disable auto-sharing for "{{name}}". Are you sure you want to continue?',
	'autoshare_calculating_recipients_message': 'Calculating auto-share recipients…',
	'autoshare_with_everyone_title': 'Auto-share with everyone?',
	'autoshare_with_everyone_message': 'This will share "{{name}}" with all future users of this hub.',
	'autoshare_with_everyone_emails_message': 'This will share "<1>{{name}}</1>" with all future users of this hub and send an email to <strong>one existing user</strong>.',
	'autoshare_with_everyone_emails_message_plural': 'This will share "<1>{{name}}</1>" with all future users of this hub and send an email to <strong>{{count}} existing users</strong>.',
	'autoshare_with_team_title': 'Auto-share with one team?',
	'autoshare_with_team_title_plural': 'Auto-share with {{count}} teams?',
	'autoshare_with_team_message_colon': 'This will share "{{name}}" with all future users of the following team:',
	'autoshare_with_team_message_colon_plural': 'This will share "{{name}}" with all future users of the following teams:',
	'autoshare_with_team_email_message': 'Additionally, it will be shared via email with <strong>one existing user</strong>.',
	'autoshare_with_team_email_message_plural': 'Additionally, it will be shared via email with <strong>{{count}} existing users</strong>.',
	'autoshare_disabled_hint': 'Auto-sharing will be disabled.',
	'autoshare_with_everyone_in_future_hint': 'Auto-share with all future users of this hub.',
	'autoshare_with_everyone_in_future_and_now_hint': 'Auto-share with all future users of this hub and and share now with <strong>one existing user</strong>.',
	'autoshare_with_everyone_in_future_and_now_hint_plural': 'Auto-share with all future users of this hub and share now with <strong>{{count}} existing users</strong>.',
	'autoshare_with_team_hint': 'Auto-share with all future users in the selected team.',
	'autoshare_with_team_hint_plural': 'Auto-share with all future users in the selected <strong>{{count}} teams<strong>.',
	'autoshare_with_user_hint': 'Additionally, share now with <strong>one existing user</strong>.',
	'autoshare_with_user_hint_plural': 'Additionally, share now with <strong>{{count}} existing users</strong>.',
	'role_owner': 'Owner',
	'role_admin': 'Admin',
	'role_member': 'Member',
	'role_user': 'User',
	'role_line_manager': 'Line Manager',
	'permission_report': 'Reports',
	'permission_user': 'Users & Teams',
	'permission_asset': 'Assets',
	'permission_playlist': 'Playlists & Topics',
	'permission_nudge': 'Nudges',
	'permission_helix': 'Helix',
	'permission_status_has_permission': 'Has this permission',
	'permission_status_does_not_have_permission': 'Does not have this permission',
	'changelog_source_user': 'User',
	'changelog_source_sso': 'SSO',
	'changelog_source_user_import': 'User import',
	'changelog_source_scim': 'SCIM',
	'changelog_source_mindsmith': 'Mindsmith',
	'changelog_source_recall': 'Recall',
	'changelog_action_from_source': '{{action}} from {{source}}',
	'changelog_profile_confirmed': 'Profile confirmed',
	'changelog_custom_field_updated': 'Custom field',
	'changelog_custom_field_added': 'New custom field',
	'changelog_custom_field_removed': 'Deleted custom field',
	'changelog_teams_added': 'Added teams',
	'changelog_teams_removed': 'Removed teams',
	'changelog_managed_teams_added': 'New manager teams',
	'changelog_managed_teams_removed': 'Deleted manager teams',
	'changelog_password_reset_requested': 'Password reset requested',
	'changelog_password_changed': 'Password changed',
	'changelog_is_invited': 'Invited',
	'changelog_teams_included': 'Included teams',
	'changelog_teams_excluded': 'Excluded teams',
	'changelog_contents_added': 'Added contents',
	'changelog_contents_removed': 'Removed contents',
	'changelog_avatar_updated': 'Avatar updated',
	'changelog_action_added': 'Added action',
	'changelog_action_updated': 'Updated action',
	'changelog_skills_added': 'Skills added',
	'changelog_skills': 'Skills',
	'changelog_skills_removed': 'Skills removed',
	'changelog_sets_added': 'Sets added',
	'changelog_sets': 'Sets',
	'changelog_sets_removed': 'Sets removed',
	'changelog_reset_last_triggered': 'Last triggered date reset',
	'changelog_set_role_to': 'Set role to',
	'changelog_set_is_target_due_date_to_true': 'Display target due date to audience',
	'changelog_set_is_target_due_date_to_false': 'Do not display target due date to audience',
	'changelog_distributed': 'Distributed to hub',
	'changelog_distribution_removed': 'Distribution removed from hub',
	'changelog_thumbnail_updated': 'Thumbnail image updated',
	'changelog_thumbnail_removed': 'Thumbnail image removed',
	'changelog_badge_image_updated': 'Badge image updated',
	'changelog_badge_image_removed': 'Badge image removed',
	'changelog_badge_added': 'Badge added',
	'changelog_badge_removed': 'Badge removed',
	'changelog_optional': 'Set as optional',
	'changelog_required': 'Set as required',
	'changelog_content_set_as_optional': 'Content set as optional',
	'changelog_content_set_as_required': 'Content set as required',
	'changelog_published': 'Published',
	'changelog_not_published': 'Not published',
	'changelog_content_reordered': 'Reordered content',
	'changelog_owning_team': 'Owning team set to',
	'changelog_owner_added': 'Owner set to',
	'changelog_owner_removed': 'Owner removed',
	'changelog_content_added': 'Content added',
	'changelog_content_removed': 'Content removed',
	'changelog_tags_added': 'Tags added',
	'changelog_tags_removed': 'Tags removed',
	'changelog_topics_added': 'Topics added',
	'changelog_topics_removed': 'Topics removed',
	'changelog_audience_all': 'Audience set to everyone',
	'changelog_audience_teams': 'Audience set to teams',
	'changelog_audience_admins': 'Audience set to only admins',
	'changelog_audience_no_one': 'Audience set to no one',
	'changelog_mark_as_done_manual': 'Mark as done set to manual',
	'changelog_mark_as_done_automatic': 'Mark as done set to automatic',
	'changelog_custom_data_added': 'Custom data added',
	'changelog_allow_member_contributions_enabled': 'Content contributions set to allowed',
	'changelog_allow_member_contributions_disabled': 'Content contributions set to not allowed',
	'changelog_auto_share_with_all': 'Auto-shared with everyone',
	'changelog_auto_share_disabled': 'Auto-sharing disabled',
	'changelog_auto_share_teams': 'Auto-shared with selected teams',
	'changelog_unlock_date_and_time': 'Unlock date and time',
	'changelog_locking_mode_time': 'Section locked, will unlock at the specified time',
	'changelog_locking_mode_locked': 'Section locked',
	'changelog_locking_mode_unlocked': 'Section unlocked',
	'changelog_locking_mode_progress': 'Section locked, will unlock after completion of previous content',
	'changelog_auto_share_teams_added': 'Added auto-share team',
	'changelog_auto_share_teams_removed': 'Removed auto-share teams',
	'changelog_duplicated': 'Duplicated',
	'changelog_true': 'Set to true',
	'changelog_false': 'Set to false',
	'changelog_calendar_is_auto_join_enabled': 'Calendar auto-join enabled',
	'changelog_calendar_auto_join_settings': 'Updated calendar auto-join settings',
	'changelog_google_calendar_disconnected': 'Google calendar disconnected',
	'changelog_microsoft_calendar_disconnected': 'Microsoft calendar disconnected',
	'changelog_microsoft_calendar_reauthorised': 'Microsoft calendar reauthorised',
	'changelog_microsoft_calendar_connected': 'Microsoft calendar connected',
	'changelog_google_calendar_connected': 'Google calendar connected',
	'changelog_google_calendar_reauthorised': 'Google calendar reauthorised',
	'changelog_meetings_to_join': 'Meetings to join',
	'changelog_meetings_i_organise': 'Join only meetings I organise',
	'changelog_mindsmith_markdown_changed': 'Course contents updated in Mindsmith',
	'changelog_mindset_uid_added_to_team': 'Coach knowledge bank added',
	'changelog_created_event_session': 'Event session created',
	'changelog_deleted_event_session': 'Event session deleted',
	'changelog_updated_event_session': 'Event session updated',
	'changelog_event_session_details': 'Session details',
	'changelog_changed_event_session_details': 'Changed session details',
	'changelog_start_datetime': 'Start date and time',
	'changelog_end_datetime': 'End date and time',
	'mark_as_done_automatic_scorm_description': 'SCORM courses will be marked as done automatically based on the content’s own completion status',
	'mark_as_done_automatic': 'Automatic',
	'mark_as_done_manual': 'Manual',
	'optional_content_required': 'Required',
	'optional_content_optional': 'Optional',
	'optional_content_completion': 'Completion',
	'optional_content_hint_parent_playlist': 'This setting only applies within the current parent playlist "{{playlistName}}".',
	'optional_content_hint_circular_reference': 'This playlist must be optional to stop a circular reference from being created.',
	'optional_content_hint_circular_reference_multiselected': 'This selection contains a playlist which must be optional to stop a circular reference from being created.',
	'optional_content_hint_permission_inheritance': 'An optional playlist doesn’t inherit permissions from its parent playlist.',
	'optional_content_hint_parent_audience_all': 'Not everyone who can view the parent playlist can view this playlist.',
	'optional_content_hint_parent_audience_teams': 'People in the following team might not be able to view this playlist:',
	'optional_content_hint_parent_audience_teams_plural': 'People in the following teams might not be able to view this playlist:',
	'table_ascending': 'Ascending',
	'table_descending': 'Descending',
	'table_sort_by_column_ascending_order': 'Sort by {{columnTitle}} in ascending order',
	'table_sort_by_column_descending_order': 'Sort by {{columnTitle}} in descending order',
	'hint_markdown_field': 'This field can be formatted using Markdown. Click this icon to view the cheat sheet.',
	'hint_customisable_field': 'This field can be customised when configuring specific notifications',
	'hint_distribution_field': 'Distribute this playlist to other hubs',
	'hint_distribution_field_plural': 'Distribute these playlists to other hubs',
	'hint_autoshare_field': 'Automatically share with all members of the selected audience and anyone who joins it in the future.',
	'hint_remove_owning_team_asset': 'Managers of the previous owning team ({{teamNames}}) will no longer be able to edit this asset.',
	'hint_remove_owning_team_asset_plural': 'Managers of the previous owning teams ({{teamNames}}) will no longer be able to edit these assets.',
	'hint_remove_owning_team_playlist': 'Managers of the previous owning team ({{teamNames}}) will no longer be able to edit this playlist.',
	'hint_remove_owning_team_playlist_plural': 'Managers of the previous owning teams ({{teamNames}}) will no longer be able to edit these playlists.',
	'hint_used_in_playlist': 'Used in <2>1 playlist</2>',
	'hint_used_in_playlist_plural': 'Used in <2>{{count}} playlists</2>',
	'hint_distributed_from_hub_name': 'Distributed from <2>{{hubName}}</2>',
	'hint_teams_playlist_common': 'This team applies to all selected playlists',
	'hint_teams_playlist_common_plural': 'These teams apply to all selected playlists',
	'hint_teams_playlist_individual': 'This team applies to some, but not all selected playlists',
	'hint_teams_playlist_individual_plural': 'These teams apply to some, but not all selected playlists',
	'hint_teams_asset_common': 'This team applies to all selected assets',
	'hint_teams_asset_common_plural': 'These teams apply to all selected assets',
	'hint_teams_asset_individual': 'This team applies to some, but not all selected assets',
	'hint_teams_asset_individual_plural': 'These teams apply to some, but not all selected assets',
	'hint_hub_playlist_common': 'This hub applies to all selected playlists',
	'hint_hub_playlist_common_plural': 'These hubs apply for all selected playlists',
	'hint_hub_playlist_individual': 'This hub applies to some, but not all selected playlists',
	'hint_hub_playlist_individual_plural': 'These hubs apply to some, but not all selected playlists',
	'hint_member_contributions': 'Allow everyone in audience to add and edit their own assets',
	'hint_autoshare_disabled_by_admin_audience_plural': 'The auto-shares for one or more selected playlists will be disabled as the playlists will only be viewable by admins.',
	'hint_autoshare_disabled_by_admin_audience': 'The auto-share for this playlist will be disabled as the playlist is only viewable by admins.',
	'hint_autoshare_all_disabled_by_team_audience_plural': 'The auto-shares for one or more selected playlists will be disabled as the playlists are no longer shareable with everyone.',
	'hint_autoshare_all_disabled_by_team_audience': 'The auto-share for this playlist will be disabled as the playlist is no longer shareable with everyone.',
	'hint_autoshare_teams_disabled_by_team_audience_plural': 'The auto-shares for one or more selected playlists might be disabled by this change.',
	'hint_autoshare_teams_disabled_by_team_audience': 'The auto-share for this playlist will be disabled as the playlist is no longer shareable with all <2><strong>teams</strong></2> in the auto-share audience.',
	'hint_topics_playlist_common': 'This topic applies to all selected playlists',
	'hint_topics_playlist_common_plural': 'These topics apply to all selected playlists',
	'hint_topics_playlist_individual': 'This topic applies to some, but not all selected playlists',
	'hint_topics_playlist_individual_plural': 'These topics apply to some, but not all selected playlists',
	'hint_tags_common_playlist': 'This tag applies to all selected playlists',
	'hint_tags_common_playlist_plural': 'These tags apply to all selected playlists',
	'hint_tags_individual_playlist': 'This tag applies to some, but not all selected playlists',
	'hint_tags_individual_playlist_plural': 'These tags apply to some, but not all selected playlists',
	'hint_tags_common_asset': 'This tag applies to all selected assets',
	'hint_tags_common_asset_plural': 'These tags apply to all selected assets',
	'hint_tags_individual_asset': 'This tag applies to some, but not all selected assets',
	'hint_tags_individual_asset_plural': 'These tags apply to some, but not all selected assets',
	'hint_multi_editing_only_for_assets': 'Only assets editable by you can be multi-edited',
	'hint_multi_sharing_only_for_assets_or_playlists': 'Only assets or playlists can be multi-shared',
	'hint_content_shareable_link': 'Only users in the audience will be able to view the linked content',
	'hint_announcements_admins': 'Only admins can view platform announcements',
	'hint_exclude_from_ai_distributed_content': 'Exclude from AI set in parent hub',
	'hint_select_table_navigation': 'Use up and down arrow keys to navigate rows. Press Shift + Space to select or deselect rows.',
	'hint_multi_exclude_from_ai_distributed_content': 'Some of the selected assets can\'t be updated as they have been excluded from AI in their parent hub',
	'hint_event_session_joining_instructions': 'If set, this will overwrite the joining instructions set on the event',
	'hint_admin_use_only': 'Admin use only',
	'hint_session_cannot_be_deleted': 'This session contains members who are currently booked or marked as attended. Please cancel all member attendance records before attempting to delete this session.',
	'hint_admin_content_cannot_add_session_attendees': 'Session attendees cannot be added as this event asset has an admin only audience',
	'mindset_page_title': 'AI Coach',
	'mindset_cta': 'Ask AI Coach',
	'coach_ai_name': 'AI Coach',
	'coach_ai_teaser': 'Get answers faster with your AI Coach.',
	'coach_ai_teaser_with_name': 'Get answers faster with {{coachAiName}}, your AI Coach.',
	'coach_ai_ask': 'Ask {{coachAiName}}',
	'coach_ai_ask_about': 'Ask {{coachAiName}} about "{{searchInput}}"',
	'coach_ai_thread_title_search': 'Search: {{term}}',
	'coach_ai_thread_title_coaching': 'Coaching for: {{skillName}}',
	'coach_ai_thread_prompt_coaching': 'Coach me on {{skillName}} using the feedback I received.',
	'vee_create_title': 'VeeCreate',
	'playlists_none_selected_action': 'You can select a playlist or <1>add a new one</1>.',
	'playlists_none_selected': 'No playlist selected',
	'playlists_none_selected_info': 'Playlists allow you to curate content.',
	'playlists_empty_state': 'No playlists have been added yet.',
	'playlists_heading_selection_includes_deleted': '{{name}} (Deleted)',
	'playlists_heading_selection_includes_deleted_plural': '{{count}} playlists selected ({{deletedCount}} deleted)',
	'playlist_heading_visible_to_everyone': 'Visible to everyone',
	'playlist_heading_visible_to_team': 'Visible to 1 team',
	'playlist_heading_visible_to_team_plural': 'Visible to {{count}} teams',
	'playlist_heading_visible_to_admins_only': 'Visible to admins only',
	'playlist_heading_visible_to_everyone_link': 'Visible to <2>everyone</2>',
	'playlist_heading_visible_to_team_link': 'Visible to <2>1 team</2>',
	'playlist_heading_visible_to_team_link_plural': 'Visible to <2>{{count}} teams</2>',
	'playlist_heading_visible_to_admins_only_link': 'Visible to <2>admins only</2>',
	'playlist_next_steps_heading': 'Next steps',
	'playlist_next_steps_add_metadata': 'Add a cover image and other <1>recommended metadata</1>',
	'playlist_next_steps_add_content': '<0>Add content</0> to your playlist',
	'playlist_next_steps_add_audience': '<0>Give access</0> to others',
	'playlist_access_who_can_see_this_title': 'Who can see this?',
	'playlist_access_who_can_see_this_info': 'This playlist is set to required in <2>another playlist</2> and inherits its audience.',
	'playlist_access_who_can_see_this_info_plural': 'This playlist is set to required in <2>{{count}} other playlists</2> and inherits their audience.',
	'playlist_access_who_can_edit_this_title': 'Who can edit this?',
	'playlist_access_who_can_edit_this_general_info': 'Only admins with Playlist permissions can fully edit this playlist.',
	'playlist_access_who_can_edit_this_general_distributed_info': 'Only admins with Playlist permissions can edit this playlist.',
	'playlist_access_who_can_edit_this_distributed_info': 'This is a distributed playlist. Only select fields can be edited for the playlist.',
	'playlist_access_who_can_edit_this_teams_info': 'The <2>1 manager</2> of the owning team can edit this playlist\'s details and content.',
	'playlist_access_who_can_edit_this_teams_info_plural': 'The <2>{{count}} managers</2> of the owning team can edit this playlist\'s details and content.',
	'playlist_access_who_can_edit_this_teams_no_manager_info': 'Managers of the owning team will be able to edit this playlist\'s details and content.',
	'playlist_access_who_can_edit_this_members_info': 'Everyone in audience can add and edit their own assets.',
	'playlist_access_distribution_title': 'Distribution',
	'playlist_access_distribution_description': 'Make this playlist available to other hubs',
	'playlist_access_distribution_description_plural': 'Make these {{count}} playlists available to other hubs',
	'playlist_access_auto_sharing_title': 'Auto-sharing',
	'playlist_access_effective_audience_title': 'Effective audience',
	'playlist_access_audience_overview_title': 'Audience overview',
	'playlist_access_this_playlist': 'This playlist',
	'content_nudges_card_description': 'Schedule shares and remind users to open or complete this content',
	'content_nudges_card_empty_state_playlist': 'This playlist isn\'t used in any nudges yet',
	'content_nudges_card_empty_state_asset': 'This asset isn\'t used in any nudges yet',
	'content_info_last_updated_date': 'Last updated {{date}}',
	'content_info_created_date': 'Created on {{date}}',
	'content_info_created_by_author': 'Created by <1>{{author}}<1>',
	'content_info_created_by_author_link': 'Created by <2>{{author}}</2>',
	'content_info_created_by_you': 'Created by <1>you<1>',
	'content_info_created_by_you_link': 'Created by <2>you</2>',
	'content_status_editor_page_info': 'Set the completion status for the selected content and audience',
	'content_status_completion_info': 'The completion date will not be changed for people who have already completed this content',
	'content_status_share_panel_hint_email_template': 'This notification uses the <1><0>"{{emailTemplate}}"</0></1> email template.',
	'property_new_completion_status': 'New completion status',
	'content_review_people_list_title': 'Review people to set/reset completion status',
	'content_review_confirm_update_hint': 'You cannot undo this action',
	'content_review_people_list_total_info_not_started': 'The status of the selected content will be reset to "Not started" for 1 person.',
	'content_review_people_list_total_info_not_started_plural': 'The status of the selected content will be reset to "Not started" for {{count}} people.',
	'content_review_people_list_total_info_completed': 'The status of the selected content will be set to "Completed on {{date}}" for 1 person.',
	'content_review_people_list_total_info_completed_plural': 'The status of the selected content will be set to "Completed on {{date}}" for {{count}} people.',
	'content_status_reset_summary_not_started': 'The status of the selected content was reset to "Not started" for 1 person',
	'content_status_reset_summary_not_started_and_shared': 'The status of the selected content was reset to "Not started" for 1 person and the content was successfully shared',
	'content_status_reset_summary_completed': 'The status of the selected content was set to "Completed on {{date}}" for 1 person',
	'content_status_reset_summary_not_started_plural': 'The status of the selected content was reset to "Not started" for {{count}} people',
	'content_status_reset_summary_not_started_and_shared_plural': 'The status of the selected content was reset to "Not started" for {{count}} people and the content was successfully shared',
	'content_status_reset_summary_completed_plural': 'The status of the selected content was set to "Completed on {{date}}" for {{count}} people',
	'content_status_sharing_everyone': 'Sharing with everyone in audience - 1 person',
	'content_status_sharing_with_changed_status': 'Sharing with people whose status was changed - 1 person',
	'content_status_sharing_everyone_plural': 'Sharing with everyone in audience - {{count}} people',
	'content_status_sharing_with_changed_status_plural': 'Sharing with people whose status was changed - {{count}} people',
	'validate_start_with': 'Should start with {{value}}',
	'skills_empty_state': 'No skills have been added yet.',
	'skills_sets_empty_state': 'No skill sets have been added yet.',
	'skills_set_none_selected_action': 'You can select a set or <1>add a new one</1>.',
	'skills_set_none_selected': 'No set selected',
	'skills_set_none_selected_info': 'Evaluate people\'s skills by creating sets.',
	'skills_none_selected': 'No skill selected',
	'skills_none_selected_info': 'Evaluate people using skills.',
	'skills_system_name_info': 'System name: {{name}}',
	'skills_hint_skill_content_modified': 'Content was modified from base skill "{{name}}".',
	'skills_sets_audience_description': 'Determine who will be assessed against this skill set.',
	'skills_title_meetings_this_week': 'Meetings this week',
	'skills_title_recommended_content': 'Recommended content',
	'skills_title_recommended_content_for': 'Recommended content for "{{name}}"',
	'skills_title_skills_this_week': 'Skills this week',
	'skills_title_skills_this_meeting': 'Skills this meeting',
	'skills_title_skills_history': 'Skills history',
	'skills_title_overview': 'Overview',
	'skills_empty_state_data_processing': 'Data will be processed by the end of the week.',
	'skills_empty_state_you_have_no_tracked_meetings': 'You have not participated in any meetings with skills tracking yet.',
	'skills_empty_state_person_has_no_tracked_meetings': 'This person has not participated in any meetings with skills tracking yet.',
	'skills_organised_by': 'Organised by {{user}}',
	'skills_empty_state_skill_not_recorded_during_meeting': 'We did not record usage of this skill during this meeting.',
	'skills_empty_state_skill_not_recorded_this_week': 'We did not record usage of this skill in this week.',
	'skills_no_score': 'No score',
	'skills_status': 'Skills status',
	'skills_status_aria_label': 'Bar chart titled \'Skill status\' showing different skills and the percentage at which the selected users demonstrated each skill',
	'skills_heatmap': 'Skills heatmap',
	'skills_heatmap_users_aria_label': 'Heatmap titled \'Skills heatmap\' showing different skills and the intensity at which users demonstrated each skill',
	'skills_heatmap_teams_aria_label': 'Heatmap titled \'Skills heatmap\' showing different skills and the intensity at which teams demonstrated each skill',
	'skills_this_week_aria_label': 'Bar chart titled \'Skills this week\' showing different skills and the percentage at which the selected users demonstrated each skill during the selected week',
	'skills_this_meeting_aria_label': 'Bar chart titled \'Skills this meeting\' showing different skills and the percentage at which the selected users demonstrated each skill during the selected meeting',
	'skills_empty_welcome_title': 'Welcome to Helix',
	'skills_empty_get_started_title': 'Get started with your first meeting',
	'skills_empty_get_started_text_1': 'Record your first meeting to see your skills analysis right here.',
	'skills_empty_get_started_text_2': 'It couldn’t be easier – simply invite <1>helix@5app.com</1> to your next meeting and it will automatically start tracking your skills.',
	'skills_empty_get_started_text_3': 'You will see an attendee called Helix at the meeting. Helix will listen out for any skills you demonstrate throughout the meeting, and you’ll receive your analysis immediately after the meeting ends.',
	'skills_empty_how_helix_works_title': 'How does Helix work?',
	'skills_empty_how_helix_works_text_1': 'Helix will attend any meeting to which <1>helix@5app.com</1> is invited.',
	'skills_empty_how_helix_works_text_2': 'When your meeting starts, you will see an attendee called Helix. If it is in the waiting room, you will need to let Helix in to allow it to start analysing your meeting.',
	'skills_empty_how_helix_works_text_3': 'Once your meeting has finished, Helix will process the data and send you an email with a summary of the skills you displayed, including your strengths and development areas.',
	'skills_empty_how_helix_works_text_4': 'You will be able to return here at any time to see more details and suggestions for improving your skills.',
	'skills_empty_how_helix_works_text_5': 'Helix will also send you a weekly summary via email to show you how you’re improving over time.',
	'skills_empty_mind_changed_title': 'What if I change my mind and don’t want Helix to record my meeting?',
	'skills_empty_mind_changed_text_1': 'Not a problem!',
	'skills_empty_mind_changed_text_2': 'If it’s before your meeting, just remove Helix from the invitation.',
	'skills_empty_mind_changed_text_3': 'If your meeting has already started, either don’t let Helix into the meeting or remove it as a participant. The analysis will be performed against the part of the meeting which Helix attended.',
	'skills_empty_mind_changed_text_4': 'Helix won’t attend any meetings it’s not invited to, so you’re always in control of what it can and can’t record and analyse.',
	'skills_empty_invite_helix_title': 'Invite Helix to a meeting',
	'skills_empty_invite_helix_text_1': 'Ready to collect more data? Invite <1>helix@5app.com</1> to your next meeting to get started!',
	'skills_empty_invite_helix_text_2': 'You will see an attendee called Helix at the meeting. Helix will listen out for any skills you demonstrate throughout the meeting, and you’ll receive your analysis immediately after the meeting ends.',
	'skills_empty_invite_helix_text_3': 'You can invite Helix to any meeting you like, from team meetings to 1:1s to coaching events to brainstorming sessions. The more meetings Helix attends, the more accurate the data will be!',
	'skills_empty_auto_join_title': 'Have Helix auto-join your meetings',
	'skills_empty_auto_join_text_1': 'You already know which meetings you’d like Helix to attend? Simply connect your calendar and choose which meetings Helix should automatically join in the future.',
	'skills_empty_auto_join_text_2': 'No need to manually invite <1>helix@5app.com</1> to the meeting - Helix will join based on your preferences.',
	'skills_empty_auto_join_text_3': 'You can edit your meeting preferences or unlink your calendar at any time via your <1>Settings</1> page.',
	'skills_empty_auto_join_text_4': 'But of course, you can still also manually invite Helix to any meeting!',
	'skills_auto_join_title': 'Auto-joining meetings',
	'skills_auto_join_text_1': 'You already know which meetings you’d like Helix to attend? Via your <1>Settings</1> page you can connect your calendar and choose which meetings Helix should automatically join in the future.',
	'skills_auto_join_text_2': 'No need to manually invite <1>helix@5app.com</1> to the meeting - Helix will join based on your preferences.',
	'skills_auto_join_text_3': 'Of course, you can still also manually invite Helix to any meeting!',
	'skills_feedback_analysis_not_helpful': 'Analysis for skill "{{name}}" was not helpful',
	'skills_feedback_analysis_helpful': 'Analysis for skill "{{name}}" was helpful',
	'skills_feedback_placeholder_rating_positive': 'What was helpful or what could we do better? Help us to improve (optional)',
	'skills_feedback_placeholder_rating_negative': 'What didn’t help for you? Help us to improve (optional)',
	'skills_feedback_thanks': 'Thanks for your feedback!',
	'skills_feedback_what_was_helpful': 'What was helpful?',
	'skills_feedback_what_was_unhelpful': 'What was unhelpful?',
	'skills_feedback_was_analysis_helpful': 'Was this analysis helpful?',
	'skills_helix_not_linked_title': 'Helix not linked to this hub',
	'skills_helix_not_linked_text_1': 'Helix can only be linked to one hub that you are a member of, and at the moment you have it linked to <strong>{{helixHubName}}</strong> (<4>{{helixHubDomain}}</4>).',
	'skills_helix_not_linked_text_2': 'If you would like to use this hub for Helix then click the button below. This will only update future meetings and analysis, existing meetings and analysis will no longer be visible.',
	'skills_helix_not_linked_text_3': 'Using this hub for Helix will allow admins of this hub to view your analytics.',
	'skills_admin_helix_not_linked_title': 'User does not have Helix linked to this hub',
	'skills_admin_helix_not_linked_text_1': 'Helix can only be linked to one hub that each user is a member of, and this user doesn’t have it linked to this hub.',
	'skills_admin_helix_not_linked_text_2': 'The user is able to link it to this hub by logging in to Helix on this hub and clicking on the option to "Use this hub for Helix".',
	'auto_join_settings_title': 'Helix auto-join settings',
	'auto_join_settings_not_connected_text': 'Connect your Google or Microsoft calendar to enable Helix to auto-join meetings. You will be able to set rules to determine which meetings Helix will auto-join.',
	'auto_join_settings_not_connected_privacy': 'We will only use your calendar data to determine which meetings to auto-join based on the rules you set, as per our <1>privacy policy</1>.',
	'auto_join_settings_form_title': 'Auto-join calendar events',
	'auto_join_settings_form_meetings_title': 'Meetings to join',
	'auto_join_settings_form_meetings_all': 'All meetings',
	'auto_join_settings_form_meetings_only_internal': 'Only internal meetings',
	'auto_join_settings_form_meetings_only_external': 'Only external meetings',
	'auto_join_settings_form_meetings_only_organised_by_me': 'Only meetings I organise',
	'auto_join_settings_deauthorised_options_title': 'Options',
	'auto_join_settings_deauthorised_options_reauthorise': 'Re-authorise your calendar to resume Helix auto-join functionality',
	'auto_join_settings_deauthorised_options_disconnect': 'Disconnect your calendar if you no longer want auto-join functionality, in this case Helix will not auto-join any further meetings',
	'sessions_list_title': 'Sessions list',
	'sessions_list_empty_state': 'No sessions have been added yet from this start date.',
	'trial_welcome_get_started_title': 'Get started with Helix',
	'trial_welcome_intro': 'To receive your first skills analysis, invite Helix to a meeting.',
	'trial_welcome_option_1_title': 'Option 1: Invite Helix to one meeting',
	'trial_welcome_option_1_step_1': 'Open your meeting invite in your calendar.',
	'trial_welcome_option_1_step_2': 'Add <0>helix@5app.com</0> as an attendee.',
	'trial_welcome_option_1_step_3': 'Start your meeting as normal.',
	'trial_welcome_option_1_step_4': 'When Helix joins, admit it from the waiting room if needed.',
	'trial_welcome_option_1_step_5': 'After the meeting ends, Helix will send your skills analysis by email.',
	'trial_welcome_option_2_title': 'Option 2: Let Helix join selected meetings automatically',
	'trial_welcome_option_2_text_1': 'You can connect your calendar and choose which meetings Helix should join in future.',
	'trial_welcome_option_2_text_2': 'Helix will only join meetings based on your preferences. You can change these preferences or disconnect your calendar at any time in <0>Settings</0>.',
	'trial_welcome_meeting_title': 'What happens in the meeting?',
	'trial_welcome_meeting_text_1': 'When the meeting starts, you\'ll see an attendee called Helix.',
	'trial_welcome_meeting_text_2': 'For this trial, Helix will analyse examples of nine key leadership skills.',
	'trial_welcome_meeting_text_3': 'After the meeting, you\'ll receive an email with your skills analysis, including strengths, development areas and suggested next steps.',
	'trial_welcome_skills_title': 'What skills does Helix analyse?',
	'trial_welcome_skills_intro': 'For this trial, Helix analyses nine core leadership skills:',
	'trial_welcome_skill_accountability': 'Accountability',
	'trial_welcome_skill_coachability': 'Coachability',
	'trial_welcome_skill_growth_mindset': 'Growth Mindset',
	'trial_welcome_skill_communication': 'Communication',
	'trial_welcome_skill_active_listening': 'Active Listening',
	'trial_welcome_skill_coaching': 'Coaching',
	'trial_welcome_skill_strategic_vision': 'Strategic Vision',
	'trial_welcome_skill_change_management': 'Change Management',
	'trial_welcome_skill_results_focused': 'Results Focused',
	'trial_welcome_skills_outro': 'These are just the starting point for the trial. Helix can analyse many more skills and can be configured around your organisation\'s own competency and skills frameworks, leadership models or development priorities.',
	'trial_welcome_opt_out_title': 'What if I don\'t want Helix to analyse a meeting?',
	'trial_welcome_opt_out_intro': 'You\'re always in control.',
	'trial_welcome_opt_out_remove_email': 'Before the meeting, remove <0>helix@5app.com</0> from the calendar invite.',
	'trial_welcome_opt_out_started': 'If your meeting has already started, either don\'t let Helix into the meeting or remove Helix as a participant.',
	'trial_welcome_opt_out_assurance': 'Helix will not join any meeting unless it has been invited, and will not analyse any participant who is not a Helix user.',

};
